import * as Types from '../../../model/Sitecore.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_pageInfo_PageInfo = (
  { __typename?: 'PageInfo' }
  & Pick<Types.PageInfo, 'endCursor' | 'hasNext'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate_baseTemplates_ItemTemplate = (
  { __typename?: 'ItemTemplate' }
  & Pick<Types.ItemTemplate, 'id' | 'name'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate = (
  { __typename?: 'ItemTemplate' }
  & Pick<Types.ItemTemplate, 'id' | 'name'>
  & { baseTemplates: Types.Maybe<Array<Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate_baseTemplates_ItemTemplate>>> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ArticleCategory_name_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM = { __typename?: 'Accordion' | 'AccordionFolder' | 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' | 'AccordionItem' | 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' | 'AccordionParametersTemplate' | 'AccordionPresentation' | 'AccordionPresentationFolder' | 'Accordion_02d060598cc14423a9ac9ff2365176b7' | 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' | 'AddItem' | 'AddItem_1e1b739ec3784909941d171aca7362e5' | 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' | 'AddItem_de8c75222f3241288f20342f479894eb' | 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' | 'AddThisParameters' | 'AggregatedFacetFilter' | 'AlertMessage' | 'AlertMessageFolder' | 'AlertMessageParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_c9XozYxqaFC0frAPHPeq433LPynBF0XM1g0Uz5LICn8 = { __typename?: 'AlertMessageType' | 'AllertMessageTypeFolder' | 'Archive' | 'ArticleAuthor' | 'ArticleAuthorsFolder' | 'ArticleCategoriesFolder' | 'ArticleChapter' | 'ArticleChapters' | 'ArticleContentType' | 'ArticleContentTypesFolder' | 'ArticleFilter' | 'ArticleFilterOption' | 'ArticleFootnote' | 'ArticleFootnoteLink' | 'ArticleFootnoteText' | 'ArticleInfogramTile' | 'ArticleInfogramTileParametersTemplate' | 'ArticlePage' | 'ArticleRegion' | 'ArticleRegionsFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_9VPlmQkQdt9l4maQ46Z5fMhr5w16NSqTADFDI2lIY9Q = { __typename?: 'ArticleSearchPage' | 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' | 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' | 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' | 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' | 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' | 'ArticleSeriesCollection' | 'ArticleSeriesFolder' | 'ArticleSettings' | 'ArticleSubscriptionBanner' | 'ArticleSubscriptionBannerFolder' | 'ArticleTag' | 'ArticleTagsFolder' | 'ArticleTeamAuthor' | 'ArticleTileParametersTemplate' | 'ArticleTilesParametersTemplate' | 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' | 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' | 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' | 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_5Bp8CGD6gBt5zmgrKJRqS8sSurv5NB60wKLFzTr1j8 = { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' | 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' | 'ArticlesGroupFolder' | 'AttachThemeExtension' | 'AutomaticDocumentListings' | 'AutomaticDocumentListingsFolder' | 'AvailableJSONRenderings' | 'AvailableMetaRenderings' | 'AvailableRenderings' | 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' | 'AwardsBanner' | 'AwardsBannerFolder' | 'AwardsBannerImage' | 'AwardsBannerParametersTemplate' | 'BYOCWrapperRenderingParameters' | 'BackgroundColorOption' | 'BackgroundColorOptionFolder' | 'BannerFolder' | 'BannerType' | 'BannerTypeFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_vgM8szlOwwreWnyZ96extC1BJblr1vJelIcjuF6Tw = { __typename?: 'BaseHeading' | 'BaseHeadingFolder' | 'BoolFacet' | 'BranchesFolder' | 'Breadcrumb' | 'BrowserTitleDefinition' | 'CORSEntry' | 'CORSGrouping' | 'CTAPresentationType' | 'CTAPresentationTypeFolder' | 'C__AbrdnPage' | 'C__ActionBase' | 'C__AdvancedParameter' | 'C__App' | 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' | 'C__ArticleWildcardPage' | 'C__AvailableRenderingsFolder' | 'C__BYOCRenderingParameters' | 'C__BackgroundParametersTemplate' | 'C__BaseCTA' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_shlDQDRBXfEV2IMt8Q7OnzROWrVF0nQMSI8rkrSZU = { __typename?: 'C__BasePage' | 'C__BasePage_037da552a5524fe4aeee331f57ac1378' | 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' | 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' | 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' | 'C__BasePage_728c97b5c56146d9807e21018a972bb5' | 'C__BasePage_6105875085f346729dfc8d133b481f26' | 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' | 'C__BaseRenderingParameters' | 'C__BaseTheme' | 'C__BaseVariantField' | 'C__Class' | 'C__CompositeGroup' | 'C__CompositeSection' | 'C__EloquaForm' | 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' | 'C__ExtendedOptions' | 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' | 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' | 'C__FEaaSRenderingParameters' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_0SYpviiyXX3BRforwncXG3pexVXYcIm4fmQoeSPcK4 = { __typename?: 'C__FacetSelectorConfigBase' | 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' | 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' | 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' | 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' | 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' | 'C__GlobalDatasourceBehavior' | 'C__GridDefinition' | 'C__GridItemBase' | 'C__GridParameters' | 'C__HeadlessSite' | 'C__HeadlessTenant' | 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' | 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' | 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' | 'C__IAllowEmpty' | 'C__IBaseVariantDefinition' | 'C__IBoosting' | 'C__ICacheable' | 'C__ICompatibleRenderings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_JuL8MVaWzToSlJIakCO1bigqoAcm1EGyklGo3wRrRLw = { __typename?: 'C__IComponentVariant' | 'C__IControlType' | 'C__IDynamicPlaceholder' | 'C__IFEaaSComponentsDataSourceTemplates' | 'C__IFEaaSComponentsEditorScriptURL' | 'C__IIcon' | 'C__ILocation' | 'C__IPaginable' | 'C__IPagination' | 'C__IPoi' | 'C__IRenderingId' | 'C__ISplitter' | 'C__IStyling' | 'C__IVariantDefinition' | 'C__InvestmentTrustPage' | 'C__JSONField' | 'C__JSONReference' | 'C__JSSData' | 'C__JSSSettings' | 'C__JSSSiteFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_aqw7j7oAQM5GJ9oIWaOAyiGli5atrgfmQJoQe8rDt4 = { __typename?: 'C__JssRootFolder' | 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' | 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' | 'C__Page' | 'C__PageData' | 'C__PageDesignFolder' | 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' | 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' | 'C__PartialDesign' | 'C__PartialDesignFolder' | 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' | 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' | 'C__PlaceholderWrapper' | 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' | 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' | 'C__RedirectMapGrouping' | 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' | 'C__Route' | 'C__SimpleVideo' | 'C__SiteSettingsFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_jWiNNE8wAezwjVLEWn3IRc7x4WY9EKiEuZpBROPG4 = { __typename?: 'C__SitemapSettings' | 'C__StandardTemplate' | 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' | 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' | 'C__TrustFolder' | 'C__VariantDefinition' | 'C__VariantField' | 'C__VariantsGrouping' | 'C___AdvancedItem' | 'C___Arguments' | 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' | 'C___Article' | 'C___ArticlePageWorkflow' | 'C___ArticleSearchPage' | 'C___ArticleWildcard' | 'C___AssetServiceThemeMode' | 'C___BaseArticle' | 'C___BaseDataFolder' | 'C___BaseHelpArticle' | 'C___BaseInvestmentTrust' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BfCZy14f5vCYoKPvUvlJVRkotuL1gmUwjkgrggQ05A = { __typename?: 'C___BaseJSSTenant' | 'C___BasePage' | 'C___BasePageDesign' | 'C___BasePageDesignFolder' | 'C___BasePartialDesign' | 'C___BasePartialDesignFolder' | 'C___BasePlaceholder' | 'C___BasePlaceholderSettingsFolder' | 'C___BasePresentation' | 'C___BasePressRelease' | 'C___BaseRenderingParameters' | 'C___BaseSXAStandardValuesFolder' | 'C___BaseSettings' | 'C___BaseSharedSitesSettings' | 'C___BaseSiteDefinition' | 'C___BaseSiteFolder' | 'C___BaseSiteGrouping' | 'C___BaseSiteRoot' | 'C___BaseTenant' | 'C___BaseTenantFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_PHLgvBFZABTRngNRTYYUi9KBdwe9p7W4YDlCj72fOIs = { __typename?: 'C___BucketRules' | 'C___CORS' | 'C___Content' | 'C___ContentType' | 'C___DataAttributes' | 'C___DatasourceWorkflow' | 'C___Dependencies' | 'C___Description' | 'C___DesignTemplateMapping' | 'C___Designable' | 'C___EditType' | 'C___EditType_8a9f84baaa124c5d9096935714809da4' | 'C___EditingTheme' | 'C___Enabled' | 'C___ErrorHandling' | 'C___ExternalArticle' | 'C___Fields' | 'C___FilteredArticlesParent' | 'C___FilteredArticlesWildcard' | 'C___Footnotes' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_KL7bf4QPLQ7mpyzzvQk5f6piwJk1PES0rcP7Uy9x0M = { __typename?: 'C___FundDetailsWildcard' | 'C___FundFormAvailability' | 'C___FundMetadataPage' | 'C___FundSearchPage' | 'C___FundsFolder' | 'C___FundsFormsFolder' | 'C___FundsLiteratureFolder' | 'C___FundsShareclassesDetailsWildcard' | 'C___GridMapping' | 'C___HelpArticle' | 'C___HelpArticleSearchPage' | 'C___HelpArticleWildcard' | 'C___HorizonDatasourceGrouping' | 'C___Icon' | 'C___IncludeByDefault' | 'C___IncludeIfInstalled' | 'C___InternalArticle' | 'C___InternetExplorerCompatibilityMode' | 'C___IsSystemModule' | 'C___JSONVariantPaging' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_iqnu4DMOAGlC9sVDpDbjHWwyB7ysXrKwlOhFHAyC0 = { __typename?: 'C___JSONVariantsBase' | 'C___LimitedDisplay' | 'C___LinkAttributes' | 'C___LinkSettings' | 'C___LiteratureHubSearchPage' | 'C___ManualKeyInformation' | 'C___MemberOf' | 'C___MetadataPage' | 'C___Modules' | 'C___Name' | 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' | 'C___Name_299cdb154745448a807868d401248eaa' | 'C___Name_b88cf88159a54a19991e71038751cb60' | 'C___Navigable' | 'C___NavigablePage' | 'C___PageContent' | 'C___PageWorkflow' | 'C___PerSiteStandardValues' | 'C___Podcast' | 'C___PodcastPressRelease' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_umgzCXtgi1WMowaNMDJnNsdrdDP4Ie7qfWy2owTqtI = { __typename?: 'C___PremiumContentPage' | 'C___PressRelease' | 'C___PressReleaseContentType' | 'C___PressReleaseSearchPage' | 'C___PressReleaseWildcard' | 'C___ProtectedTheme' | 'C___PublishingGroupingTemplate' | 'C___RenderingRelatedParameters' | 'C___RenderingVariantsBase' | 'C___RenderingsList' | 'C___RobotsContent' | 'C___RoleDomain' | 'C___RoleName' | 'C___RoleType' | 'C___SalesforceCommonValidations' | 'C___SalesforceFieldId' | 'C___SalesforceFieldTitle' | 'C___SalesforceFieldValue' | 'C___Script' | 'C___SearchSignature' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_c8gc72G7Xyo5xvM63VPyvhGmiUxe0BFuVTVAj9su0 = { __typename?: 'C___Searchable' | 'C___SecurityItemPointer' | 'C___SharedArticles' | 'C___SharedContent' | 'C___SharedHelpArticles' | 'C___SharedPage' | 'C___SharedPressReleases' | 'C___SharedRoot' | 'C___SharedSettings' | 'C___SiteContent' | 'C___SiteFolder' | 'C___SiteMediaLibrary' | 'C___SiteSettings' | 'C___SiteTemplate' | 'C___SitecoreClientSiteManaging' | 'C___Sitemap' | 'C___SitemapMediaItems' | 'C___SlidersRangeSettings' | 'C___SolutionTemplateContent' | 'C___SolutionTemplateDescription' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_VtfJ6wYpLDTemXJEIB7XJw2duFCBCMgGB8vlYx6hsc0 = { __typename?: 'C___SolutionTemplateName' | 'C___SortOrder' | 'C___StackBreakpoint' | 'C___Statistics' | 'C___SupportedLanguages' | 'C___Taggable' | 'C___TeamMembersParentPage' | 'C___TeamMembersWildcard' | 'C___TechzoneArticle' | 'C___Template' | 'C___Title' | 'C___Type' | 'C___Validation' | 'C___VariantPaging' | 'C___VectorTile' | 'C___VectorTileLink' | 'C___Video' | 'C___VideoPressRelease' | 'C___Width' | 'C___WildcardPage' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_1BpmAGsjLrkU4cexVLSJ4OyM81tByZRfH3Rlj3t6CE = { __typename?: 'CacheSetting' | 'Caching_26fce9bf0256458d8281a713a5bf5520' | 'CalendarEvent' | 'CallOutSection' | 'CallOutSectionDropdownOption' | 'CallOutSectionFolder' | 'CallOutSectionParametersTemplate' | 'CallToAction' | 'CallToActionFolder' | 'CapabilitiesFolder' | 'Capability' | 'CapabilityMap' | 'CapabilityMappings' | 'Carousel' | 'CarouselFolder' | 'CarouselSlide' | 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' | 'Checkbox' | 'ChecklistFilter' | 'ChecklistFilterFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_NyEECiwuus0IEb5R3ZHyvXsBaUAVp6zWfQGtLdoaAU = { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' | 'ColumnSplitter' | 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' | 'CompatibilityMode' | 'ComponentConfiguration' | 'ComponentThemeConfiguration' | 'ComponentThemesConfiguration' | 'ComponentsConfigurations' | 'ConfigurationFolder' | 'Container' | 'ContainerOption' | 'ContainerOptionsFolder' | 'ContainerParametersTemplate' | 'Container_45130bdbbae34edcaea87b68b9d94c7f' | 'ContentBlock' | 'ContentBlockFolder' | 'ContentToken' | 'ContentTokenFolder' | 'ContentType' | 'CorporateTheme' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_Fj4L99iVJxbVnFn7srvABth7WlFSHNzZENorwzE = { __typename?: 'CorporateThemesFolder' | 'Country' | 'CountryISOCode' | 'CountryISOCodesFolder' | 'CustomerReviewFolder' | 'CustomerReviewTile' | 'CustomerReviewTileParametersTemplate' | 'DataBridgeDocumentCategoryMap' | 'DataBridgeFund' | 'DataBridgeFundRangeName' | 'DataBridgeSettingsFolder' | 'DataBridgeShareClass' | 'DataFolder' | 'DatasourceConfiguration' | 'DatasourceConfigurations' | 'DatasourceWorkflowAction' | 'DateFacet' | 'DateFilter' | 'DateFilterFolder' | 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ANdBVC6KFTlUcJhSibUfyWTFtLta5lsMUp9qlxcVurI = { __typename?: 'DefaultColumnLayout' | 'DefaultShareclassMapping' | 'DefaultShareclassMappings' | 'DescriptiveHighlight' | 'DescriptiveHighlightFolder' | 'DescriptiveHighlightItem' | 'DescriptiveHighlightParametersTemplate' | 'Device' | 'Device_7c27ec70f42e40428a0fabaa2f8eda18' | 'Devices' | 'DictionaryFolder' | 'DisqusParameters' | 'DistanceFacet' | 'Divider' | 'DocumentItem' | 'DocumentListings' | 'DocumentListingsFolder' | 'DocumentTypeFolder' | 'DominantLanguageMapping' | 'Dropdown' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_xbvRLMKOfZhwK7StDx4pk8GufekPnO6TlKVuKDWc0 = { __typename?: 'DropdownFilter' | 'DropdownFilterFolder' | 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' | 'EditEditingTheme' | 'EditFrame' | 'EditModePanel' | 'EditSiteItem' | 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' | 'EditSiteTheme' | 'EditTenantTemplate' | 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' | 'EditType' | 'EloquaFormFolder' | 'EloquaFundForm' | 'Enum' | 'Enums' | 'ErrorPage' | 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' | 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' | 'ErrorPage_45d797cc048740ffb693214883ff35c2' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_C7jD2H7yOuHKbYSq1WvlnNO2zZ9k33Tt60j7wVs4 = { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' | 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' | 'EventCalendarParameters' | 'EventList' | 'EventListParameters' | 'EventTypes' | 'EventsFolder' | 'ExecuteScript' | 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' | 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' | 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' | 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' | 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' | 'ExtendSiteTheme' | 'ExternalLiterature' | 'FEaaSWrapperRenderingParameters' | 'FacebookCommentsParametersTemplate' | 'FacetSlider' | 'FacetSliderFolder' | 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_6hn5PudNLAFVxgpoCeIRzlxkBlB8a1pSQwG8cmE = { __typename?: 'FacetSummary' | 'FacetSummaryFolder' | 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' | 'FacetsGrouping' | 'FakeNavigationItem' | 'FeatureBanner' | 'FeatureBannerParametersTemplate' | 'FeaturedArticles' | 'FeaturedArticlesFolder' | 'FeaturedTheme' | 'FeaturedThemesFolder' | 'Feed' | 'FeedFolder' | 'FeedParameters' | 'FieldEditor' | 'FieldRenderer' | 'FileList' | 'FileListFolder' | 'FileListParametersTemplate' | 'File_04129321770849c1801baee196e1c0a8' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_u7BRZVBhheosXLCSBWQJBOivuyXVuOOaFBBIAa5UQdc = { __typename?: 'FilterCriteria' | 'FilterCriteriaFolder' | 'FilterTaxonomyOption' | 'FilterTaxonomyOptions' | 'FilteredArticlesParentPage' | 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' | 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' | 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' | 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' | 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' | 'FilteredArticlesWildcardPage' | 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' | 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' | 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' | 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' | 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' | 'Flip' | 'FlipFolder' | 'Flip_5ef078504c044b839dafefd752cfaba8' | 'Flipside' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_dpqtGMeZVSGVIy9q5ldacew1cWo2gELfnm77xVZDIg = { __typename?: 'FloatFacet' | 'Footer' | 'FooterFolder' | 'FooterLink' | 'FormRenderingParameters' | 'FundAssetClass' | 'FundAssetClassesFolder' | 'FundDetailsWildcardPage' | 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' | 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' | 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' | 'FundFormsFolder' | 'FundInFocus' | 'FundInFocusShareClass' | 'FundSearchPage' | 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' | 'FundSearchPage_5806f83c03bc443380678ff955f4310f' | 'FundSearchPage_7432205c04214a419ca064c4cb37501c' | 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' | 'FundSettings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_lalHkBPxpftIF8HuYXqfDXnzifCeKVwttYezsBbL6A = { __typename?: 'FundShareclassDetailsWildcardPage' | 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' | 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' | 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' | 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' | 'FundSubAssetClass' | 'FundSubAssetClassesFolder' | 'FundsExternalLiteratureFolder' | 'FundsFolder' | 'FundsInFocusFolder' | 'FundsInFocusParametersTemplate' | 'FundsLiteratureFolder' | 'FundsLiteratureMappingsFolder' | 'Gallery' | 'GalleryFolder' | 'GalleryImage' | 'GalleryParametersTemplate' | 'GalleryVideo' | 'GatedAccordionContainer' | 'GlobalLanguageSelector' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_Q9MXc9RjR2M267DgK6zxTNUiUi6NIPijp0dZLLIgk = { __typename?: 'GlobalNavigationBar' | 'GoogleAnalytics' | 'GoogleTagManager' | 'GoogleTagManagerFolder' | 'GridSetup' | 'GridTheme' | 'HTMLCode' | 'HTMLCodeFolder' | 'HTMLInclude' | 'HTMLIncludesFolder' | 'HTMLSnippet' | 'HTMLSnippetFolder' | 'HTMLTag' | 'Header' | 'HeaderFolder' | 'Heading' | 'HeadlessSiteSetupRoot' | 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' | 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' | 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_dMUje5zuPQ5cTfsHsP483FXiZjLZOp5y7mQEffnH1xw = { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' | 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' | 'HeadlessSite_229484893ca144958b9937167dfb5064' | 'HeadlessSite_b28055626acc45a2913a9617398c9730' | 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' | 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' | 'HeadlessSolutionTemplateFolder' | 'HeadlessTenantSetupRoot' | 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' | 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' | 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' | 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' | 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' | 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' | 'HeadlessTenant_94824ac390d748499e5af0275d10811f' | 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' | 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' | 'HeadlessTrustSite' | 'HeadlessVariants' | 'HeadlessVariantsGrouping' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_hb7aIiGiWMscK3W1w04Vy90EkNWrFzDyfbrTjKcNK2s = { __typename?: 'HelpArticlePage' | 'HelpArticlePlatform' | 'HelpArticlePlatformMap' | 'HelpArticlePlatformMappings' | 'HelpArticlePlatformsFolder' | 'HelpArticleSearchPage' | 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' | 'HelpArticleTag' | 'HelpArticleTagsFolder' | 'HelpArticleWildcardPage' | 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' | 'HelpArticlesGroupFolder' | 'HelpTagMap' | 'HelpTagMappings' | 'HeroBanner' | 'Highlight' | 'HighlightBlock' | 'HighlightBlockFolder' | 'HighlightBlockParametersTemplate' | 'HighlightFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_mlJlKCHse9oAGb81rXrwxNMBDoalRluBpSZ2wf1jcU = { __typename?: 'HighlightItem' | 'HighlightParametersTemplate' | 'Home' | 'HomePage' | 'HomePage_0d3963a8171d4080b5f808618578b631' | 'HomePage_6d95c7d946c74a70be07304cc73a2010' | 'HomePage_b407f259b4e34c7db9a06e8907a56b17' | 'HomePage_cde13c51062d426b95569e8202edc963' | 'HomePage_de9353283a3e41c495ba386aed0540c6' | 'IFrame' | 'IFrameFolder' | 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' | 'IFrameParametersTemplate' | 'IFrame_0da12d476de24dfeb4d0f513489bfea1' | 'IFrame_88a6f65f2b78491bb3770b06e48883e1' | 'Icon' | 'IconFolder' | 'Image' | 'ImageFolder' | 'ImageFolder_edc00e86cef24d0cbfa264460becc323' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_bpyH1qQmSBBKUyiskmVf3nBxPfFJ3ja7QnVcUd6KZro = { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' | 'ImageParametersTemplate' | 'Image_83bc563c6320490092f8204bff81586a' | 'Image_15185b0e641844499f934ff03b7ee032' | 'Image_d885df8cb2d64007b34b2bbafb527304' | 'Infographics' | 'InfographicsFolder' | 'InputValidationStep' | 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' | 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' | 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' | 'IntegerFacet' | 'IntroCopy' | 'IntroCopyFolder' | 'InvestmentTrustAssetClass' | 'InvestmentTrustAssetClassFolder' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' | 'InvestmentTrustRegion' | 'InvestmentTrustRegionFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg = { __typename?: 'InvestmentTrustStyle' | 'InvestmentTrustStyleFolder' | 'InvestorType' | 'InvestorTypesFolder' | 'ItemQueriesFolder' | 'ItemRights' | 'JSBeaconSettings' | 'JSONCheckbox' | 'JSONContent' | 'JSONDate' | 'JSONFile' | 'JSONImage' | 'JSONLayout' | 'JSONList' | 'JSONMultilistReference' | 'JSONPlaceholder' | 'JSONQuery' | 'JSONResults' | 'JSONRichText' | 'JSONScriban' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY = { __typename?: 'JSONSection' | 'JSONTemplate' | 'JSONText' | 'JSONToken' | 'JSONVariantDefinition' | 'JSONVariants' | 'JSSLayout' | 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' | 'JSSSettings_6b328292f8314ab79885d89a054ca10a' | 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' | 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' | 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' | 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' | 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' | 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' | 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' | 'JSSSiteGrouping' | 'JSSTenantFolder' | 'JavaScriptRendering' | 'JsonRendering' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q = { __typename?: 'JurisdictionStatus' | 'JurisdictionsFolder' | 'KeyHighlightItem' | 'KeyHighlights' | 'KeyHighlightsFolder' | 'KeyHighlightsParametersTemplate' | 'Language' | 'LanguageSelector' | 'LanguagesFolder' | 'LatestPressReleasesParametersTemplate' | 'LayoutServiceVariants' | 'LimitedDisplayFolder' | 'LimitedDisplayOption' | 'Link' | 'LinkList' | 'LinkListFolder' | 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' | 'LinkList_33c9207e3b0446068ef54ca99a97c776' | 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' | 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA = { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' | 'Link_930f134d56784b35bfd1b77f9d0115f1' | 'Link_e24e0789a05848bfabb6c69c0e60b6b7' | 'LinksFolder' | 'List' | 'ListFacet' | 'ListFolder' | 'ListItem' | 'ListParametersTemplate' | 'ListStyle' | 'ListStyleItem' | 'ListingHeroBanner' | 'ListingHeroParametersTemplate' | 'LiteratureAuthorization' | 'LiteratureAuthorizationsFolder' | 'LiteratureHubSearchPage' | 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' | 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' | 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' | 'LoadMore' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM = { __typename?: 'LoadMoreFolder' | 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' | 'LocationFilter' | 'LocationFilterFolder' | 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' | 'Log' | 'Login' | 'Login_abed54dc4f7840ddac562289c9c849d8' | 'LogoTextBlockItem' | 'LogoTextBlocks' | 'LogoTextBlocksFolder' | 'Logout' | 'Logout_c2294d8235a6452a94b15eb5e543b602' | 'ManagedRangeFilter' | 'ManagedRangeFilterFolder' | 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' | 'ManagedRangeItem' | 'Map' | 'MapParameters' | 'MapsFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 = { __typename?: 'MapsProvider' | 'MediaBlock' | 'MediaBlockFolder' | 'MediaBlockParametersTemplate' | 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' | 'MediaLinkParameters' | 'MediaVirtualFolder' | 'MegaNavigation' | 'MegaNavigationFolder' | 'MetaBranding' | 'MetaRenderingParameters' | 'MetadataPartialDesign' | 'Model' | 'ModelIterator' | 'MyLocationPOI' | 'Navigation' | 'NavigationCategory' | 'NavigationFilter' | 'NavigationFilterFolder' | 'NavigationLink' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs = { __typename?: 'NavigationSubcategory' | 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' | 'OneTrustSettings' | 'OptimiserConfiguration' | 'OptimiserConfigurationSection' | 'OptimizedFile' | 'OracleCDPSettings' | 'OverlayContent' | 'OverlayFolderTemplate' | 'Ownership' | 'OwnershipFolder' | 'POI' | 'POIFolder' | 'POIType' | 'POIs' | 'PageBranchesFolder' | 'PageContent' | 'PageContentFolder' | 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' | 'PageDesign' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M = { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' | 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' | 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' | 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' | 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' | 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' | 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' | 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' | 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' | 'PageDesign_1105b8f81e00426bbf1fc840742d827b' | 'PageDesigns' | 'PageDesigns_3af52e70e982424b9c85e355542500c9' | 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' | 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' | 'PageDesigns_99a71bba507746729c3fb29b04abee23' | 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' | 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' | 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' | 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' | 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY = { __typename?: 'PageLevelTabs' | 'PageLevelTabsFolder' | 'PageList' | 'PageSelector' | 'PageSelectorConfiguration' | 'PageSelectorFolder' | 'PageSelector_59a7bb775f8c435ab810291abde80e63' | 'PageSize' | 'PageSizeFolder' | 'PageSize_b682562e0af64b3e9e3b45273bbe152d' | 'PageTheme' | 'PageThemesFolder' | 'Page_4f49a81db3664f198b89cab92f377d7a' | 'Page_5e66d86353544fe6a27d3b894984d50f' | 'Page_84f342ad2d0646b9aa9a818201145ca2' | 'Page_718df200be51463d93edf4d77ab7a49e' | 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' | 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' | 'Page_dae7821153e14dbabb0ddf0b53a90aaf' | 'Page_fa608b3e6aeb426388a059d89caabada' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc = { __typename?: 'Pagging' | 'Pagination' | 'PaginationFolder' | 'Paragraph' | 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' | 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' | 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' | 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' | 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' | 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' | 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' | 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' | 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' | 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' | 'PartialDesigns' | 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' | 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' | 'PartialDesigns_36c869ded22040929ce829f6ed643c66' | 'PartialDesigns_1943dc73710a430895515a342c84b037' | 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es = { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' | 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' | 'PartialDesigns_d216303f58d8425688da8cd30d00afab' | 'PartialDesigns_facda26791204fa9a0363344348f2c42' | 'PerformanceChartSettings' | 'PerformanceChartTimePeriod' | 'PerformanceChartTimePeriodFolder' | 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' | 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' | 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' | 'Placeholder_1ca0304be5b64810821154426f1752c2' | 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' | 'PlainHtmlParametersTemplate' | 'Playlist' | 'PlaylistFolder' | 'PlaylistParametersTemplate' | 'Podcast' | 'PodcastFolder' | 'PodcastPage' | 'PodcastPressReleasePage' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM = { __typename?: 'PoiTypes' | 'PostDeleteStep' | 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' | 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' | 'PostDeleteStep_b20857895385413883f096f3767cb156' | 'PostSetupStep' | 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' | 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' | 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' | 'PreDeleteStep' | 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' | 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' | 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' | 'PreDeleteValidationStep' | 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' | 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' | 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' | 'Presentation' | 'Presentation_0a70fa7389234a6eabf34134f25f3221' | 'PressReleaseContentType' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk = { __typename?: 'PressReleaseContentTypesFolder' | 'PressReleaseFilter' | 'PressReleasePage' | 'PressReleasePlatform' | 'PressReleasePlatformsFolder' | 'PressReleaseSearchPage' | 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' | 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' | 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' | 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' | 'PressReleaseWildcardPage' | 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' | 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' | 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' | 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' | 'PressReleasesGroupFolder' | 'PrivacyWarning' | 'ProjectFolder' | 'Promo' | 'PromoFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU = { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' | 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' | 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' | 'Promo_dfed4457d760457abec1c0dccdc44381' | 'PromotedContent' | 'PromotedContentFolder' | 'PropertyListingCard' | 'PropertyListingCards' | 'PropertyListingCategory' | 'PropertyListingFolder' | 'Query_98b413525a4b4067b92418a4b50f0a53' | 'QuickLinks' | 'QuickLinksFolder' | 'QuickLinksParametersTemplate' | 'QuotationBlockItem' | 'QuotationBlocks' | 'QuotationBlocksFolder' | 'QuotationBlocksParametersTemplate' | 'Quote' | 'QuoteFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 = { __typename?: 'QuoteParametersTemplate' | 'RadiusFilter' | 'RadiusFilterFolder' | 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' | 'RadiusScheme' | 'RadiusSchemeValue' | 'RangeSliderFilter' | 'RangeSliderFilterFolder' | 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' | 'RecentArticles' | 'Redirect' | 'RedirectMap' | 'RedirectMaps' | 'Region' | 'RegionLanguages' | 'RegionLanguagesFolder' | 'RelatedArticles' | 'RelatedArticlesParametersTemplate' | 'RenderEngineType' | 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg = { __typename?: 'RenderingHost' | 'ResizableIFramePage' | 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' | 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' | 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' | 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' | 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' | 'ResponsiveImage' | 'ResultsCount' | 'ResultsCountFolder' | 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' | 'ResultsVariantSelector' | 'RichText' | 'RichTextFolder' | 'RichText_0f3b73366112418c8bbab0526f3887ce' | 'RichText_efcfd8f6596745f48f85b5421928205d' | 'RiskImageMapping' | 'RiskImageMappings' | 'RiskLevelOption' | 'RiskLevelOptionFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc = { __typename?: 'RiskWarning' | 'RiskWarningFolder' | 'RiskWarningParametersTemplate' | 'RolePlaceholder' | 'RowSplitter' | 'RowSplitter_340c887da1d1415b9678c763af74ea97' | 'Rule' | 'SDRLogoMapping' | 'SDRLogoMappings' | 'SDRTypeOption' | 'SDRTypeOptionFolder' | 'SXAJSSLayout' | 'SXARole' | 'SXAStandardValuesFolder' | 'SalesforceAlertMessage' | 'SalesforceCheckBox' | 'SalesforceCheckBoxType' | 'SalesforceConditionalRadioButton' | 'SalesforceConditionalRadioButtons' | 'SalesforceDateInput' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM = { __typename?: 'SalesforceDropdown' | 'SalesforceDropdownOption' | 'SalesforceHiddenField' | 'SalesforceInput' | 'SalesforceInputType' | 'SalesforceIntegratedForm' | 'SalesforceIntegratedFormTypesFolder' | 'SalesforceRepeatableSubSection' | 'SalesforceRichTextArea' | 'SalesforceSection' | 'SalesforceSortCodeInput' | 'SalesforceSubmissionType' | 'Scope' | 'ScopesFolder' | 'Scriban' | 'Scripts' | 'SearchBox' | 'SearchBoxFolder' | 'SearchBox_1c04fd611d874590acfe9cc186865ab3' | 'SearchFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo = { __typename?: 'SearchResults' | 'SearchResultsFolder' | 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' | 'SecondaryHeroBannerParametersTemplate' | 'SectionHeading' | 'SectionHeadingFolder' | 'SectionHeadingParametersTemplate' | 'SectionHeadingType' | 'SectionHeadingTypeFolder' | 'SectionSelector' | 'SectionSelectorFolder' | 'SectionSelectorTab' | 'Security_33077d51ebad4d1cb4a83b79f51dba13' | 'Series' | 'SeriesFolder' | 'Settings' | 'SettingsFolder' | 'Settings_6c82caca67dc464195698faad083230e' | 'SharePriceSettings' | 'SharedArticlesFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs = { __typename?: 'SharedContentFolder' | 'SharedFolder' | 'SharedHelpArticlesFolder' | 'SharedPressReleasesFolder' | 'SharedSettingsFolder' | 'SharedSitesSettings' | 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' | 'Showcase' | 'ShowcaseFolder' | 'ShowcaseItem' | 'ShowcaseParametersTemplate' | 'Site' | 'SiteContentFolder' | 'SiteDefinition' | 'SiteEntryDisclaimer' | 'SiteFolder' | 'SiteGrouping' | 'SiteManagement' | 'SiteSecurityItemPointer' | 'SiteSelector' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo = { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' | 'SiteSetupRoot' | 'SiteTheme' | 'Site_e46f3af239fa4866a1577017c4b2a40c' | 'SitecoreFormWrapperParametersTemplate' | 'SitecoreRole' | 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' | 'SkipLink' | 'SkipLinkParameters' | 'SkipLinksFolder' | 'Snippet' | 'SnippetItem' | 'SnippetsFolder' | 'SocialLoginWrapper' | 'SocialMediaButtons' | 'SocialMediaFolder' | 'SocialMediaShare' | 'SocialMediaTemplate' | 'SocialNetwork' | 'SocialNetworkFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU = { __typename?: 'SocialNetworkLink' | 'SolutionTemplate' | 'SortResults' | 'SortResultsFolder' | 'Sorting' | 'SortingGroups' | 'SpotifyPodcast' | 'SpotifyPodcastFolder' | 'StickyCTA' | 'StickyCTAFolder' | 'StickyCTAParametersTemplate' | 'StrategiesInFocusFolder' | 'StrategyInFocus' | 'Style' | 'Styles' | 'Styles_9c0dac2808aa4b44bc2153363206f6a5' | 'SubscriptionBannerParametersTemplate' | 'Tab' | 'TabItem' | 'TableOfContents' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 = { __typename?: 'TableOfContentsFolder' | 'TableOfContentsSection' | 'TableOfContentsSubsection' | 'Tabs' | 'TabsFolder' | 'Tabs_f26a9560ccf148c59542800e837caf7a' | 'Tag' | 'TagCloud' | 'TagFolder' | 'TagList' | 'TeamBiographySettings' | 'TeamListingCards' | 'TeamListingCardsFolder' | 'TeamMember' | 'TeamMemberCard' | 'TeamMembers' | 'TeamMembersParentPage' | 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' | 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' | 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk = { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' | 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' | 'TeamMembersWildcardPage' | 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' | 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' | 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' | 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' | 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' | 'TeamProfileCards' | 'TeamProfileCardsFolder' | 'TechzoneArticlePage' | 'Tenant' | 'TenantFolder' | 'TenantSecurityItemPointer' | 'TenantSetupRoot' | 'TertieryHeroBanner' | 'TertieryHeroBannerParametersTemplate' | 'Text' | 'TextBlock' | 'TextBlockHeadingParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 = { __typename?: 'TextBlockHeadingType' | 'TextBlockHeadingTypeFolder' | 'TextBlockLinkType' | 'TextBlockLinkTypeFolder' | 'TextBlocks' | 'TextBlocksFolder' | 'TextBlocksParametersTemplate' | 'TextFolder' | 'TextFolder_b762d56787f5493cbb480c455d834457' | 'Text_b8f5894cb4934016bf784090b0a2fd16' | 'Theme' | 'ThemeTag' | 'ThemeTagsFolder' | 'ThemingMode' | 'ThemingModes' | 'Tile' | 'TileLink' | 'TileParametersTemplate' | 'TileSizeOption' | 'TileSizeOptionFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 = { __typename?: 'TilesFolder' | 'TilesParametersTemplate' | 'Title' | 'Title_a82e893105754175917de904ef7e6dbe' | 'Toggle' | 'ToggleFolder' | 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' | 'Transformation' | 'TrustArticleHeroParametersTemplate' | 'TrustFinder' | 'TrustFinderFilterOption' | 'TrustRegion' | 'TrustType' | 'TrustTypesFolder' | 'Twitter' | 'TwitterApp' | 'TwitterApps' | 'TwitterFolder' | 'TwitterParametersTemplate' | 'TwitterSettings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w = { __typename?: 'UnknownItem' | 'UnminifiedFile' | 'UpgradeScript' | 'UpgradeScriptLibrary' | 'VariantComponentField' | 'VariantDateField' | 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' | 'VariantPlaceholder' | 'VariantReference' | 'VariantSection' | 'VariantTemplate' | 'VariantText' | 'VariantToken' | 'Variants' | 'VectorFolder' | 'VectorTile' | 'VectorTileLink' | 'VectorTilesFolder' | 'VectorTilesParametersTemplate' | 'Version_95ebc23204774dc38ad3465d5fe8da2f' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU = { __typename?: 'Video' | 'VideoCountOption' | 'VideoCountOptions' | 'VideoFolder' | 'VideoFolder_bba49474673e468186ba8b1a20e067a9' | 'VideoPage' | 'VideoParameters' | 'VideoParametersTemplate' | 'VideoPressReleasePage' | 'Video_4bc649610a894242be2dc5026090cf49' | '_AssetsOptimization' | '_BackgroundImage' | '_CompatibleThemes' | '_CompositeTheme' | '_CustomMetadata' | '_CustomRenderingViewPath' | '_DatasourceBehaviour' | '_Favicon' | '_FormsFolderLocation' | '_FundSettings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 = { __typename?: '_HasValidUrlName' | '_LocalDataLink' | '_Login' | '_OpenGraphMetadata' | '_PageDesignTheme' | '_PageSearchScope' | '_SearchCriteria' | '_SearchableWithoutRelatedItems' | '_SeoMetadata' | '_SiteTheme' | '_SitemapSettings' | '_StickyNote' | '_Styleable' | '_TwitterMetadata' | '_Webinar' | '_WildcardSource' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & { name: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ArticleCategory_name_TextField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem = ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_c9XozYxqaFC0frAPHPeq433LPynBF0XM1g0Uz5LICn8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_9VPlmQkQdt9l4maQ46Z5fMhr5w16NSqTADFDI2lIY9Q | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_5Bp8CGD6gBt5zmgrKJRqS8sSurv5NB60wKLFzTr1j8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_vgM8szlOwwreWnyZ96extC1BJblr1vJelIcjuF6Tw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_shlDQDRBXfEV2IMt8Q7OnzROWrVF0nQMSI8rkrSZU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_0SYpviiyXX3BRforwncXG3pexVXYcIm4fmQoeSPcK4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_JuL8MVaWzToSlJIakCO1bigqoAcm1EGyklGo3wRrRLw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_aqw7j7oAQM5GJ9oIWaOAyiGli5atrgfmQJoQe8rDt4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_jWiNNE8wAezwjVLEWn3IRc7x4WY9EKiEuZpBROPG4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BfCZy14f5vCYoKPvUvlJVRkotuL1gmUwjkgrggQ05A | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_PHLgvBFZABTRngNRTYYUi9KBdwe9p7W4YDlCj72fOIs | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_KL7bf4QPLQ7mpyzzvQk5f6piwJk1PES0rcP7Uy9x0M | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_iqnu4DMOAGlC9sVDpDbjHWwyB7ysXrKwlOhFHAyC0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_umgzCXtgi1WMowaNMDJnNsdrdDP4Ie7qfWy2owTqtI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_c8gc72G7Xyo5xvM63VPyvhGmiUxe0BFuVTVAj9su0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_VtfJ6wYpLDTemXJEIB7XJw2duFCBCMgGB8vlYx6hsc0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_1BpmAGsjLrkU4cexVLSJ4OyM81tByZRfH3Rlj3t6CE | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_NyEECiwuus0IEb5R3ZHyvXsBaUAVp6zWfQGtLdoaAU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_Fj4L99iVJxbVnFn7srvABth7WlFSHNzZENorwzE | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ANdBVC6KFTlUcJhSibUfyWTFtLta5lsMUp9qlxcVurI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_xbvRLMKOfZhwK7StDx4pk8GufekPnO6TlKVuKDWc0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_C7jD2H7yOuHKbYSq1WvlnNO2zZ9k33Tt60j7wVs4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_6hn5PudNLAFVxgpoCeIRzlxkBlB8a1pSQwG8cmE | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_u7BRZVBhheosXLCSBWQJBOivuyXVuOOaFBBIAa5UQdc | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_dpqtGMeZVSGVIy9q5ldacew1cWo2gELfnm77xVZDIg | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_lalHkBPxpftIF8HuYXqfDXnzifCeKVwttYezsBbL6A | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_Q9MXc9RjR2M267DgK6zxTNUiUi6NIPijp0dZLLIgk | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_dMUje5zuPQ5cTfsHsP483FXiZjLZOp5y7mQEffnH1xw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_hb7aIiGiWMscK3W1w04Vy90EkNWrFzDyfbrTjKcNK2s | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_mlJlKCHse9oAGb81rXrwxNMBDoalRluBpSZ2wf1jcU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_bpyH1qQmSBBKUyiskmVf3nBxPfFJ3ja7QnVcUd6KZro | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ArticleCategory;

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField = (
  { __typename?: 'LookupField' }
  & { targetItem: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField = (
  { __typename?: 'DateField' }
  & Pick<Types.DateField, 'formattedDateValue'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField = (
  { __typename?: 'ImageField' }
  & Pick<Types.ImageField, 'src'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ArticleTag_name_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM = { __typename?: 'Accordion' | 'AccordionFolder' | 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' | 'AccordionItem' | 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' | 'AccordionParametersTemplate' | 'AccordionPresentation' | 'AccordionPresentationFolder' | 'Accordion_02d060598cc14423a9ac9ff2365176b7' | 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' | 'AddItem' | 'AddItem_1e1b739ec3784909941d171aca7362e5' | 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' | 'AddItem_de8c75222f3241288f20342f479894eb' | 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' | 'AddThisParameters' | 'AggregatedFacetFilter' | 'AlertMessage' | 'AlertMessageFolder' | 'AlertMessageParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E = { __typename?: 'AlertMessageType' | 'AllertMessageTypeFolder' | 'Archive' | 'ArticleAuthor' | 'ArticleAuthorsFolder' | 'ArticleCategoriesFolder' | 'ArticleCategory' | 'ArticleChapter' | 'ArticleChapters' | 'ArticleContentType' | 'ArticleContentTypesFolder' | 'ArticleFilter' | 'ArticleFilterOption' | 'ArticleFootnote' | 'ArticleFootnoteLink' | 'ArticleFootnoteText' | 'ArticleInfogramTile' | 'ArticleInfogramTileParametersTemplate' | 'ArticlePage' | 'ArticleRegion' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_PnwaseAlIGIXnxiuLSPaWKSThHdZCaYYv4GPnTc4U = { __typename?: 'ArticleRegionsFolder' | 'ArticleSearchPage' | 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' | 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' | 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' | 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' | 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' | 'ArticleSeriesCollection' | 'ArticleSeriesFolder' | 'ArticleSettings' | 'ArticleSubscriptionBanner' | 'ArticleSubscriptionBannerFolder' | 'ArticleTagsFolder' | 'ArticleTeamAuthor' | 'ArticleTileParametersTemplate' | 'ArticleTilesParametersTemplate' | 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' | 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' | 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' | 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_5Bp8CGD6gBt5zmgrKJRqS8sSurv5NB60wKLFzTr1j8 = { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' | 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' | 'ArticlesGroupFolder' | 'AttachThemeExtension' | 'AutomaticDocumentListings' | 'AutomaticDocumentListingsFolder' | 'AvailableJSONRenderings' | 'AvailableMetaRenderings' | 'AvailableRenderings' | 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' | 'AwardsBanner' | 'AwardsBannerFolder' | 'AwardsBannerImage' | 'AwardsBannerParametersTemplate' | 'BYOCWrapperRenderingParameters' | 'BackgroundColorOption' | 'BackgroundColorOptionFolder' | 'BannerFolder' | 'BannerType' | 'BannerTypeFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_vgM8szlOwwreWnyZ96extC1BJblr1vJelIcjuF6Tw = { __typename?: 'BaseHeading' | 'BaseHeadingFolder' | 'BoolFacet' | 'BranchesFolder' | 'Breadcrumb' | 'BrowserTitleDefinition' | 'CORSEntry' | 'CORSGrouping' | 'CTAPresentationType' | 'CTAPresentationTypeFolder' | 'C__AbrdnPage' | 'C__ActionBase' | 'C__AdvancedParameter' | 'C__App' | 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' | 'C__ArticleWildcardPage' | 'C__AvailableRenderingsFolder' | 'C__BYOCRenderingParameters' | 'C__BackgroundParametersTemplate' | 'C__BaseCTA' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_shlDQDRBXfEV2IMt8Q7OnzROWrVF0nQMSI8rkrSZU = { __typename?: 'C__BasePage' | 'C__BasePage_037da552a5524fe4aeee331f57ac1378' | 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' | 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' | 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' | 'C__BasePage_728c97b5c56146d9807e21018a972bb5' | 'C__BasePage_6105875085f346729dfc8d133b481f26' | 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' | 'C__BaseRenderingParameters' | 'C__BaseTheme' | 'C__BaseVariantField' | 'C__Class' | 'C__CompositeGroup' | 'C__CompositeSection' | 'C__EloquaForm' | 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' | 'C__ExtendedOptions' | 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' | 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' | 'C__FEaaSRenderingParameters' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_0SYpviiyXX3BRforwncXG3pexVXYcIm4fmQoeSPcK4 = { __typename?: 'C__FacetSelectorConfigBase' | 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' | 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' | 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' | 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' | 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' | 'C__GlobalDatasourceBehavior' | 'C__GridDefinition' | 'C__GridItemBase' | 'C__GridParameters' | 'C__HeadlessSite' | 'C__HeadlessTenant' | 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' | 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' | 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' | 'C__IAllowEmpty' | 'C__IBaseVariantDefinition' | 'C__IBoosting' | 'C__ICacheable' | 'C__ICompatibleRenderings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_JuL8MVaWzToSlJIakCO1bigqoAcm1EGyklGo3wRrRLw = { __typename?: 'C__IComponentVariant' | 'C__IControlType' | 'C__IDynamicPlaceholder' | 'C__IFEaaSComponentsDataSourceTemplates' | 'C__IFEaaSComponentsEditorScriptURL' | 'C__IIcon' | 'C__ILocation' | 'C__IPaginable' | 'C__IPagination' | 'C__IPoi' | 'C__IRenderingId' | 'C__ISplitter' | 'C__IStyling' | 'C__IVariantDefinition' | 'C__InvestmentTrustPage' | 'C__JSONField' | 'C__JSONReference' | 'C__JSSData' | 'C__JSSSettings' | 'C__JSSSiteFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_aqw7j7oAQM5GJ9oIWaOAyiGli5atrgfmQJoQe8rDt4 = { __typename?: 'C__JssRootFolder' | 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' | 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' | 'C__Page' | 'C__PageData' | 'C__PageDesignFolder' | 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' | 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' | 'C__PartialDesign' | 'C__PartialDesignFolder' | 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' | 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' | 'C__PlaceholderWrapper' | 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' | 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' | 'C__RedirectMapGrouping' | 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' | 'C__Route' | 'C__SimpleVideo' | 'C__SiteSettingsFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_jWiNNE8wAezwjVLEWn3IRc7x4WY9EKiEuZpBROPG4 = { __typename?: 'C__SitemapSettings' | 'C__StandardTemplate' | 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' | 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' | 'C__TrustFolder' | 'C__VariantDefinition' | 'C__VariantField' | 'C__VariantsGrouping' | 'C___AdvancedItem' | 'C___Arguments' | 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' | 'C___Article' | 'C___ArticlePageWorkflow' | 'C___ArticleSearchPage' | 'C___ArticleWildcard' | 'C___AssetServiceThemeMode' | 'C___BaseArticle' | 'C___BaseDataFolder' | 'C___BaseHelpArticle' | 'C___BaseInvestmentTrust' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_BfCZy14f5vCYoKPvUvlJVRkotuL1gmUwjkgrggQ05A = { __typename?: 'C___BaseJSSTenant' | 'C___BasePage' | 'C___BasePageDesign' | 'C___BasePageDesignFolder' | 'C___BasePartialDesign' | 'C___BasePartialDesignFolder' | 'C___BasePlaceholder' | 'C___BasePlaceholderSettingsFolder' | 'C___BasePresentation' | 'C___BasePressRelease' | 'C___BaseRenderingParameters' | 'C___BaseSXAStandardValuesFolder' | 'C___BaseSettings' | 'C___BaseSharedSitesSettings' | 'C___BaseSiteDefinition' | 'C___BaseSiteFolder' | 'C___BaseSiteGrouping' | 'C___BaseSiteRoot' | 'C___BaseTenant' | 'C___BaseTenantFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_PHLgvBFZABTRngNRTYYUi9KBdwe9p7W4YDlCj72fOIs = { __typename?: 'C___BucketRules' | 'C___CORS' | 'C___Content' | 'C___ContentType' | 'C___DataAttributes' | 'C___DatasourceWorkflow' | 'C___Dependencies' | 'C___Description' | 'C___DesignTemplateMapping' | 'C___Designable' | 'C___EditType' | 'C___EditType_8a9f84baaa124c5d9096935714809da4' | 'C___EditingTheme' | 'C___Enabled' | 'C___ErrorHandling' | 'C___ExternalArticle' | 'C___Fields' | 'C___FilteredArticlesParent' | 'C___FilteredArticlesWildcard' | 'C___Footnotes' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_KL7bf4QPLQ7mpyzzvQk5f6piwJk1PES0rcP7Uy9x0M = { __typename?: 'C___FundDetailsWildcard' | 'C___FundFormAvailability' | 'C___FundMetadataPage' | 'C___FundSearchPage' | 'C___FundsFolder' | 'C___FundsFormsFolder' | 'C___FundsLiteratureFolder' | 'C___FundsShareclassesDetailsWildcard' | 'C___GridMapping' | 'C___HelpArticle' | 'C___HelpArticleSearchPage' | 'C___HelpArticleWildcard' | 'C___HorizonDatasourceGrouping' | 'C___Icon' | 'C___IncludeByDefault' | 'C___IncludeIfInstalled' | 'C___InternalArticle' | 'C___InternetExplorerCompatibilityMode' | 'C___IsSystemModule' | 'C___JSONVariantPaging' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_iqnu4DMOAGlC9sVDpDbjHWwyB7ysXrKwlOhFHAyC0 = { __typename?: 'C___JSONVariantsBase' | 'C___LimitedDisplay' | 'C___LinkAttributes' | 'C___LinkSettings' | 'C___LiteratureHubSearchPage' | 'C___ManualKeyInformation' | 'C___MemberOf' | 'C___MetadataPage' | 'C___Modules' | 'C___Name' | 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' | 'C___Name_299cdb154745448a807868d401248eaa' | 'C___Name_b88cf88159a54a19991e71038751cb60' | 'C___Navigable' | 'C___NavigablePage' | 'C___PageContent' | 'C___PageWorkflow' | 'C___PerSiteStandardValues' | 'C___Podcast' | 'C___PodcastPressRelease' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_umgzCXtgi1WMowaNMDJnNsdrdDP4Ie7qfWy2owTqtI = { __typename?: 'C___PremiumContentPage' | 'C___PressRelease' | 'C___PressReleaseContentType' | 'C___PressReleaseSearchPage' | 'C___PressReleaseWildcard' | 'C___ProtectedTheme' | 'C___PublishingGroupingTemplate' | 'C___RenderingRelatedParameters' | 'C___RenderingVariantsBase' | 'C___RenderingsList' | 'C___RobotsContent' | 'C___RoleDomain' | 'C___RoleName' | 'C___RoleType' | 'C___SalesforceCommonValidations' | 'C___SalesforceFieldId' | 'C___SalesforceFieldTitle' | 'C___SalesforceFieldValue' | 'C___Script' | 'C___SearchSignature' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_c8gc72G7Xyo5xvM63VPyvhGmiUxe0BFuVTVAj9su0 = { __typename?: 'C___Searchable' | 'C___SecurityItemPointer' | 'C___SharedArticles' | 'C___SharedContent' | 'C___SharedHelpArticles' | 'C___SharedPage' | 'C___SharedPressReleases' | 'C___SharedRoot' | 'C___SharedSettings' | 'C___SiteContent' | 'C___SiteFolder' | 'C___SiteMediaLibrary' | 'C___SiteSettings' | 'C___SiteTemplate' | 'C___SitecoreClientSiteManaging' | 'C___Sitemap' | 'C___SitemapMediaItems' | 'C___SlidersRangeSettings' | 'C___SolutionTemplateContent' | 'C___SolutionTemplateDescription' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_VtfJ6wYpLDTemXJEIB7XJw2duFCBCMgGB8vlYx6hsc0 = { __typename?: 'C___SolutionTemplateName' | 'C___SortOrder' | 'C___StackBreakpoint' | 'C___Statistics' | 'C___SupportedLanguages' | 'C___Taggable' | 'C___TeamMembersParentPage' | 'C___TeamMembersWildcard' | 'C___TechzoneArticle' | 'C___Template' | 'C___Title' | 'C___Type' | 'C___Validation' | 'C___VariantPaging' | 'C___VectorTile' | 'C___VectorTileLink' | 'C___Video' | 'C___VideoPressRelease' | 'C___Width' | 'C___WildcardPage' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_1BpmAGsjLrkU4cexVLSJ4OyM81tByZRfH3Rlj3t6CE = { __typename?: 'CacheSetting' | 'Caching_26fce9bf0256458d8281a713a5bf5520' | 'CalendarEvent' | 'CallOutSection' | 'CallOutSectionDropdownOption' | 'CallOutSectionFolder' | 'CallOutSectionParametersTemplate' | 'CallToAction' | 'CallToActionFolder' | 'CapabilitiesFolder' | 'Capability' | 'CapabilityMap' | 'CapabilityMappings' | 'Carousel' | 'CarouselFolder' | 'CarouselSlide' | 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' | 'Checkbox' | 'ChecklistFilter' | 'ChecklistFilterFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_NyEECiwuus0IEb5R3ZHyvXsBaUAVp6zWfQGtLdoaAU = { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' | 'ColumnSplitter' | 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' | 'CompatibilityMode' | 'ComponentConfiguration' | 'ComponentThemeConfiguration' | 'ComponentThemesConfiguration' | 'ComponentsConfigurations' | 'ConfigurationFolder' | 'Container' | 'ContainerOption' | 'ContainerOptionsFolder' | 'ContainerParametersTemplate' | 'Container_45130bdbbae34edcaea87b68b9d94c7f' | 'ContentBlock' | 'ContentBlockFolder' | 'ContentToken' | 'ContentTokenFolder' | 'ContentType' | 'CorporateTheme' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_Fj4L99iVJxbVnFn7srvABth7WlFSHNzZENorwzE = { __typename?: 'CorporateThemesFolder' | 'Country' | 'CountryISOCode' | 'CountryISOCodesFolder' | 'CustomerReviewFolder' | 'CustomerReviewTile' | 'CustomerReviewTileParametersTemplate' | 'DataBridgeDocumentCategoryMap' | 'DataBridgeFund' | 'DataBridgeFundRangeName' | 'DataBridgeSettingsFolder' | 'DataBridgeShareClass' | 'DataFolder' | 'DatasourceConfiguration' | 'DatasourceConfigurations' | 'DatasourceWorkflowAction' | 'DateFacet' | 'DateFilter' | 'DateFilterFolder' | 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ANdBVC6KFTlUcJhSibUfyWTFtLta5lsMUp9qlxcVurI = { __typename?: 'DefaultColumnLayout' | 'DefaultShareclassMapping' | 'DefaultShareclassMappings' | 'DescriptiveHighlight' | 'DescriptiveHighlightFolder' | 'DescriptiveHighlightItem' | 'DescriptiveHighlightParametersTemplate' | 'Device' | 'Device_7c27ec70f42e40428a0fabaa2f8eda18' | 'Devices' | 'DictionaryFolder' | 'DisqusParameters' | 'DistanceFacet' | 'Divider' | 'DocumentItem' | 'DocumentListings' | 'DocumentListingsFolder' | 'DocumentTypeFolder' | 'DominantLanguageMapping' | 'Dropdown' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_xbvRLMKOfZhwK7StDx4pk8GufekPnO6TlKVuKDWc0 = { __typename?: 'DropdownFilter' | 'DropdownFilterFolder' | 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' | 'EditEditingTheme' | 'EditFrame' | 'EditModePanel' | 'EditSiteItem' | 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' | 'EditSiteTheme' | 'EditTenantTemplate' | 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' | 'EditType' | 'EloquaFormFolder' | 'EloquaFundForm' | 'Enum' | 'Enums' | 'ErrorPage' | 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' | 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' | 'ErrorPage_45d797cc048740ffb693214883ff35c2' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_C7jD2H7yOuHKbYSq1WvlnNO2zZ9k33Tt60j7wVs4 = { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' | 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' | 'EventCalendarParameters' | 'EventList' | 'EventListParameters' | 'EventTypes' | 'EventsFolder' | 'ExecuteScript' | 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' | 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' | 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' | 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' | 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' | 'ExtendSiteTheme' | 'ExternalLiterature' | 'FEaaSWrapperRenderingParameters' | 'FacebookCommentsParametersTemplate' | 'FacetSlider' | 'FacetSliderFolder' | 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_6hn5PudNLAFVxgpoCeIRzlxkBlB8a1pSQwG8cmE = { __typename?: 'FacetSummary' | 'FacetSummaryFolder' | 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' | 'FacetsGrouping' | 'FakeNavigationItem' | 'FeatureBanner' | 'FeatureBannerParametersTemplate' | 'FeaturedArticles' | 'FeaturedArticlesFolder' | 'FeaturedTheme' | 'FeaturedThemesFolder' | 'Feed' | 'FeedFolder' | 'FeedParameters' | 'FieldEditor' | 'FieldRenderer' | 'FileList' | 'FileListFolder' | 'FileListParametersTemplate' | 'File_04129321770849c1801baee196e1c0a8' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_u7BRZVBhheosXLCSBWQJBOivuyXVuOOaFBBIAa5UQdc = { __typename?: 'FilterCriteria' | 'FilterCriteriaFolder' | 'FilterTaxonomyOption' | 'FilterTaxonomyOptions' | 'FilteredArticlesParentPage' | 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' | 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' | 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' | 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' | 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' | 'FilteredArticlesWildcardPage' | 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' | 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' | 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' | 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' | 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' | 'Flip' | 'FlipFolder' | 'Flip_5ef078504c044b839dafefd752cfaba8' | 'Flipside' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_dpqtGMeZVSGVIy9q5ldacew1cWo2gELfnm77xVZDIg = { __typename?: 'FloatFacet' | 'Footer' | 'FooterFolder' | 'FooterLink' | 'FormRenderingParameters' | 'FundAssetClass' | 'FundAssetClassesFolder' | 'FundDetailsWildcardPage' | 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' | 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' | 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' | 'FundFormsFolder' | 'FundInFocus' | 'FundInFocusShareClass' | 'FundSearchPage' | 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' | 'FundSearchPage_5806f83c03bc443380678ff955f4310f' | 'FundSearchPage_7432205c04214a419ca064c4cb37501c' | 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' | 'FundSettings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_lalHkBPxpftIF8HuYXqfDXnzifCeKVwttYezsBbL6A = { __typename?: 'FundShareclassDetailsWildcardPage' | 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' | 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' | 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' | 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' | 'FundSubAssetClass' | 'FundSubAssetClassesFolder' | 'FundsExternalLiteratureFolder' | 'FundsFolder' | 'FundsInFocusFolder' | 'FundsInFocusParametersTemplate' | 'FundsLiteratureFolder' | 'FundsLiteratureMappingsFolder' | 'Gallery' | 'GalleryFolder' | 'GalleryImage' | 'GalleryParametersTemplate' | 'GalleryVideo' | 'GatedAccordionContainer' | 'GlobalLanguageSelector' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_Q9MXc9RjR2M267DgK6zxTNUiUi6NIPijp0dZLLIgk = { __typename?: 'GlobalNavigationBar' | 'GoogleAnalytics' | 'GoogleTagManager' | 'GoogleTagManagerFolder' | 'GridSetup' | 'GridTheme' | 'HTMLCode' | 'HTMLCodeFolder' | 'HTMLInclude' | 'HTMLIncludesFolder' | 'HTMLSnippet' | 'HTMLSnippetFolder' | 'HTMLTag' | 'Header' | 'HeaderFolder' | 'Heading' | 'HeadlessSiteSetupRoot' | 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' | 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' | 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_dMUje5zuPQ5cTfsHsP483FXiZjLZOp5y7mQEffnH1xw = { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' | 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' | 'HeadlessSite_229484893ca144958b9937167dfb5064' | 'HeadlessSite_b28055626acc45a2913a9617398c9730' | 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' | 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' | 'HeadlessSolutionTemplateFolder' | 'HeadlessTenantSetupRoot' | 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' | 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' | 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' | 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' | 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' | 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' | 'HeadlessTenant_94824ac390d748499e5af0275d10811f' | 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' | 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' | 'HeadlessTrustSite' | 'HeadlessVariants' | 'HeadlessVariantsGrouping' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_hb7aIiGiWMscK3W1w04Vy90EkNWrFzDyfbrTjKcNK2s = { __typename?: 'HelpArticlePage' | 'HelpArticlePlatform' | 'HelpArticlePlatformMap' | 'HelpArticlePlatformMappings' | 'HelpArticlePlatformsFolder' | 'HelpArticleSearchPage' | 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' | 'HelpArticleTag' | 'HelpArticleTagsFolder' | 'HelpArticleWildcardPage' | 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' | 'HelpArticlesGroupFolder' | 'HelpTagMap' | 'HelpTagMappings' | 'HeroBanner' | 'Highlight' | 'HighlightBlock' | 'HighlightBlockFolder' | 'HighlightBlockParametersTemplate' | 'HighlightFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_mlJlKCHse9oAGb81rXrwxNMBDoalRluBpSZ2wf1jcU = { __typename?: 'HighlightItem' | 'HighlightParametersTemplate' | 'Home' | 'HomePage' | 'HomePage_0d3963a8171d4080b5f808618578b631' | 'HomePage_6d95c7d946c74a70be07304cc73a2010' | 'HomePage_b407f259b4e34c7db9a06e8907a56b17' | 'HomePage_cde13c51062d426b95569e8202edc963' | 'HomePage_de9353283a3e41c495ba386aed0540c6' | 'IFrame' | 'IFrameFolder' | 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' | 'IFrameParametersTemplate' | 'IFrame_0da12d476de24dfeb4d0f513489bfea1' | 'IFrame_88a6f65f2b78491bb3770b06e48883e1' | 'Icon' | 'IconFolder' | 'Image' | 'ImageFolder' | 'ImageFolder_edc00e86cef24d0cbfa264460becc323' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_bpyH1qQmSBBKUyiskmVf3nBxPfFJ3ja7QnVcUd6KZro = { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' | 'ImageParametersTemplate' | 'Image_83bc563c6320490092f8204bff81586a' | 'Image_15185b0e641844499f934ff03b7ee032' | 'Image_d885df8cb2d64007b34b2bbafb527304' | 'Infographics' | 'InfographicsFolder' | 'InputValidationStep' | 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' | 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' | 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' | 'IntegerFacet' | 'IntroCopy' | 'IntroCopyFolder' | 'InvestmentTrustAssetClass' | 'InvestmentTrustAssetClassFolder' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' | 'InvestmentTrustRegion' | 'InvestmentTrustRegionFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg = { __typename?: 'InvestmentTrustStyle' | 'InvestmentTrustStyleFolder' | 'InvestorType' | 'InvestorTypesFolder' | 'ItemQueriesFolder' | 'ItemRights' | 'JSBeaconSettings' | 'JSONCheckbox' | 'JSONContent' | 'JSONDate' | 'JSONFile' | 'JSONImage' | 'JSONLayout' | 'JSONList' | 'JSONMultilistReference' | 'JSONPlaceholder' | 'JSONQuery' | 'JSONResults' | 'JSONRichText' | 'JSONScriban' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY = { __typename?: 'JSONSection' | 'JSONTemplate' | 'JSONText' | 'JSONToken' | 'JSONVariantDefinition' | 'JSONVariants' | 'JSSLayout' | 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' | 'JSSSettings_6b328292f8314ab79885d89a054ca10a' | 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' | 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' | 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' | 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' | 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' | 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' | 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' | 'JSSSiteGrouping' | 'JSSTenantFolder' | 'JavaScriptRendering' | 'JsonRendering' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q = { __typename?: 'JurisdictionStatus' | 'JurisdictionsFolder' | 'KeyHighlightItem' | 'KeyHighlights' | 'KeyHighlightsFolder' | 'KeyHighlightsParametersTemplate' | 'Language' | 'LanguageSelector' | 'LanguagesFolder' | 'LatestPressReleasesParametersTemplate' | 'LayoutServiceVariants' | 'LimitedDisplayFolder' | 'LimitedDisplayOption' | 'Link' | 'LinkList' | 'LinkListFolder' | 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' | 'LinkList_33c9207e3b0446068ef54ca99a97c776' | 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' | 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA = { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' | 'Link_930f134d56784b35bfd1b77f9d0115f1' | 'Link_e24e0789a05848bfabb6c69c0e60b6b7' | 'LinksFolder' | 'List' | 'ListFacet' | 'ListFolder' | 'ListItem' | 'ListParametersTemplate' | 'ListStyle' | 'ListStyleItem' | 'ListingHeroBanner' | 'ListingHeroParametersTemplate' | 'LiteratureAuthorization' | 'LiteratureAuthorizationsFolder' | 'LiteratureHubSearchPage' | 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' | 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' | 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' | 'LoadMore' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM = { __typename?: 'LoadMoreFolder' | 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' | 'LocationFilter' | 'LocationFilterFolder' | 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' | 'Log' | 'Login' | 'Login_abed54dc4f7840ddac562289c9c849d8' | 'LogoTextBlockItem' | 'LogoTextBlocks' | 'LogoTextBlocksFolder' | 'Logout' | 'Logout_c2294d8235a6452a94b15eb5e543b602' | 'ManagedRangeFilter' | 'ManagedRangeFilterFolder' | 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' | 'ManagedRangeItem' | 'Map' | 'MapParameters' | 'MapsFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 = { __typename?: 'MapsProvider' | 'MediaBlock' | 'MediaBlockFolder' | 'MediaBlockParametersTemplate' | 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' | 'MediaLinkParameters' | 'MediaVirtualFolder' | 'MegaNavigation' | 'MegaNavigationFolder' | 'MetaBranding' | 'MetaRenderingParameters' | 'MetadataPartialDesign' | 'Model' | 'ModelIterator' | 'MyLocationPOI' | 'Navigation' | 'NavigationCategory' | 'NavigationFilter' | 'NavigationFilterFolder' | 'NavigationLink' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs = { __typename?: 'NavigationSubcategory' | 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' | 'OneTrustSettings' | 'OptimiserConfiguration' | 'OptimiserConfigurationSection' | 'OptimizedFile' | 'OracleCDPSettings' | 'OverlayContent' | 'OverlayFolderTemplate' | 'Ownership' | 'OwnershipFolder' | 'POI' | 'POIFolder' | 'POIType' | 'POIs' | 'PageBranchesFolder' | 'PageContent' | 'PageContentFolder' | 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' | 'PageDesign' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M = { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' | 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' | 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' | 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' | 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' | 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' | 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' | 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' | 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' | 'PageDesign_1105b8f81e00426bbf1fc840742d827b' | 'PageDesigns' | 'PageDesigns_3af52e70e982424b9c85e355542500c9' | 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' | 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' | 'PageDesigns_99a71bba507746729c3fb29b04abee23' | 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' | 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' | 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' | 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' | 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY = { __typename?: 'PageLevelTabs' | 'PageLevelTabsFolder' | 'PageList' | 'PageSelector' | 'PageSelectorConfiguration' | 'PageSelectorFolder' | 'PageSelector_59a7bb775f8c435ab810291abde80e63' | 'PageSize' | 'PageSizeFolder' | 'PageSize_b682562e0af64b3e9e3b45273bbe152d' | 'PageTheme' | 'PageThemesFolder' | 'Page_4f49a81db3664f198b89cab92f377d7a' | 'Page_5e66d86353544fe6a27d3b894984d50f' | 'Page_84f342ad2d0646b9aa9a818201145ca2' | 'Page_718df200be51463d93edf4d77ab7a49e' | 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' | 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' | 'Page_dae7821153e14dbabb0ddf0b53a90aaf' | 'Page_fa608b3e6aeb426388a059d89caabada' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc = { __typename?: 'Pagging' | 'Pagination' | 'PaginationFolder' | 'Paragraph' | 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' | 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' | 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' | 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' | 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' | 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' | 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' | 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' | 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' | 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' | 'PartialDesigns' | 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' | 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' | 'PartialDesigns_36c869ded22040929ce829f6ed643c66' | 'PartialDesigns_1943dc73710a430895515a342c84b037' | 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es = { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' | 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' | 'PartialDesigns_d216303f58d8425688da8cd30d00afab' | 'PartialDesigns_facda26791204fa9a0363344348f2c42' | 'PerformanceChartSettings' | 'PerformanceChartTimePeriod' | 'PerformanceChartTimePeriodFolder' | 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' | 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' | 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' | 'Placeholder_1ca0304be5b64810821154426f1752c2' | 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' | 'PlainHtmlParametersTemplate' | 'Playlist' | 'PlaylistFolder' | 'PlaylistParametersTemplate' | 'Podcast' | 'PodcastFolder' | 'PodcastPage' | 'PodcastPressReleasePage' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM = { __typename?: 'PoiTypes' | 'PostDeleteStep' | 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' | 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' | 'PostDeleteStep_b20857895385413883f096f3767cb156' | 'PostSetupStep' | 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' | 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' | 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' | 'PreDeleteStep' | 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' | 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' | 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' | 'PreDeleteValidationStep' | 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' | 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' | 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' | 'Presentation' | 'Presentation_0a70fa7389234a6eabf34134f25f3221' | 'PressReleaseContentType' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk = { __typename?: 'PressReleaseContentTypesFolder' | 'PressReleaseFilter' | 'PressReleasePage' | 'PressReleasePlatform' | 'PressReleasePlatformsFolder' | 'PressReleaseSearchPage' | 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' | 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' | 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' | 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' | 'PressReleaseWildcardPage' | 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' | 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' | 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' | 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' | 'PressReleasesGroupFolder' | 'PrivacyWarning' | 'ProjectFolder' | 'Promo' | 'PromoFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU = { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' | 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' | 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' | 'Promo_dfed4457d760457abec1c0dccdc44381' | 'PromotedContent' | 'PromotedContentFolder' | 'PropertyListingCard' | 'PropertyListingCards' | 'PropertyListingCategory' | 'PropertyListingFolder' | 'Query_98b413525a4b4067b92418a4b50f0a53' | 'QuickLinks' | 'QuickLinksFolder' | 'QuickLinksParametersTemplate' | 'QuotationBlockItem' | 'QuotationBlocks' | 'QuotationBlocksFolder' | 'QuotationBlocksParametersTemplate' | 'Quote' | 'QuoteFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 = { __typename?: 'QuoteParametersTemplate' | 'RadiusFilter' | 'RadiusFilterFolder' | 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' | 'RadiusScheme' | 'RadiusSchemeValue' | 'RangeSliderFilter' | 'RangeSliderFilterFolder' | 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' | 'RecentArticles' | 'Redirect' | 'RedirectMap' | 'RedirectMaps' | 'Region' | 'RegionLanguages' | 'RegionLanguagesFolder' | 'RelatedArticles' | 'RelatedArticlesParametersTemplate' | 'RenderEngineType' | 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg = { __typename?: 'RenderingHost' | 'ResizableIFramePage' | 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' | 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' | 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' | 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' | 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' | 'ResponsiveImage' | 'ResultsCount' | 'ResultsCountFolder' | 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' | 'ResultsVariantSelector' | 'RichText' | 'RichTextFolder' | 'RichText_0f3b73366112418c8bbab0526f3887ce' | 'RichText_efcfd8f6596745f48f85b5421928205d' | 'RiskImageMapping' | 'RiskImageMappings' | 'RiskLevelOption' | 'RiskLevelOptionFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc = { __typename?: 'RiskWarning' | 'RiskWarningFolder' | 'RiskWarningParametersTemplate' | 'RolePlaceholder' | 'RowSplitter' | 'RowSplitter_340c887da1d1415b9678c763af74ea97' | 'Rule' | 'SDRLogoMapping' | 'SDRLogoMappings' | 'SDRTypeOption' | 'SDRTypeOptionFolder' | 'SXAJSSLayout' | 'SXARole' | 'SXAStandardValuesFolder' | 'SalesforceAlertMessage' | 'SalesforceCheckBox' | 'SalesforceCheckBoxType' | 'SalesforceConditionalRadioButton' | 'SalesforceConditionalRadioButtons' | 'SalesforceDateInput' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM = { __typename?: 'SalesforceDropdown' | 'SalesforceDropdownOption' | 'SalesforceHiddenField' | 'SalesforceInput' | 'SalesforceInputType' | 'SalesforceIntegratedForm' | 'SalesforceIntegratedFormTypesFolder' | 'SalesforceRepeatableSubSection' | 'SalesforceRichTextArea' | 'SalesforceSection' | 'SalesforceSortCodeInput' | 'SalesforceSubmissionType' | 'Scope' | 'ScopesFolder' | 'Scriban' | 'Scripts' | 'SearchBox' | 'SearchBoxFolder' | 'SearchBox_1c04fd611d874590acfe9cc186865ab3' | 'SearchFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo = { __typename?: 'SearchResults' | 'SearchResultsFolder' | 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' | 'SecondaryHeroBannerParametersTemplate' | 'SectionHeading' | 'SectionHeadingFolder' | 'SectionHeadingParametersTemplate' | 'SectionHeadingType' | 'SectionHeadingTypeFolder' | 'SectionSelector' | 'SectionSelectorFolder' | 'SectionSelectorTab' | 'Security_33077d51ebad4d1cb4a83b79f51dba13' | 'Series' | 'SeriesFolder' | 'Settings' | 'SettingsFolder' | 'Settings_6c82caca67dc464195698faad083230e' | 'SharePriceSettings' | 'SharedArticlesFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs = { __typename?: 'SharedContentFolder' | 'SharedFolder' | 'SharedHelpArticlesFolder' | 'SharedPressReleasesFolder' | 'SharedSettingsFolder' | 'SharedSitesSettings' | 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' | 'Showcase' | 'ShowcaseFolder' | 'ShowcaseItem' | 'ShowcaseParametersTemplate' | 'Site' | 'SiteContentFolder' | 'SiteDefinition' | 'SiteEntryDisclaimer' | 'SiteFolder' | 'SiteGrouping' | 'SiteManagement' | 'SiteSecurityItemPointer' | 'SiteSelector' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo = { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' | 'SiteSetupRoot' | 'SiteTheme' | 'Site_e46f3af239fa4866a1577017c4b2a40c' | 'SitecoreFormWrapperParametersTemplate' | 'SitecoreRole' | 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' | 'SkipLink' | 'SkipLinkParameters' | 'SkipLinksFolder' | 'Snippet' | 'SnippetItem' | 'SnippetsFolder' | 'SocialLoginWrapper' | 'SocialMediaButtons' | 'SocialMediaFolder' | 'SocialMediaShare' | 'SocialMediaTemplate' | 'SocialNetwork' | 'SocialNetworkFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU = { __typename?: 'SocialNetworkLink' | 'SolutionTemplate' | 'SortResults' | 'SortResultsFolder' | 'Sorting' | 'SortingGroups' | 'SpotifyPodcast' | 'SpotifyPodcastFolder' | 'StickyCTA' | 'StickyCTAFolder' | 'StickyCTAParametersTemplate' | 'StrategiesInFocusFolder' | 'StrategyInFocus' | 'Style' | 'Styles' | 'Styles_9c0dac2808aa4b44bc2153363206f6a5' | 'SubscriptionBannerParametersTemplate' | 'Tab' | 'TabItem' | 'TableOfContents' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 = { __typename?: 'TableOfContentsFolder' | 'TableOfContentsSection' | 'TableOfContentsSubsection' | 'Tabs' | 'TabsFolder' | 'Tabs_f26a9560ccf148c59542800e837caf7a' | 'Tag' | 'TagCloud' | 'TagFolder' | 'TagList' | 'TeamBiographySettings' | 'TeamListingCards' | 'TeamListingCardsFolder' | 'TeamMember' | 'TeamMemberCard' | 'TeamMembers' | 'TeamMembersParentPage' | 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' | 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' | 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk = { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' | 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' | 'TeamMembersWildcardPage' | 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' | 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' | 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' | 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' | 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' | 'TeamProfileCards' | 'TeamProfileCardsFolder' | 'TechzoneArticlePage' | 'Tenant' | 'TenantFolder' | 'TenantSecurityItemPointer' | 'TenantSetupRoot' | 'TertieryHeroBanner' | 'TertieryHeroBannerParametersTemplate' | 'Text' | 'TextBlock' | 'TextBlockHeadingParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 = { __typename?: 'TextBlockHeadingType' | 'TextBlockHeadingTypeFolder' | 'TextBlockLinkType' | 'TextBlockLinkTypeFolder' | 'TextBlocks' | 'TextBlocksFolder' | 'TextBlocksParametersTemplate' | 'TextFolder' | 'TextFolder_b762d56787f5493cbb480c455d834457' | 'Text_b8f5894cb4934016bf784090b0a2fd16' | 'Theme' | 'ThemeTag' | 'ThemeTagsFolder' | 'ThemingMode' | 'ThemingModes' | 'Tile' | 'TileLink' | 'TileParametersTemplate' | 'TileSizeOption' | 'TileSizeOptionFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 = { __typename?: 'TilesFolder' | 'TilesParametersTemplate' | 'Title' | 'Title_a82e893105754175917de904ef7e6dbe' | 'Toggle' | 'ToggleFolder' | 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' | 'Transformation' | 'TrustArticleHeroParametersTemplate' | 'TrustFinder' | 'TrustFinderFilterOption' | 'TrustRegion' | 'TrustType' | 'TrustTypesFolder' | 'Twitter' | 'TwitterApp' | 'TwitterApps' | 'TwitterFolder' | 'TwitterParametersTemplate' | 'TwitterSettings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w = { __typename?: 'UnknownItem' | 'UnminifiedFile' | 'UpgradeScript' | 'UpgradeScriptLibrary' | 'VariantComponentField' | 'VariantDateField' | 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' | 'VariantPlaceholder' | 'VariantReference' | 'VariantSection' | 'VariantTemplate' | 'VariantText' | 'VariantToken' | 'Variants' | 'VectorFolder' | 'VectorTile' | 'VectorTileLink' | 'VectorTilesFolder' | 'VectorTilesParametersTemplate' | 'Version_95ebc23204774dc38ad3465d5fe8da2f' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU = { __typename?: 'Video' | 'VideoCountOption' | 'VideoCountOptions' | 'VideoFolder' | 'VideoFolder_bba49474673e468186ba8b1a20e067a9' | 'VideoPage' | 'VideoParameters' | 'VideoParametersTemplate' | 'VideoPressReleasePage' | 'Video_4bc649610a894242be2dc5026090cf49' | '_AssetsOptimization' | '_BackgroundImage' | '_CompatibleThemes' | '_CompositeTheme' | '_CustomMetadata' | '_CustomRenderingViewPath' | '_DatasourceBehaviour' | '_Favicon' | '_FormsFolderLocation' | '_FundSettings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 = { __typename?: '_HasValidUrlName' | '_LocalDataLink' | '_Login' | '_OpenGraphMetadata' | '_PageDesignTheme' | '_PageSearchScope' | '_SearchCriteria' | '_SearchableWithoutRelatedItems' | '_SeoMetadata' | '_SiteTheme' | '_SitemapSettings' | '_StickyNote' | '_Styleable' | '_TwitterMetadata' | '_Webinar' | '_WildcardSource' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ArticleTag = (
  { __typename?: 'ArticleTag' }
  & { name: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ArticleTag_name_TextField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems = ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_dxYboWowVqXyFEQIHTW4KbhL0lHEcueHzhBbeD0999E | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_PnwaseAlIGIXnxiuLSPaWKSThHdZCaYYv4GPnTc4U | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_5Bp8CGD6gBt5zmgrKJRqS8sSurv5NB60wKLFzTr1j8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_vgM8szlOwwreWnyZ96extC1BJblr1vJelIcjuF6Tw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_shlDQDRBXfEV2IMt8Q7OnzROWrVF0nQMSI8rkrSZU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_0SYpviiyXX3BRforwncXG3pexVXYcIm4fmQoeSPcK4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_JuL8MVaWzToSlJIakCO1bigqoAcm1EGyklGo3wRrRLw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_aqw7j7oAQM5GJ9oIWaOAyiGli5atrgfmQJoQe8rDt4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_jWiNNE8wAezwjVLEWn3IRc7x4WY9EKiEuZpBROPG4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_BfCZy14f5vCYoKPvUvlJVRkotuL1gmUwjkgrggQ05A | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_PHLgvBFZABTRngNRTYYUi9KBdwe9p7W4YDlCj72fOIs | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_KL7bf4QPLQ7mpyzzvQk5f6piwJk1PES0rcP7Uy9x0M | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_iqnu4DMOAGlC9sVDpDbjHWwyB7ysXrKwlOhFHAyC0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_umgzCXtgi1WMowaNMDJnNsdrdDP4Ie7qfWy2owTqtI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_c8gc72G7Xyo5xvM63VPyvhGmiUxe0BFuVTVAj9su0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_VtfJ6wYpLDTemXJEIB7XJw2duFCBCMgGB8vlYx6hsc0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_1BpmAGsjLrkU4cexVLSJ4OyM81tByZRfH3Rlj3t6CE | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_NyEECiwuus0IEb5R3ZHyvXsBaUAVp6zWfQGtLdoaAU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_Fj4L99iVJxbVnFn7srvABth7WlFSHNzZENorwzE | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ANdBVC6KFTlUcJhSibUfyWTFtLta5lsMUp9qlxcVurI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_xbvRLMKOfZhwK7StDx4pk8GufekPnO6TlKVuKDWc0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_C7jD2H7yOuHKbYSq1WvlnNO2zZ9k33Tt60j7wVs4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_6hn5PudNLAFVxgpoCeIRzlxkBlB8a1pSQwG8cmE | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_u7BRZVBhheosXLCSBWQJBOivuyXVuOOaFBBIAa5UQdc | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_dpqtGMeZVSGVIy9q5ldacew1cWo2gELfnm77xVZDIg | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_lalHkBPxpftIF8HuYXqfDXnzifCeKVwttYezsBbL6A | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_Q9MXc9RjR2M267DgK6zxTNUiUi6NIPijp0dZLLIgk | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_dMUje5zuPQ5cTfsHsP483FXiZjLZOp5y7mQEffnH1xw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_hb7aIiGiWMscK3W1w04Vy90EkNWrFzDyfbrTjKcNK2s | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_mlJlKCHse9oAGb81rXrwxNMBDoalRluBpSZ2wf1jcU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_bpyH1qQmSBBKUyiskmVf3nBxPfFJ3ja7QnVcUd6KZro | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems_ArticleTag;

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField = (
  { __typename?: 'MultilistField' }
  & { targetItems: Types.Maybe<Array<Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField_targetItems>>> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_duration_IntegerField = (
  { __typename?: 'IntegerField' }
  & Pick<Types.IntegerField, 'value'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___ExternalArticle_articleUrl_LinkField = (
  { __typename?: 'LinkField' }
  & Pick<Types.LinkField, 'url'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Podcast_duration_IntegerField = (
  { __typename?: 'IntegerField' }
  & Pick<Types.IntegerField, 'value'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Video_duration_IntegerField = (
  { __typename?: 'IntegerField' }
  & Pick<Types.IntegerField, 'value'>
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM = { __typename?: 'Accordion' | 'AccordionFolder' | 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' | 'AccordionItem' | 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' | 'AccordionParametersTemplate' | 'AccordionPresentation' | 'AccordionPresentationFolder' | 'Accordion_02d060598cc14423a9ac9ff2365176b7' | 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' | 'AddItem' | 'AddItem_1e1b739ec3784909941d171aca7362e5' | 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' | 'AddItem_de8c75222f3241288f20342f479894eb' | 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' | 'AddThisParameters' | 'AggregatedFacetFilter' | 'AlertMessage' | 'AlertMessageFolder' | 'AlertMessageParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_wfDPLl23dLb7kIKKAtoHNJmSxbeOaFz8xo6iy1TKtKo = { __typename?: 'AlertMessageType' | 'AllertMessageTypeFolder' | 'Archive' | 'ArticleAuthor' | 'ArticleAuthorsFolder' | 'ArticleCategoriesFolder' | 'ArticleCategory' | 'ArticleChapter' | 'ArticleChapters' | 'ArticleContentType' | 'ArticleContentTypesFolder' | 'ArticleFilter' | 'ArticleFilterOption' | 'ArticleFootnote' | 'ArticleFootnoteLink' | 'ArticleFootnoteText' | 'ArticleInfogramTile' | 'ArticleInfogramTileParametersTemplate' | 'ArticleRegion' | 'ArticleRegionsFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_9VPlmQkQdt9l4maQ46Z5fMhr5w16NSqTADFDI2lIY9Q = { __typename?: 'ArticleSearchPage' | 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' | 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' | 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' | 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' | 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' | 'ArticleSeriesCollection' | 'ArticleSeriesFolder' | 'ArticleSettings' | 'ArticleSubscriptionBanner' | 'ArticleSubscriptionBannerFolder' | 'ArticleTag' | 'ArticleTagsFolder' | 'ArticleTeamAuthor' | 'ArticleTileParametersTemplate' | 'ArticleTilesParametersTemplate' | 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' | 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' | 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' | 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_5Bp8CGD6gBt5zmgrKJRqS8sSurv5NB60wKLFzTr1j8 = { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' | 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' | 'ArticlesGroupFolder' | 'AttachThemeExtension' | 'AutomaticDocumentListings' | 'AutomaticDocumentListingsFolder' | 'AvailableJSONRenderings' | 'AvailableMetaRenderings' | 'AvailableRenderings' | 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' | 'AwardsBanner' | 'AwardsBannerFolder' | 'AwardsBannerImage' | 'AwardsBannerParametersTemplate' | 'BYOCWrapperRenderingParameters' | 'BackgroundColorOption' | 'BackgroundColorOptionFolder' | 'BannerFolder' | 'BannerType' | 'BannerTypeFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_vgM8szlOwwreWnyZ96extC1BJblr1vJelIcjuF6Tw = { __typename?: 'BaseHeading' | 'BaseHeadingFolder' | 'BoolFacet' | 'BranchesFolder' | 'Breadcrumb' | 'BrowserTitleDefinition' | 'CORSEntry' | 'CORSGrouping' | 'CTAPresentationType' | 'CTAPresentationTypeFolder' | 'C__AbrdnPage' | 'C__ActionBase' | 'C__AdvancedParameter' | 'C__App' | 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' | 'C__ArticleWildcardPage' | 'C__AvailableRenderingsFolder' | 'C__BYOCRenderingParameters' | 'C__BackgroundParametersTemplate' | 'C__BaseCTA' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_shlDQDRBXfEV2IMt8Q7OnzROWrVF0nQMSI8rkrSZU = { __typename?: 'C__BasePage' | 'C__BasePage_037da552a5524fe4aeee331f57ac1378' | 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' | 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' | 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' | 'C__BasePage_728c97b5c56146d9807e21018a972bb5' | 'C__BasePage_6105875085f346729dfc8d133b481f26' | 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' | 'C__BaseRenderingParameters' | 'C__BaseTheme' | 'C__BaseVariantField' | 'C__Class' | 'C__CompositeGroup' | 'C__CompositeSection' | 'C__EloquaForm' | 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' | 'C__ExtendedOptions' | 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' | 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' | 'C__FEaaSRenderingParameters' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_0SYpviiyXX3BRforwncXG3pexVXYcIm4fmQoeSPcK4 = { __typename?: 'C__FacetSelectorConfigBase' | 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' | 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' | 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' | 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' | 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' | 'C__GlobalDatasourceBehavior' | 'C__GridDefinition' | 'C__GridItemBase' | 'C__GridParameters' | 'C__HeadlessSite' | 'C__HeadlessTenant' | 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' | 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' | 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' | 'C__IAllowEmpty' | 'C__IBaseVariantDefinition' | 'C__IBoosting' | 'C__ICacheable' | 'C__ICompatibleRenderings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_JuL8MVaWzToSlJIakCO1bigqoAcm1EGyklGo3wRrRLw = { __typename?: 'C__IComponentVariant' | 'C__IControlType' | 'C__IDynamicPlaceholder' | 'C__IFEaaSComponentsDataSourceTemplates' | 'C__IFEaaSComponentsEditorScriptURL' | 'C__IIcon' | 'C__ILocation' | 'C__IPaginable' | 'C__IPagination' | 'C__IPoi' | 'C__IRenderingId' | 'C__ISplitter' | 'C__IStyling' | 'C__IVariantDefinition' | 'C__InvestmentTrustPage' | 'C__JSONField' | 'C__JSONReference' | 'C__JSSData' | 'C__JSSSettings' | 'C__JSSSiteFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_aqw7j7oAQM5GJ9oIWaOAyiGli5atrgfmQJoQe8rDt4 = { __typename?: 'C__JssRootFolder' | 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' | 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' | 'C__Page' | 'C__PageData' | 'C__PageDesignFolder' | 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' | 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' | 'C__PartialDesign' | 'C__PartialDesignFolder' | 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' | 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' | 'C__PlaceholderWrapper' | 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' | 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' | 'C__RedirectMapGrouping' | 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' | 'C__Route' | 'C__SimpleVideo' | 'C__SiteSettingsFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Re1euv9drVm0NohuqiMcKyycP5ujAaDiSSznEjEAeZI = { __typename?: 'C__SitemapSettings' | 'C__StandardTemplate' | 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' | 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' | 'C__TrustFolder' | 'C__VariantDefinition' | 'C__VariantField' | 'C__VariantsGrouping' | 'C___AdvancedItem' | 'C___Arguments' | 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' | 'C___ArticlePageWorkflow' | 'C___ArticleSearchPage' | 'C___ArticleWildcard' | 'C___AssetServiceThemeMode' | 'C___BaseDataFolder' | 'C___BaseHelpArticle' | 'C___BaseInvestmentTrust' | 'C___BaseJSSTenant' | 'C___BasePage' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_PD2OTV2TMoKDBDNAm0pRi8GwkTe63L3MQsnRVuM8 = { __typename?: 'C___BasePageDesign' | 'C___BasePageDesignFolder' | 'C___BasePartialDesign' | 'C___BasePartialDesignFolder' | 'C___BasePlaceholder' | 'C___BasePlaceholderSettingsFolder' | 'C___BasePresentation' | 'C___BasePressRelease' | 'C___BaseRenderingParameters' | 'C___BaseSXAStandardValuesFolder' | 'C___BaseSettings' | 'C___BaseSharedSitesSettings' | 'C___BaseSiteDefinition' | 'C___BaseSiteFolder' | 'C___BaseSiteGrouping' | 'C___BaseSiteRoot' | 'C___BaseTenant' | 'C___BaseTenantFolder' | 'C___BucketRules' | 'C___CORS' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_6oyewowwUP6ipRwmNQvI1DW4rTZIn8bnts1NNM8ij0 = { __typename?: 'C___Content' | 'C___ContentType' | 'C___DataAttributes' | 'C___DatasourceWorkflow' | 'C___Dependencies' | 'C___Description' | 'C___DesignTemplateMapping' | 'C___Designable' | 'C___EditType' | 'C___EditType_8a9f84baaa124c5d9096935714809da4' | 'C___EditingTheme' | 'C___Enabled' | 'C___ErrorHandling' | 'C___Fields' | 'C___FilteredArticlesParent' | 'C___FilteredArticlesWildcard' | 'C___Footnotes' | 'C___FundDetailsWildcard' | 'C___FundFormAvailability' | 'C___FundMetadataPage' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_GNmq3n3K2USwuX4z0UZC47JUgWQnvhJSP6nXbATy4Ao = { __typename?: 'C___FundSearchPage' | 'C___FundsFolder' | 'C___FundsFormsFolder' | 'C___FundsLiteratureFolder' | 'C___FundsShareclassesDetailsWildcard' | 'C___GridMapping' | 'C___HelpArticle' | 'C___HelpArticleSearchPage' | 'C___HelpArticleWildcard' | 'C___HorizonDatasourceGrouping' | 'C___Icon' | 'C___IncludeByDefault' | 'C___IncludeIfInstalled' | 'C___InternetExplorerCompatibilityMode' | 'C___IsSystemModule' | 'C___JSONVariantPaging' | 'C___JSONVariantsBase' | 'C___LimitedDisplay' | 'C___LinkAttributes' | 'C___LinkSettings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Ux6JLRdfh0GjkvqEdcUVw5SqtzInlZEOcNOjGWbCg = { __typename?: 'C___LiteratureHubSearchPage' | 'C___ManualKeyInformation' | 'C___MemberOf' | 'C___MetadataPage' | 'C___Modules' | 'C___Name' | 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' | 'C___Name_299cdb154745448a807868d401248eaa' | 'C___Name_b88cf88159a54a19991e71038751cb60' | 'C___Navigable' | 'C___NavigablePage' | 'C___PageContent' | 'C___PageWorkflow' | 'C___PerSiteStandardValues' | 'C___PodcastPressRelease' | 'C___PremiumContentPage' | 'C___PressRelease' | 'C___PressReleaseContentType' | 'C___PressReleaseSearchPage' | 'C___PressReleaseWildcard' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_XT7btXTP1S1wiJya967DqOnGw5ThfdAKBWgQbeFJdnI = { __typename?: 'C___ProtectedTheme' | 'C___PublishingGroupingTemplate' | 'C___RenderingRelatedParameters' | 'C___RenderingVariantsBase' | 'C___RenderingsList' | 'C___RobotsContent' | 'C___RoleDomain' | 'C___RoleName' | 'C___RoleType' | 'C___SalesforceCommonValidations' | 'C___SalesforceFieldId' | 'C___SalesforceFieldTitle' | 'C___SalesforceFieldValue' | 'C___Script' | 'C___SearchSignature' | 'C___Searchable' | 'C___SecurityItemPointer' | 'C___SharedArticles' | 'C___SharedContent' | 'C___SharedHelpArticles' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Sb8Hd1k0UXqZaj47DUjcflpTJwTJEfe104Gzw7gO4 = { __typename?: 'C___SharedPage' | 'C___SharedPressReleases' | 'C___SharedRoot' | 'C___SharedSettings' | 'C___SiteContent' | 'C___SiteFolder' | 'C___SiteMediaLibrary' | 'C___SiteSettings' | 'C___SiteTemplate' | 'C___SitecoreClientSiteManaging' | 'C___Sitemap' | 'C___SitemapMediaItems' | 'C___SlidersRangeSettings' | 'C___SolutionTemplateContent' | 'C___SolutionTemplateDescription' | 'C___SolutionTemplateName' | 'C___SortOrder' | 'C___StackBreakpoint' | 'C___Statistics' | 'C___SupportedLanguages' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ELlhLVLHa1ObteM0Zf1CEhTb2AaKo0jzPPIooMTDyc = { __typename?: 'C___Taggable' | 'C___TeamMembersParentPage' | 'C___TeamMembersWildcard' | 'C___Template' | 'C___Title' | 'C___Type' | 'C___Validation' | 'C___VariantPaging' | 'C___VectorTile' | 'C___VectorTileLink' | 'C___VideoPressRelease' | 'C___Width' | 'C___WildcardPage' | 'CacheSetting' | 'Caching_26fce9bf0256458d8281a713a5bf5520' | 'CalendarEvent' | 'CallOutSection' | 'CallOutSectionDropdownOption' | 'CallOutSectionFolder' | 'CallOutSectionParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Vzulctr4vbcm4GoMFUEvTnDDXxqlSt79ktwvhAcSk = { __typename?: 'CallToAction' | 'CallToActionFolder' | 'CapabilitiesFolder' | 'Capability' | 'CapabilityMap' | 'CapabilityMappings' | 'Carousel' | 'CarouselFolder' | 'CarouselSlide' | 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' | 'Checkbox' | 'ChecklistFilter' | 'ChecklistFilterFolder' | 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' | 'ColumnSplitter' | 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' | 'CompatibilityMode' | 'ComponentConfiguration' | 'ComponentThemeConfiguration' | 'ComponentThemesConfiguration' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_QMkGvqOoCDiGGc1zfoz0p3Z0g5zsPi4KwOiPEAIZg = { __typename?: 'ComponentsConfigurations' | 'ConfigurationFolder' | 'Container' | 'ContainerOption' | 'ContainerOptionsFolder' | 'ContainerParametersTemplate' | 'Container_45130bdbbae34edcaea87b68b9d94c7f' | 'ContentBlock' | 'ContentBlockFolder' | 'ContentToken' | 'ContentTokenFolder' | 'ContentType' | 'CorporateTheme' | 'CorporateThemesFolder' | 'Country' | 'CountryISOCode' | 'CountryISOCodesFolder' | 'CustomerReviewFolder' | 'CustomerReviewTile' | 'CustomerReviewTileParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_NHRIFTGboCJvjMw0rDR9t8ZOf9NfaVLhXXP6v51YM = { __typename?: 'DataBridgeDocumentCategoryMap' | 'DataBridgeFund' | 'DataBridgeFundRangeName' | 'DataBridgeSettingsFolder' | 'DataBridgeShareClass' | 'DataFolder' | 'DatasourceConfiguration' | 'DatasourceConfigurations' | 'DatasourceWorkflowAction' | 'DateFacet' | 'DateFilter' | 'DateFilterFolder' | 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' | 'DefaultColumnLayout' | 'DefaultShareclassMapping' | 'DefaultShareclassMappings' | 'DescriptiveHighlight' | 'DescriptiveHighlightFolder' | 'DescriptiveHighlightItem' | 'DescriptiveHighlightParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_igBe5NjOT87tZQcGU22kxsWF63ZmHQTWDapee9r8uU = { __typename?: 'Device' | 'Device_7c27ec70f42e40428a0fabaa2f8eda18' | 'Devices' | 'DictionaryFolder' | 'DisqusParameters' | 'DistanceFacet' | 'Divider' | 'DocumentItem' | 'DocumentListings' | 'DocumentListingsFolder' | 'DocumentTypeFolder' | 'DominantLanguageMapping' | 'Dropdown' | 'DropdownFilter' | 'DropdownFilterFolder' | 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' | 'EditEditingTheme' | 'EditFrame' | 'EditModePanel' | 'EditSiteItem' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_WGoF5OPQ2m1jrQRj6nfitfA8H3fOONjaDJERvzVrHQ = { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' | 'EditSiteTheme' | 'EditTenantTemplate' | 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' | 'EditType' | 'EloquaFormFolder' | 'EloquaFundForm' | 'Enum' | 'Enums' | 'ErrorPage' | 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' | 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' | 'ErrorPage_45d797cc048740ffb693214883ff35c2' | 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' | 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' | 'EventCalendarParameters' | 'EventList' | 'EventListParameters' | 'EventTypes' | 'EventsFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Eb2ZND2WgqWO0sWHMoQzbEvwEAmoeev4JlJSjX7cE = { __typename?: 'ExecuteScript' | 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' | 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' | 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' | 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' | 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' | 'ExtendSiteTheme' | 'ExternalLiterature' | 'FEaaSWrapperRenderingParameters' | 'FacebookCommentsParametersTemplate' | 'FacetSlider' | 'FacetSliderFolder' | 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' | 'FacetSummary' | 'FacetSummaryFolder' | 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' | 'FacetsGrouping' | 'FakeNavigationItem' | 'FeatureBanner' | 'FeatureBannerParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_xgsdtrwXG1jD0R5oCadCWlXjHfMiv1Dwr1EFlNvo = { __typename?: 'FeaturedArticles' | 'FeaturedArticlesFolder' | 'FeaturedTheme' | 'FeaturedThemesFolder' | 'Feed' | 'FeedFolder' | 'FeedParameters' | 'FieldEditor' | 'FieldRenderer' | 'FileList' | 'FileListFolder' | 'FileListParametersTemplate' | 'File_04129321770849c1801baee196e1c0a8' | 'FilterCriteria' | 'FilterCriteriaFolder' | 'FilterTaxonomyOption' | 'FilterTaxonomyOptions' | 'FilteredArticlesParentPage' | 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' | 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_0g8bqGGWq2Q3G6xB1FCohEHGqwmlAgfNH3AAVDRzHA = { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' | 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' | 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' | 'FilteredArticlesWildcardPage' | 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' | 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' | 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' | 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' | 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' | 'Flip' | 'FlipFolder' | 'Flip_5ef078504c044b839dafefd752cfaba8' | 'Flipside' | 'FloatFacet' | 'Footer' | 'FooterFolder' | 'FooterLink' | 'FormRenderingParameters' | 'FundAssetClass' | 'FundAssetClassesFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_kIu7OBH7HsDU0TkykDVjPVZtDhGJxjfiNpLvGi0 = { __typename?: 'FundDetailsWildcardPage' | 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' | 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' | 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' | 'FundFormsFolder' | 'FundInFocus' | 'FundInFocusShareClass' | 'FundSearchPage' | 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' | 'FundSearchPage_5806f83c03bc443380678ff955f4310f' | 'FundSearchPage_7432205c04214a419ca064c4cb37501c' | 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' | 'FundSettings' | 'FundShareclassDetailsWildcardPage' | 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' | 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' | 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' | 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' | 'FundSubAssetClass' | 'FundSubAssetClassesFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_8DFRXSrYNWYOfaBu93cS6HeobRBeXq6riLlnN1aM = { __typename?: 'FundsExternalLiteratureFolder' | 'FundsFolder' | 'FundsInFocusFolder' | 'FundsInFocusParametersTemplate' | 'FundsLiteratureFolder' | 'FundsLiteratureMappingsFolder' | 'Gallery' | 'GalleryFolder' | 'GalleryImage' | 'GalleryParametersTemplate' | 'GalleryVideo' | 'GatedAccordionContainer' | 'GlobalLanguageSelector' | 'GlobalNavigationBar' | 'GoogleAnalytics' | 'GoogleTagManager' | 'GoogleTagManagerFolder' | 'GridSetup' | 'GridTheme' | 'HTMLCode' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_bxj87Is24khLXOtvNFqbWwo0G66vp0OaMND65f1IqVI = { __typename?: 'HTMLCodeFolder' | 'HTMLInclude' | 'HTMLIncludesFolder' | 'HTMLSnippet' | 'HTMLSnippetFolder' | 'HTMLTag' | 'Header' | 'HeaderFolder' | 'Heading' | 'HeadlessSiteSetupRoot' | 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' | 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' | 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' | 'HeadlessSite_68ffa40c5aab45548f774742b163f318' | 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' | 'HeadlessSite_229484893ca144958b9937167dfb5064' | 'HeadlessSite_b28055626acc45a2913a9617398c9730' | 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' | 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' | 'HeadlessSolutionTemplateFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_LxlD1ICqasirLiHujLI8u4L6fszr3SBTG3skNJF4g = { __typename?: 'HeadlessTenantSetupRoot' | 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' | 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' | 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' | 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' | 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' | 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' | 'HeadlessTenant_94824ac390d748499e5af0275d10811f' | 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' | 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' | 'HeadlessTrustSite' | 'HeadlessVariants' | 'HeadlessVariantsGrouping' | 'HelpArticlePage' | 'HelpArticlePlatform' | 'HelpArticlePlatformMap' | 'HelpArticlePlatformMappings' | 'HelpArticlePlatformsFolder' | 'HelpArticleSearchPage' | 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_z8xUbaELBYsbHsBpdhNLcfvzHsA23xoUk1SWN9UwI = { __typename?: 'HelpArticleTag' | 'HelpArticleTagsFolder' | 'HelpArticleWildcardPage' | 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' | 'HelpArticlesGroupFolder' | 'HelpTagMap' | 'HelpTagMappings' | 'HeroBanner' | 'Highlight' | 'HighlightBlock' | 'HighlightBlockFolder' | 'HighlightBlockParametersTemplate' | 'HighlightFolder' | 'HighlightItem' | 'HighlightParametersTemplate' | 'Home' | 'HomePage' | 'HomePage_0d3963a8171d4080b5f808618578b631' | 'HomePage_6d95c7d946c74a70be07304cc73a2010' | 'HomePage_b407f259b4e34c7db9a06e8907a56b17' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_tnJgW9MQXLCfHZWBZcdx3FhUPRzUHZZqzKI4qC8EE = { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' | 'HomePage_de9353283a3e41c495ba386aed0540c6' | 'IFrame' | 'IFrameFolder' | 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' | 'IFrameParametersTemplate' | 'IFrame_0da12d476de24dfeb4d0f513489bfea1' | 'IFrame_88a6f65f2b78491bb3770b06e48883e1' | 'Icon' | 'IconFolder' | 'Image' | 'ImageFolder' | 'ImageFolder_edc00e86cef24d0cbfa264460becc323' | 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' | 'ImageParametersTemplate' | 'Image_83bc563c6320490092f8204bff81586a' | 'Image_15185b0e641844499f934ff03b7ee032' | 'Image_d885df8cb2d64007b34b2bbafb527304' | 'Infographics' | 'InfographicsFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_7vZGYm7JAiv82Af36LZLxneXdwtBRBydtW8LtxDtJk = { __typename?: 'InputValidationStep' | 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' | 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' | 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' | 'IntegerFacet' | 'IntroCopy' | 'IntroCopyFolder' | 'InvestmentTrustAssetClass' | 'InvestmentTrustAssetClassFolder' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' | 'InvestmentTrustRegion' | 'InvestmentTrustRegionFolder' | 'InvestmentTrustStyle' | 'InvestmentTrustStyleFolder' | 'InvestorType' | 'InvestorTypesFolder' | 'ItemQueriesFolder' | 'ItemRights' | 'JSBeaconSettings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_PeUj7VPcIqa2C6rMvb0wpgdFB0U0ui2MygPRE9qfVA = { __typename?: 'JSONCheckbox' | 'JSONContent' | 'JSONDate' | 'JSONFile' | 'JSONImage' | 'JSONLayout' | 'JSONList' | 'JSONMultilistReference' | 'JSONPlaceholder' | 'JSONQuery' | 'JSONResults' | 'JSONRichText' | 'JSONScriban' | 'JSONSection' | 'JSONTemplate' | 'JSONText' | 'JSONToken' | 'JSONVariantDefinition' | 'JSONVariants' | 'JSSLayout' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_qHjgnLEQIMrgoL63jG81EErlCPTS1kTl6mIuTCTDuGY = { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' | 'JSSSettings_6b328292f8314ab79885d89a054ca10a' | 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' | 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' | 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' | 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' | 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' | 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' | 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' | 'JSSSiteGrouping' | 'JSSTenantFolder' | 'JavaScriptRendering' | 'JsonRendering' | 'JurisdictionStatus' | 'JurisdictionsFolder' | 'KeyHighlightItem' | 'KeyHighlights' | 'KeyHighlightsFolder' | 'KeyHighlightsParametersTemplate' | 'Language' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_KnDL4rszGv8TD1F2Gtv9GjYTAbWcm2RJC9kDvXGw = { __typename?: 'LanguageSelector' | 'LanguagesFolder' | 'LatestPressReleasesParametersTemplate' | 'LayoutServiceVariants' | 'LimitedDisplayFolder' | 'LimitedDisplayOption' | 'Link' | 'LinkList' | 'LinkListFolder' | 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' | 'LinkList_33c9207e3b0446068ef54ca99a97c776' | 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' | 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' | 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' | 'Link_930f134d56784b35bfd1b77f9d0115f1' | 'Link_e24e0789a05848bfabb6c69c0e60b6b7' | 'LinksFolder' | 'List' | 'ListFacet' | 'ListFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Opl5cNHRdnB3yaTwFKbg1lNmQvBSPbaIir0Uuch7B8 = { __typename?: 'ListItem' | 'ListParametersTemplate' | 'ListStyle' | 'ListStyleItem' | 'ListingHeroBanner' | 'ListingHeroParametersTemplate' | 'LiteratureAuthorization' | 'LiteratureAuthorizationsFolder' | 'LiteratureHubSearchPage' | 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' | 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' | 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' | 'LoadMore' | 'LoadMoreFolder' | 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' | 'LocationFilter' | 'LocationFilterFolder' | 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' | 'Log' | 'Login' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_YixOCUVo8JKl6mVCv71yAa0lBTYyOdfqIwoNkOBQtz8 = { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' | 'LogoTextBlockItem' | 'LogoTextBlocks' | 'LogoTextBlocksFolder' | 'Logout' | 'Logout_c2294d8235a6452a94b15eb5e543b602' | 'ManagedRangeFilter' | 'ManagedRangeFilterFolder' | 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' | 'ManagedRangeItem' | 'Map' | 'MapParameters' | 'MapsFolder' | 'MapsProvider' | 'MediaBlock' | 'MediaBlockFolder' | 'MediaBlockParametersTemplate' | 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' | 'MediaLinkParameters' | 'MediaVirtualFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_jBOfYuylyWySHKuUCgZJknZuPRYz13g2FVZ4m7kUZMI = { __typename?: 'MegaNavigation' | 'MegaNavigationFolder' | 'MetaBranding' | 'MetaRenderingParameters' | 'MetadataPartialDesign' | 'Model' | 'ModelIterator' | 'MyLocationPOI' | 'Navigation' | 'NavigationCategory' | 'NavigationFilter' | 'NavigationFilterFolder' | 'NavigationLink' | 'NavigationSubcategory' | 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' | 'OneTrustSettings' | 'OptimiserConfiguration' | 'OptimiserConfigurationSection' | 'OptimizedFile' | 'OracleCDPSettings' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_usbRk2OlM5ZZpFW8ViKscaPnxg17FVuIw7r9TkaiVk = { __typename?: 'OverlayContent' | 'OverlayFolderTemplate' | 'Ownership' | 'OwnershipFolder' | 'POI' | 'POIFolder' | 'POIType' | 'POIs' | 'PageBranchesFolder' | 'PageContent' | 'PageContentFolder' | 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' | 'PageDesign' | 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' | 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' | 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' | 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' | 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' | 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' | 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_CncwPmOu1qDVWdJxq0XvMWMn14UBotb97ikFXjzg8s = { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' | 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' | 'PageDesign_1105b8f81e00426bbf1fc840742d827b' | 'PageDesigns' | 'PageDesigns_3af52e70e982424b9c85e355542500c9' | 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' | 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' | 'PageDesigns_99a71bba507746729c3fb29b04abee23' | 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' | 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' | 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' | 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' | 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' | 'PageLevelTabs' | 'PageLevelTabsFolder' | 'PageList' | 'PageSelector' | 'PageSelectorConfiguration' | 'PageSelectorFolder' | 'PageSelector_59a7bb775f8c435ab810291abde80e63' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_roNAWnZfjm0VC3FlfGlfUDGqUawbCmZH88Pf8nWdhE = { __typename?: 'PageSize' | 'PageSizeFolder' | 'PageSize_b682562e0af64b3e9e3b45273bbe152d' | 'PageTheme' | 'PageThemesFolder' | 'Page_4f49a81db3664f198b89cab92f377d7a' | 'Page_5e66d86353544fe6a27d3b894984d50f' | 'Page_84f342ad2d0646b9aa9a818201145ca2' | 'Page_718df200be51463d93edf4d77ab7a49e' | 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' | 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' | 'Page_dae7821153e14dbabb0ddf0b53a90aaf' | 'Page_fa608b3e6aeb426388a059d89caabada' | 'Pagging' | 'Pagination' | 'PaginationFolder' | 'Paragraph' | 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' | 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' | 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Zla3hlcSKzlkanFRu1wnd8ipNPGQD9OFUYJkY7zt8s = { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' | 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' | 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' | 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' | 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' | 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' | 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' | 'PartialDesigns' | 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' | 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' | 'PartialDesigns_36c869ded22040929ce829f6ed643c66' | 'PartialDesigns_1943dc73710a430895515a342c84b037' | 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' | 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' | 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' | 'PartialDesigns_d216303f58d8425688da8cd30d00afab' | 'PartialDesigns_facda26791204fa9a0363344348f2c42' | 'PerformanceChartSettings' | 'PerformanceChartTimePeriod' | 'PerformanceChartTimePeriodFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_sLtzdfCQiw3eXmsHo9SuM5NEORKevxzWDrtPQt4Gdk8 = { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' | 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' | 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' | 'Placeholder_1ca0304be5b64810821154426f1752c2' | 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' | 'PlainHtmlParametersTemplate' | 'Playlist' | 'PlaylistFolder' | 'PlaylistParametersTemplate' | 'Podcast' | 'PodcastFolder' | 'PodcastPressReleasePage' | 'PoiTypes' | 'PostDeleteStep' | 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' | 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' | 'PostDeleteStep_b20857895385413883f096f3767cb156' | 'PostSetupStep' | 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' | 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_EQct3IViU2c443A0IlmDETgbOnEEOPzITU93OO24k = { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' | 'PreDeleteStep' | 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' | 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' | 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' | 'PreDeleteValidationStep' | 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' | 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' | 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' | 'Presentation' | 'Presentation_0a70fa7389234a6eabf34134f25f3221' | 'PressReleaseContentType' | 'PressReleaseContentTypesFolder' | 'PressReleaseFilter' | 'PressReleasePage' | 'PressReleasePlatform' | 'PressReleasePlatformsFolder' | 'PressReleaseSearchPage' | 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' | 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_tcRunbeXnY8WTwhdmSuSqHcw2zwb7Y2E7jxdXqh7Q = { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' | 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' | 'PressReleaseWildcardPage' | 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' | 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' | 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' | 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' | 'PressReleasesGroupFolder' | 'PrivacyWarning' | 'ProjectFolder' | 'Promo' | 'PromoFolder' | 'PromoFolder_f07cbe8973ae4de692172570260cac6e' | 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' | 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' | 'Promo_dfed4457d760457abec1c0dccdc44381' | 'PromotedContent' | 'PromotedContentFolder' | 'PropertyListingCard' | 'PropertyListingCards' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_h0Tz9h9wM8abuJnRKN2fPGHzS2ZReJ9z5SKOmm315I = { __typename?: 'PropertyListingCategory' | 'PropertyListingFolder' | 'Query_98b413525a4b4067b92418a4b50f0a53' | 'QuickLinks' | 'QuickLinksFolder' | 'QuickLinksParametersTemplate' | 'QuotationBlockItem' | 'QuotationBlocks' | 'QuotationBlocksFolder' | 'QuotationBlocksParametersTemplate' | 'Quote' | 'QuoteFolder' | 'QuoteParametersTemplate' | 'RadiusFilter' | 'RadiusFilterFolder' | 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' | 'RadiusScheme' | 'RadiusSchemeValue' | 'RangeSliderFilter' | 'RangeSliderFilterFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_tbpqGjolxU3pcFczqzaC0ntUEW0NszVudqL4C4ZVsaw = { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' | 'RecentArticles' | 'Redirect' | 'RedirectMap' | 'RedirectMaps' | 'Region' | 'RegionLanguages' | 'RegionLanguagesFolder' | 'RelatedArticles' | 'RelatedArticlesParametersTemplate' | 'RenderEngineType' | 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' | 'RenderingHost' | 'ResizableIFramePage' | 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' | 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' | 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' | 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' | 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' | 'ResponsiveImage' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_uP9rp7h1pjaYcqvXUN0yz5GEfEkz9kDHrOIFDKTe8JM = { __typename?: 'ResultsCount' | 'ResultsCountFolder' | 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' | 'ResultsVariantSelector' | 'RichText' | 'RichTextFolder' | 'RichText_0f3b73366112418c8bbab0526f3887ce' | 'RichText_efcfd8f6596745f48f85b5421928205d' | 'RiskImageMapping' | 'RiskImageMappings' | 'RiskLevelOption' | 'RiskLevelOptionFolder' | 'RiskWarning' | 'RiskWarningFolder' | 'RiskWarningParametersTemplate' | 'RolePlaceholder' | 'RowSplitter' | 'RowSplitter_340c887da1d1415b9678c763af74ea97' | 'Rule' | 'SDRLogoMapping' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Tp0UzWbV6ozvpWrheVY8BGEdUjOvUh3Y9iDj7Pv1qu4 = { __typename?: 'SDRLogoMappings' | 'SDRTypeOption' | 'SDRTypeOptionFolder' | 'SXAJSSLayout' | 'SXARole' | 'SXAStandardValuesFolder' | 'SalesforceAlertMessage' | 'SalesforceCheckBox' | 'SalesforceCheckBoxType' | 'SalesforceConditionalRadioButton' | 'SalesforceConditionalRadioButtons' | 'SalesforceDateInput' | 'SalesforceDropdown' | 'SalesforceDropdownOption' | 'SalesforceHiddenField' | 'SalesforceInput' | 'SalesforceInputType' | 'SalesforceIntegratedForm' | 'SalesforceIntegratedFormTypesFolder' | 'SalesforceRepeatableSubSection' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_G8FYHCXNBRNfBYIVSbEJjoXTmu8dMJe3lUyip7oNtM = { __typename?: 'SalesforceRichTextArea' | 'SalesforceSection' | 'SalesforceSortCodeInput' | 'SalesforceSubmissionType' | 'Scope' | 'ScopesFolder' | 'Scriban' | 'Scripts' | 'SearchBox' | 'SearchBoxFolder' | 'SearchBox_1c04fd611d874590acfe9cc186865ab3' | 'SearchFolder' | 'SearchResults' | 'SearchResultsFolder' | 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' | 'SecondaryHeroBannerParametersTemplate' | 'SectionHeading' | 'SectionHeadingFolder' | 'SectionHeadingParametersTemplate' | 'SectionHeadingType' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_YO3R3dRwmJ7kf2W5RD4IriaMiMxbJzaTrBpDY0zJS4 = { __typename?: 'SectionHeadingTypeFolder' | 'SectionSelector' | 'SectionSelectorFolder' | 'SectionSelectorTab' | 'Security_33077d51ebad4d1cb4a83b79f51dba13' | 'Series' | 'SeriesFolder' | 'Settings' | 'SettingsFolder' | 'Settings_6c82caca67dc464195698faad083230e' | 'SharePriceSettings' | 'SharedArticlesFolder' | 'SharedContentFolder' | 'SharedFolder' | 'SharedHelpArticlesFolder' | 'SharedPressReleasesFolder' | 'SharedSettingsFolder' | 'SharedSitesSettings' | 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' | 'Showcase' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_y48J6UT4kIqGmztM4g2Le5OzuGTC6E9X7BDtyASV68c = { __typename?: 'ShowcaseFolder' | 'ShowcaseItem' | 'ShowcaseParametersTemplate' | 'Site' | 'SiteContentFolder' | 'SiteDefinition' | 'SiteEntryDisclaimer' | 'SiteFolder' | 'SiteGrouping' | 'SiteManagement' | 'SiteSecurityItemPointer' | 'SiteSelector' | 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' | 'SiteSetupRoot' | 'SiteTheme' | 'Site_e46f3af239fa4866a1577017c4b2a40c' | 'SitecoreFormWrapperParametersTemplate' | 'SitecoreRole' | 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' | 'SkipLink' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_rMIoPET1EZiSNJAVz7aFzOMJaTMj83sMz0sSD6k7bwY = { __typename?: 'SkipLinkParameters' | 'SkipLinksFolder' | 'Snippet' | 'SnippetItem' | 'SnippetsFolder' | 'SocialLoginWrapper' | 'SocialMediaButtons' | 'SocialMediaFolder' | 'SocialMediaShare' | 'SocialMediaTemplate' | 'SocialNetwork' | 'SocialNetworkFolder' | 'SocialNetworkLink' | 'SolutionTemplate' | 'SortResults' | 'SortResultsFolder' | 'Sorting' | 'SortingGroups' | 'SpotifyPodcast' | 'SpotifyPodcastFolder' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_YSLMB07kmzLWyezRMm3lkPsDSojo5FuGN5oGtEsy18 = { __typename?: 'StickyCTA' | 'StickyCTAFolder' | 'StickyCTAParametersTemplate' | 'StrategiesInFocusFolder' | 'StrategyInFocus' | 'Style' | 'Styles' | 'Styles_9c0dac2808aa4b44bc2153363206f6a5' | 'SubscriptionBannerParametersTemplate' | 'Tab' | 'TabItem' | 'TableOfContents' | 'TableOfContentsFolder' | 'TableOfContentsSection' | 'TableOfContentsSubsection' | 'Tabs' | 'TabsFolder' | 'Tabs_f26a9560ccf148c59542800e837caf7a' | 'Tag' | 'TagCloud' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_DNrgFsAgnIHTX8e5fZBH22tvbYXgVMUj0vltWH1RQ = { __typename?: 'TagFolder' | 'TagList' | 'TeamBiographySettings' | 'TeamListingCards' | 'TeamListingCardsFolder' | 'TeamMember' | 'TeamMemberCard' | 'TeamMembers' | 'TeamMembersParentPage' | 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' | 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' | 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' | 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' | 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' | 'TeamMembersWildcardPage' | 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' | 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' | 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' | 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' | 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_TUqbxEsNwyHbMzQeAM20w3jNDKk6PmrQjKstQjyQQ0 = { __typename?: 'TeamProfileCards' | 'TeamProfileCardsFolder' | 'Tenant' | 'TenantFolder' | 'TenantSecurityItemPointer' | 'TenantSetupRoot' | 'TertieryHeroBanner' | 'TertieryHeroBannerParametersTemplate' | 'Text' | 'TextBlock' | 'TextBlockHeadingParametersTemplate' | 'TextBlockHeadingType' | 'TextBlockHeadingTypeFolder' | 'TextBlockLinkType' | 'TextBlockLinkTypeFolder' | 'TextBlocks' | 'TextBlocksFolder' | 'TextBlocksParametersTemplate' | 'TextFolder' | 'TextFolder_b762d56787f5493cbb480c455d834457' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_DxOh7Ryvf6u19kqF1o4LQP5gu5v2jeirywFBjxO2xA = { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' | 'Theme' | 'ThemeTag' | 'ThemeTagsFolder' | 'ThemingMode' | 'ThemingModes' | 'Tile' | 'TileLink' | 'TileParametersTemplate' | 'TileSizeOption' | 'TileSizeOptionFolder' | 'TilesFolder' | 'TilesParametersTemplate' | 'Title' | 'Title_a82e893105754175917de904ef7e6dbe' | 'Toggle' | 'ToggleFolder' | 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' | 'Transformation' | 'TrustArticleHeroParametersTemplate' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_k0gLOhMzxN885S8IsLr3utZdGyu2FovkE44gp9OI = { __typename?: 'TrustFinder' | 'TrustFinderFilterOption' | 'TrustRegion' | 'TrustType' | 'TrustTypesFolder' | 'Twitter' | 'TwitterApp' | 'TwitterApps' | 'TwitterFolder' | 'TwitterParametersTemplate' | 'TwitterSettings' | 'UnknownItem' | 'UnminifiedFile' | 'UpgradeScript' | 'UpgradeScriptLibrary' | 'VariantComponentField' | 'VariantDateField' | 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' | 'VariantPlaceholder' | 'VariantReference' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_wnzIdunVljrhmZ3jYVPBD6jcv80mUuZUZD1dkD2CaPw = { __typename?: 'VariantSection' | 'VariantTemplate' | 'VariantText' | 'VariantToken' | 'Variants' | 'VectorFolder' | 'VectorTile' | 'VectorTileLink' | 'VectorTilesFolder' | 'VectorTilesParametersTemplate' | 'Version_95ebc23204774dc38ad3465d5fe8da2f' | 'Video' | 'VideoCountOption' | 'VideoCountOptions' | 'VideoFolder' | 'VideoFolder_bba49474673e468186ba8b1a20e067a9' | 'VideoParameters' | 'VideoParametersTemplate' | 'VideoPressReleasePage' | 'Video_4bc649610a894242be2dc5026090cf49' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_c0ka9idDNEoiruObD5sYxkjFaMQJrrqGaIMRaXjY = { __typename?: '_AssetsOptimization' | '_BackgroundImage' | '_CompatibleThemes' | '_CompositeTheme' | '_CustomMetadata' | '_CustomRenderingViewPath' | '_DatasourceBehaviour' | '_Favicon' | '_FormsFolderLocation' | '_FundSettings' | '_HasValidUrlName' | '_LocalDataLink' | '_Login' | '_OpenGraphMetadata' | '_PageDesignTheme' | '_PageSearchScope' | '_SearchCriteria' | '_SearchableWithoutRelatedItems' | '_SeoMetadata' | '_SiteTheme' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_bBgnQn31LkCCidBLC8sMRJ0sT2sblsnxni9ypENzM = { __typename?: '_SitemapSettings' | '_StickyNote' | '_Styleable' | '_TwitterMetadata' | '_WildcardSource' };

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleTags: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField>, duration: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_duration_IntegerField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Article = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleTags: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField>, duration: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_duration_IntegerField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___BaseArticle = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___ExternalArticle = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleUrl: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___ExternalArticle_articleUrl_LinkField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___InternalArticle = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleTags: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Podcast = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleTags: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField>, duration: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Podcast_duration_IntegerField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___TechzoneArticle = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleUrl: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___ExternalArticle_articleUrl_LinkField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Video = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleTags: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField>, duration: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Video_duration_IntegerField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_PodcastPage = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleTags: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField>, duration: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Podcast_duration_IntegerField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_TechzoneArticlePage = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleUrl: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___ExternalArticle_articleUrl_LinkField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_VideoPage = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleTags: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField>, duration: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Video_duration_IntegerField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results__Webinar = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate, articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, articleTags: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField> }
);

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results = ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_wfDPLl23dLb7kIKKAtoHNJmSxbeOaFz8xo6iy1TKtKo | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_9VPlmQkQdt9l4maQ46Z5fMhr5w16NSqTADFDI2lIY9Q | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_5Bp8CGD6gBt5zmgrKJRqS8sSurv5NB60wKLFzTr1j8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_vgM8szlOwwreWnyZ96extC1BJblr1vJelIcjuF6Tw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_shlDQDRBXfEV2IMt8Q7OnzROWrVF0nQMSI8rkrSZU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_0SYpviiyXX3BRforwncXG3pexVXYcIm4fmQoeSPcK4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_JuL8MVaWzToSlJIakCO1bigqoAcm1EGyklGo3wRrRLw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_aqw7j7oAQM5GJ9oIWaOAyiGli5atrgfmQJoQe8rDt4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Re1euv9drVm0NohuqiMcKyycP5ujAaDiSSznEjEAeZI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_PD2OTV2TMoKDBDNAm0pRi8GwkTe63L3MQsnRVuM8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_6oyewowwUP6ipRwmNQvI1DW4rTZIn8bnts1NNM8ij0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_GNmq3n3K2USwuX4z0UZC47JUgWQnvhJSP6nXbATy4Ao | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Ux6JLRdfh0GjkvqEdcUVw5SqtzInlZEOcNOjGWbCg | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_XT7btXTP1S1wiJya967DqOnGw5ThfdAKBWgQbeFJdnI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Sb8Hd1k0UXqZaj47DUjcflpTJwTJEfe104Gzw7gO4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ELlhLVLHa1ObteM0Zf1CEhTb2AaKo0jzPPIooMTDyc | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Vzulctr4vbcm4GoMFUEvTnDDXxqlSt79ktwvhAcSk | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_QMkGvqOoCDiGGc1zfoz0p3Z0g5zsPi4KwOiPEAIZg | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_NHRIFTGboCJvjMw0rDR9t8ZOf9NfaVLhXXP6v51YM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_igBe5NjOT87tZQcGU22kxsWF63ZmHQTWDapee9r8uU | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_WGoF5OPQ2m1jrQRj6nfitfA8H3fOONjaDJERvzVrHQ | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Eb2ZND2WgqWO0sWHMoQzbEvwEAmoeev4JlJSjX7cE | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_xgsdtrwXG1jD0R5oCadCWlXjHfMiv1Dwr1EFlNvo | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_0g8bqGGWq2Q3G6xB1FCohEHGqwmlAgfNH3AAVDRzHA | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_kIu7OBH7HsDU0TkykDVjPVZtDhGJxjfiNpLvGi0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_8DFRXSrYNWYOfaBu93cS6HeobRBeXq6riLlnN1aM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_bxj87Is24khLXOtvNFqbWwo0G66vp0OaMND65f1IqVI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_LxlD1ICqasirLiHujLI8u4L6fszr3SBTG3skNJF4g | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_z8xUbaELBYsbHsBpdhNLcfvzHsA23xoUk1SWN9UwI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_tnJgW9MQXLCfHZWBZcdx3FhUPRzUHZZqzKI4qC8EE | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_7vZGYm7JAiv82Af36LZLxneXdwtBRBydtW8LtxDtJk | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_PeUj7VPcIqa2C6rMvb0wpgdFB0U0ui2MygPRE9qfVA | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_qHjgnLEQIMrgoL63jG81EErlCPTS1kTl6mIuTCTDuGY | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_KnDL4rszGv8TD1F2Gtv9GjYTAbWcm2RJC9kDvXGw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Opl5cNHRdnB3yaTwFKbg1lNmQvBSPbaIir0Uuch7B8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_YixOCUVo8JKl6mVCv71yAa0lBTYyOdfqIwoNkOBQtz8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_jBOfYuylyWySHKuUCgZJknZuPRYz13g2FVZ4m7kUZMI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_usbRk2OlM5ZZpFW8ViKscaPnxg17FVuIw7r9TkaiVk | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_CncwPmOu1qDVWdJxq0XvMWMn14UBotb97ikFXjzg8s | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_roNAWnZfjm0VC3FlfGlfUDGqUawbCmZH88Pf8nWdhE | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Zla3hlcSKzlkanFRu1wnd8ipNPGQD9OFUYJkY7zt8s | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_sLtzdfCQiw3eXmsHo9SuM5NEORKevxzWDrtPQt4Gdk8 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_EQct3IViU2c443A0IlmDETgbOnEEOPzITU93OO24k | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_tcRunbeXnY8WTwhdmSuSqHcw2zwb7Y2E7jxdXqh7Q | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_h0Tz9h9wM8abuJnRKN2fPGHzS2ZReJ9z5SKOmm315I | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_tbpqGjolxU3pcFczqzaC0ntUEW0NszVudqL4C4ZVsaw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_uP9rp7h1pjaYcqvXUN0yz5GEfEkz9kDHrOIFDKTe8JM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_Tp0UzWbV6ozvpWrheVY8BGEdUjOvUh3Y9iDj7Pv1qu4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_G8FYHCXNBRNfBYIVSbEJjoXTmu8dMJe3lUyip7oNtM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_YO3R3dRwmJ7kf2W5RD4IriaMiMxbJzaTrBpDY0zJS4 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_y48J6UT4kIqGmztM4g2Le5OzuGTC6E9X7BDtyASV68c | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_rMIoPET1EZiSNJAVz7aFzOMJaTMj83sMz0sSD6k7bwY | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_YSLMB07kmzLWyezRMm3lkPsDSojo5FuGN5oGtEsy18 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_DNrgFsAgnIHTX8e5fZBH22tvbYXgVMUj0vltWH1RQ | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_TUqbxEsNwyHbMzQeAM20w3jNDKk6PmrQjKstQjyQQ0 | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_DxOh7Ryvf6u19kqF1o4LQP5gu5v2jeirywFBjxO2xA | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_k0gLOhMzxN885S8IsLr3utZdGyu2FovkE44gp9OI | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_wnzIdunVljrhmZ3jYVPBD6jcv80mUuZUZD1dkD2CaPw | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_c0ka9idDNEoiruObD5sYxkjFaMQJrrqGaIMRaXjY | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_bBgnQn31LkCCidBLC8sMRJ0sT2sblsnxni9ypENzM | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Article | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___BaseArticle | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___ExternalArticle | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___InternalArticle | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Podcast | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___TechzoneArticle | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Video | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_PodcastPage | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_TechzoneArticlePage | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_VideoPage | ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results__Webinar;

export type ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults = (
  { __typename?: 'ItemSearchResults' }
  & Pick<Types.ItemSearchResults, 'total'>
  & { pageInfo: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_pageInfo_PageInfo, results: Array<Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results>> }
);

export type ArticleSearchRelatedByDatasourceQuery_Query = (
  { __typename?: 'Query' }
  & { search: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults> }
);


export type ArticleSearchRelatedByDatasourceQueryVariables = Types.Exact<{
  pageSize: Types.Scalars['Int']['input'];
  predicates: Types.ItemSearchPredicateInput;
  after: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ArticleSearchRelatedByDatasourceQuery = ArticleSearchRelatedByDatasourceQuery_Query;

export type ItemFields_Accordion_Fragment = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AccordionFolder_Fragment = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6_Fragment = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AccordionItem_Fragment = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AccordionItem_8cf671721b2d489e809f4c23db5ab2da_Fragment = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AccordionParametersTemplate_Fragment = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AccordionPresentation_Fragment = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AccordionPresentationFolder_Fragment = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Accordion_02d060598cc14423a9ac9ff2365176b7_Fragment = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1_Fragment = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AddItem_Fragment = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AddItem_1e1b739ec3784909941d171aca7362e5_Fragment = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AddItem_3aea335cd06d45b1841acbc8d2d1ce40_Fragment = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AddItem_De8c75222f3241288f20342f479894eb_Fragment = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AddItem_Ea8a3f269ccd443a95f571b868a94bd0_Fragment = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AddThisParameters_Fragment = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AggregatedFacetFilter_Fragment = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AlertMessage_Fragment = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AlertMessageFolder_Fragment = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AlertMessageParametersTemplate_Fragment = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AlertMessageType_Fragment = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AllertMessageTypeFolder_Fragment = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Archive_Fragment = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleAuthor_Fragment = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleAuthorsFolder_Fragment = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleCategoriesFolder_Fragment = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleCategory_Fragment = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleChapter_Fragment = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleChapters_Fragment = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleContentType_Fragment = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleContentTypesFolder_Fragment = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleFilter_Fragment = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleFilterOption_Fragment = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleFootnote_Fragment = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleFootnoteLink_Fragment = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleFootnoteText_Fragment = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleInfogramTile_Fragment = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleInfogramTileParametersTemplate_Fragment = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticlePage_Fragment = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleRegion_Fragment = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleRegionsFolder_Fragment = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSearchPage_Fragment = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c_Fragment = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2_Fragment = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSearchPage_Be414ff574ac4203abb2694811443e25_Fragment = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c_Fragment = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907_Fragment = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSeriesCollection_Fragment = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSeriesFolder_Fragment = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSettings_Fragment = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSubscriptionBanner_Fragment = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleSubscriptionBannerFolder_Fragment = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleTag_Fragment = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleTagsFolder_Fragment = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleTeamAuthor_Fragment = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleTileParametersTemplate_Fragment = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleTilesParametersTemplate_Fragment = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f_Fragment = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8_Fragment = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca_Fragment = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c_Fragment = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleWildcardPage_405b20252077400383d3b47f09f88b47_Fragment = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b_Fragment = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ArticlesGroupFolder_Fragment = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AttachThemeExtension_Fragment = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AutomaticDocumentListings_Fragment = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AutomaticDocumentListingsFolder_Fragment = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AvailableJsonRenderings_Fragment = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AvailableMetaRenderings_Fragment = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AvailableRenderings_Fragment = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb_Fragment = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AwardsBanner_Fragment = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AwardsBannerFolder_Fragment = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AwardsBannerImage_Fragment = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_AwardsBannerParametersTemplate_Fragment = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ByocWrapperRenderingParameters_Fragment = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BackgroundColorOption_Fragment = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BackgroundColorOptionFolder_Fragment = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BannerFolder_Fragment = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BannerType_Fragment = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BannerTypeFolder_Fragment = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BaseHeading_Fragment = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BaseHeadingFolder_Fragment = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BoolFacet_Fragment = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BranchesFolder_Fragment = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Breadcrumb_Fragment = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_BrowserTitleDefinition_Fragment = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CorsEntry_Fragment = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CorsGrouping_Fragment = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CtaPresentationType_Fragment = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CtaPresentationTypeFolder_Fragment = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__AbrdnPage_Fragment = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ActionBase_Fragment = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__AdvancedParameter_Fragment = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__App_Fragment = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c_Fragment = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ArticleWildcardPage_Fragment = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__AvailableRenderingsFolder_Fragment = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ByocRenderingParameters_Fragment = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BackgroundParametersTemplate_Fragment = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BaseCta_Fragment = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BasePage_Fragment = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BasePage_037da552a5524fe4aeee331f57ac1378_Fragment = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f_Fragment = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BasePage_315fd21bebf04c9d9f00bae191442f1d_Fragment = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd_Fragment = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BasePage_728c97b5c56146d9807e21018a972bb5_Fragment = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BasePage_6105875085f346729dfc8d133b481f26_Fragment = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b_Fragment = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BaseRenderingParameters_Fragment = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BaseTheme_Fragment = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__BaseVariantField_Fragment = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__Class_Fragment = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__CompositeGroup_Fragment = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__CompositeSection_Fragment = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__EloquaForm_Fragment = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d_Fragment = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ExtendedOptions_Fragment = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ExtendedOptions_2964fb4257a6440fb192218443904c90_Fragment = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160_Fragment = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__FEaaSRenderingParameters_Fragment = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__FacetSelectorConfigBase_Fragment = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845_Fragment = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b_Fragment = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303_Fragment = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5_Fragment = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc_Fragment = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__GlobalDatasourceBehavior_Fragment = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__GridDefinition_Fragment = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__GridItemBase_Fragment = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__GridParameters_Fragment = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__HeadlessSite_Fragment = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__HeadlessTenant_Fragment = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b_Fragment = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d_Fragment = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d_Fragment = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IAllowEmpty_Fragment = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IBaseVariantDefinition_Fragment = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IBoosting_Fragment = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ICacheable_Fragment = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ICompatibleRenderings_Fragment = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IComponentVariant_Fragment = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IControlType_Fragment = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IDynamicPlaceholder_Fragment = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IfEaaSComponentsDataSourceTemplates_Fragment = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IfEaaSComponentsEditorScriptUrl_Fragment = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IIcon_Fragment = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ILocation_Fragment = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IPaginable_Fragment = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IPagination_Fragment = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IPoi_Fragment = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IRenderingId_Fragment = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ISplitter_Fragment = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IStyling_Fragment = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__IVariantDefinition_Fragment = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__InvestmentTrustPage_Fragment = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__JsonField_Fragment = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__JsonReference_Fragment = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__JssData_Fragment = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__JssSettings_Fragment = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__JssSiteFolder_Fragment = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__JssRootFolder_Fragment = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086_Fragment = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__Navigation_E6d98f24d01c419e871a4617125a49ed_Fragment = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__Page_Fragment = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PageData_Fragment = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PageDesignFolder_Fragment = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd_Fragment = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4_Fragment = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PartialDesign_Fragment = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PartialDesignFolder_Fragment = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d_Fragment = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d_Fragment = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PlaceholderWrapper_Fragment = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac_Fragment = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b_Fragment = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__RedirectMapGrouping_Fragment = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973_Fragment = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__Route_Fragment = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__SimpleVideo_Fragment = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__SiteSettingsFolder_Fragment = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__SitemapSettings_Fragment = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__StandardTemplate_Fragment = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c_Fragment = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65_Fragment = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__TrustFolder_Fragment = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__VariantDefinition_Fragment = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__VariantField_Fragment = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C__VariantsGrouping_Fragment = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___AdvancedItem_Fragment = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Arguments_Fragment = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Arguments_33fab87cd52f44319a1f589ba7c1e287_Fragment = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Article_Fragment = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___ArticlePageWorkflow_Fragment = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___ArticleSearchPage_Fragment = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___ArticleWildcard_Fragment = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___AssetServiceThemeMode_Fragment = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseArticle_Fragment = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseDataFolder_Fragment = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseHelpArticle_Fragment = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseInvestmentTrust_Fragment = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseJssTenant_Fragment = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BasePage_Fragment = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BasePageDesign_Fragment = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BasePageDesignFolder_Fragment = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BasePartialDesign_Fragment = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BasePartialDesignFolder_Fragment = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BasePlaceholder_Fragment = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BasePlaceholderSettingsFolder_Fragment = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BasePresentation_Fragment = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BasePressRelease_Fragment = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseRenderingParameters_Fragment = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseSxaStandardValuesFolder_Fragment = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseSettings_Fragment = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseSharedSitesSettings_Fragment = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseSiteDefinition_Fragment = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseSiteFolder_Fragment = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseSiteGrouping_Fragment = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseSiteRoot_Fragment = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseTenant_Fragment = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BaseTenantFolder_Fragment = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___BucketRules_Fragment = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Cors_Fragment = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Content_Fragment = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___ContentType_Fragment = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___DataAttributes_Fragment = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___DatasourceWorkflow_Fragment = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Dependencies_Fragment = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Description_Fragment = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___DesignTemplateMapping_Fragment = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Designable_Fragment = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___EditType_Fragment = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___EditType_8a9f84baaa124c5d9096935714809da4_Fragment = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___EditingTheme_Fragment = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Enabled_Fragment = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___ErrorHandling_Fragment = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___ExternalArticle_Fragment = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Fields_Fragment = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FilteredArticlesParent_Fragment = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FilteredArticlesWildcard_Fragment = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Footnotes_Fragment = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FundDetailsWildcard_Fragment = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FundFormAvailability_Fragment = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FundMetadataPage_Fragment = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FundSearchPage_Fragment = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FundsFolder_Fragment = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FundsFormsFolder_Fragment = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FundsLiteratureFolder_Fragment = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___FundsShareclassesDetailsWildcard_Fragment = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___GridMapping_Fragment = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___HelpArticle_Fragment = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___HelpArticleSearchPage_Fragment = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___HelpArticleWildcard_Fragment = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___HorizonDatasourceGrouping_Fragment = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Icon_Fragment = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___IncludeByDefault_Fragment = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___IncludeIfInstalled_Fragment = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___InternalArticle_Fragment = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___InternetExplorerCompatibilityMode_Fragment = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___IsSystemModule_Fragment = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___JsonVariantPaging_Fragment = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___JsonVariantsBase_Fragment = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___LimitedDisplay_Fragment = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___LinkAttributes_Fragment = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___LinkSettings_Fragment = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___LiteratureHubSearchPage_Fragment = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___ManualKeyInformation_Fragment = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___MemberOf_Fragment = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___MetadataPage_Fragment = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Modules_Fragment = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Name_Fragment = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d_Fragment = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Name_299cdb154745448a807868d401248eaa_Fragment = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Name_B88cf88159a54a19991e71038751cb60_Fragment = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Navigable_Fragment = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___NavigablePage_Fragment = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PageContent_Fragment = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PageWorkflow_Fragment = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PerSiteStandardValues_Fragment = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Podcast_Fragment = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PodcastPressRelease_Fragment = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PremiumContentPage_Fragment = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PressRelease_Fragment = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PressReleaseContentType_Fragment = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PressReleaseSearchPage_Fragment = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PressReleaseWildcard_Fragment = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___ProtectedTheme_Fragment = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___PublishingGroupingTemplate_Fragment = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___RenderingRelatedParameters_Fragment = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___RenderingVariantsBase_Fragment = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___RenderingsList_Fragment = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___RobotsContent_Fragment = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___RoleDomain_Fragment = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___RoleName_Fragment = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___RoleType_Fragment = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SalesforceCommonValidations_Fragment = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SalesforceFieldId_Fragment = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SalesforceFieldTitle_Fragment = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SalesforceFieldValue_Fragment = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Script_Fragment = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SearchSignature_Fragment = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Searchable_Fragment = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SecurityItemPointer_Fragment = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SharedArticles_Fragment = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SharedContent_Fragment = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SharedHelpArticles_Fragment = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SharedPage_Fragment = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SharedPressReleases_Fragment = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SharedRoot_Fragment = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SharedSettings_Fragment = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SiteContent_Fragment = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SiteFolder_Fragment = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SiteMediaLibrary_Fragment = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SiteSettings_Fragment = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SiteTemplate_Fragment = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SitecoreClientSiteManaging_Fragment = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Sitemap_Fragment = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SitemapMediaItems_Fragment = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SlidersRangeSettings_Fragment = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SolutionTemplateContent_Fragment = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SolutionTemplateDescription_Fragment = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SolutionTemplateName_Fragment = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SortOrder_Fragment = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___StackBreakpoint_Fragment = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Statistics_Fragment = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___SupportedLanguages_Fragment = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Taggable_Fragment = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___TeamMembersParentPage_Fragment = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___TeamMembersWildcard_Fragment = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___TechzoneArticle_Fragment = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Template_Fragment = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Title_Fragment = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Type_Fragment = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Validation_Fragment = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___VariantPaging_Fragment = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___VectorTile_Fragment = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___VectorTileLink_Fragment = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Video_Fragment = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___VideoPressRelease_Fragment = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___Width_Fragment = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_C___WildcardPage_Fragment = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CacheSetting_Fragment = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Caching_26fce9bf0256458d8281a713a5bf5520_Fragment = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CalendarEvent_Fragment = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CallOutSection_Fragment = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CallOutSectionDropdownOption_Fragment = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CallOutSectionFolder_Fragment = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CallOutSectionParametersTemplate_Fragment = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CallToAction_Fragment = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CallToActionFolder_Fragment = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CapabilitiesFolder_Fragment = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Capability_Fragment = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CapabilityMap_Fragment = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CapabilityMappings_Fragment = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Carousel_Fragment = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CarouselFolder_Fragment = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CarouselSlide_Fragment = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Carousel_2b65f0d87ec54834b4aa1753c0f7036b_Fragment = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Checkbox_Fragment = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ChecklistFilter_Fragment = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ChecklistFilterFolder_Fragment = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee_Fragment = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ColumnSplitter_Fragment = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0_Fragment = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CompatibilityMode_Fragment = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ComponentConfiguration_Fragment = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ComponentThemeConfiguration_Fragment = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ComponentThemesConfiguration_Fragment = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ComponentsConfigurations_Fragment = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ConfigurationFolder_Fragment = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Container_Fragment = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ContainerOption_Fragment = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ContainerOptionsFolder_Fragment = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ContainerParametersTemplate_Fragment = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Container_45130bdbbae34edcaea87b68b9d94c7f_Fragment = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ContentBlock_Fragment = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ContentBlockFolder_Fragment = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ContentToken_Fragment = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ContentTokenFolder_Fragment = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ContentType_Fragment = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CorporateTheme_Fragment = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CorporateThemesFolder_Fragment = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Country_Fragment = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CountryIsoCode_Fragment = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CountryIsoCodesFolder_Fragment = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CustomerReviewFolder_Fragment = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CustomerReviewTile_Fragment = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_CustomerReviewTileParametersTemplate_Fragment = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DataBridgeDocumentCategoryMap_Fragment = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DataBridgeFund_Fragment = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DataBridgeFundRangeName_Fragment = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DataBridgeSettingsFolder_Fragment = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DataBridgeShareClass_Fragment = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DataFolder_Fragment = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DatasourceConfiguration_Fragment = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DatasourceConfigurations_Fragment = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DatasourceWorkflowAction_Fragment = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DateFacet_Fragment = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DateFilter_Fragment = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DateFilterFolder_Fragment = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DateFilter_Ad89c1f1e99148ef865938ab13aa28f1_Fragment = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DefaultColumnLayout_Fragment = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DefaultShareclassMapping_Fragment = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DefaultShareclassMappings_Fragment = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DescriptiveHighlight_Fragment = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DescriptiveHighlightFolder_Fragment = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DescriptiveHighlightItem_Fragment = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DescriptiveHighlightParametersTemplate_Fragment = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Device_Fragment = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Device_7c27ec70f42e40428a0fabaa2f8eda18_Fragment = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Devices_Fragment = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DictionaryFolder_Fragment = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DisqusParameters_Fragment = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DistanceFacet_Fragment = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Divider_Fragment = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DocumentItem_Fragment = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DocumentListings_Fragment = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DocumentListingsFolder_Fragment = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DocumentTypeFolder_Fragment = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DominantLanguageMapping_Fragment = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Dropdown_Fragment = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DropdownFilter_Fragment = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DropdownFilterFolder_Fragment = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d_Fragment = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EditEditingTheme_Fragment = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EditFrame_Fragment = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EditModePanel_Fragment = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EditSiteItem_Fragment = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EditSiteItem_F040db0387fe4e10ae4053c63175e31b_Fragment = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EditSiteTheme_Fragment = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EditTenantTemplate_Fragment = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3_Fragment = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EditType_Fragment = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EloquaFormFolder_Fragment = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EloquaFundForm_Fragment = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Enum_Fragment = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Enums_Fragment = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ErrorPage_Fragment = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171_Fragment = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ErrorPage_4dbccce416d1491f94198496e3f77c6d_Fragment = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ErrorPage_45d797cc048740ffb693214883ff35c2_Fragment = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9_Fragment = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ErrorPage_A7dfa49761224679bf9949fffacd5fa1_Fragment = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EventCalendarParameters_Fragment = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EventList_Fragment = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EventListParameters_Fragment = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EventTypes_Fragment = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_EventsFolder_Fragment = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ExecuteScript_Fragment = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f_Fragment = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a_Fragment = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca_Fragment = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de_Fragment = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb_Fragment = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ExtendSiteTheme_Fragment = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ExternalLiterature_Fragment = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FEaaSWrapperRenderingParameters_Fragment = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FacebookCommentsParametersTemplate_Fragment = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FacetSlider_Fragment = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FacetSliderFolder_Fragment = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FacetSlider_995ce2c7319f478b84fe22053ac85bb7_Fragment = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FacetSummary_Fragment = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FacetSummaryFolder_Fragment = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2_Fragment = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FacetsGrouping_Fragment = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FakeNavigationItem_Fragment = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FeatureBanner_Fragment = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FeatureBannerParametersTemplate_Fragment = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FeaturedArticles_Fragment = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FeaturedArticlesFolder_Fragment = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FeaturedTheme_Fragment = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FeaturedThemesFolder_Fragment = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Feed_Fragment = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FeedFolder_Fragment = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FeedParameters_Fragment = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FieldEditor_Fragment = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FieldRenderer_Fragment = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FileList_Fragment = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FileListFolder_Fragment = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FileListParametersTemplate_Fragment = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_File_04129321770849c1801baee196e1c0a8_Fragment = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilterCriteria_Fragment = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilterCriteriaFolder_Fragment = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilterTaxonomyOption_Fragment = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilterTaxonomyOptions_Fragment = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesParentPage_Fragment = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesWildcardPage_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Flip_Fragment = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FlipFolder_Fragment = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Flip_5ef078504c044b839dafefd752cfaba8_Fragment = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Flipside_Fragment = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FloatFacet_Fragment = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Footer_Fragment = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FooterFolder_Fragment = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FooterLink_Fragment = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FormRenderingParameters_Fragment = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundAssetClass_Fragment = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundAssetClassesFolder_Fragment = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundDetailsWildcardPage_Fragment = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundFormsFolder_Fragment = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundInFocus_Fragment = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundInFocusShareClass_Fragment = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundSearchPage_Fragment = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundSearchPage_5505b84dba1f47c7b8054749d802d926_Fragment = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundSearchPage_5806f83c03bc443380678ff955f4310f_Fragment = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundSearchPage_7432205c04214a419ca064c4cb37501c_Fragment = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a_Fragment = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundSettings_Fragment = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundShareclassDetailsWildcardPage_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundSubAssetClass_Fragment = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundSubAssetClassesFolder_Fragment = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundsExternalLiteratureFolder_Fragment = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundsFolder_Fragment = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundsInFocusFolder_Fragment = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundsInFocusParametersTemplate_Fragment = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundsLiteratureFolder_Fragment = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_FundsLiteratureMappingsFolder_Fragment = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Gallery_Fragment = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GalleryFolder_Fragment = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GalleryImage_Fragment = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GalleryParametersTemplate_Fragment = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GalleryVideo_Fragment = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GatedAccordionContainer_Fragment = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GlobalLanguageSelector_Fragment = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GlobalNavigationBar_Fragment = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GoogleAnalytics_Fragment = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GoogleTagManager_Fragment = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GoogleTagManagerFolder_Fragment = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GridSetup_Fragment = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_GridTheme_Fragment = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HtmlCode_Fragment = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HtmlCodeFolder_Fragment = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HtmlInclude_Fragment = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HtmlIncludesFolder_Fragment = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HtmlSnippet_Fragment = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HtmlSnippetFolder_Fragment = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HtmlTag_Fragment = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Header_Fragment = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeaderFolder_Fragment = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Heading_Fragment = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSiteSetupRoot_Fragment = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b_Fragment = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1_Fragment = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5_Fragment = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSite_68ffa40c5aab45548f774742b163f318_Fragment = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149_Fragment = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSite_229484893ca144958b9937167dfb5064_Fragment = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSite_B28055626acc45a2913a9617398c9730_Fragment = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSite_F1cab1661abb450d84d55d938e7699cb_Fragment = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSite_F3884baa0e1548f59a6d7154a4559604_Fragment = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessSolutionTemplateFolder_Fragment = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenantSetupRoot_Fragment = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenant_07248c4700af499eb2a9cb7789f72372_Fragment = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8_Fragment = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenant_5d72df6049c74324969205b55767ad7b_Fragment = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3_Fragment = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenant_77a403a2094e48afafa60943d349d23d_Fragment = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2_Fragment = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenant_94824ac390d748499e5af0275d10811f_Fragment = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenant_4797571864fd40929cf2412c39757ec3_Fragment = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107_Fragment = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessTrustSite_Fragment = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessVariants_Fragment = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeadlessVariantsGrouping_Fragment = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticlePage_Fragment = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticlePlatform_Fragment = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticlePlatformMap_Fragment = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticlePlatformMappings_Fragment = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticlePlatformsFolder_Fragment = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticleSearchPage_Fragment = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77_Fragment = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticleTag_Fragment = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticleTagsFolder_Fragment = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticleWildcardPage_Fragment = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4_Fragment = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpArticlesGroupFolder_Fragment = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpTagMap_Fragment = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HelpTagMappings_Fragment = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HeroBanner_Fragment = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Highlight_Fragment = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HighlightBlock_Fragment = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HighlightBlockFolder_Fragment = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HighlightBlockParametersTemplate_Fragment = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HighlightFolder_Fragment = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HighlightItem_Fragment = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HighlightParametersTemplate_Fragment = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Home_Fragment = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HomePage_Fragment = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HomePage_0d3963a8171d4080b5f808618578b631_Fragment = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HomePage_6d95c7d946c74a70be07304cc73a2010_Fragment = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HomePage_B407f259b4e34c7db9a06e8907a56b17_Fragment = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HomePage_Cde13c51062d426b95569e8202edc963_Fragment = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_HomePage_De9353283a3e41c495ba386aed0540c6_Fragment = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IFrame_Fragment = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IFrameFolder_Fragment = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2_Fragment = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IFrameParametersTemplate_Fragment = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IFrame_0da12d476de24dfeb4d0f513489bfea1_Fragment = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IFrame_88a6f65f2b78491bb3770b06e48883e1_Fragment = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Icon_Fragment = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IconFolder_Fragment = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Image_Fragment = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ImageFolder_Fragment = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ImageFolder_Edc00e86cef24d0cbfa264460becc323_Fragment = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993_Fragment = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ImageParametersTemplate_Fragment = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Image_83bc563c6320490092f8204bff81586a_Fragment = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Image_15185b0e641844499f934ff03b7ee032_Fragment = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Image_D885df8cb2d64007b34b2bbafb527304_Fragment = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Infographics_Fragment = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InfographicsFolder_Fragment = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InputValidationStep_Fragment = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InputValidationStep_088928cf558e40ec87f3342aa9e66757_Fragment = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593_Fragment = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InputValidationStep_D028fef2babf4ad1bbe74d62a977992f_Fragment = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IntegerFacet_Fragment = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IntroCopy_Fragment = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_IntroCopyFolder_Fragment = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestmentTrustAssetClass_Fragment = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestmentTrustAssetClassFolder_Fragment = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73_Fragment = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb_Fragment = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestmentTrustRegion_Fragment = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestmentTrustRegionFolder_Fragment = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestmentTrustStyle_Fragment = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestmentTrustStyleFolder_Fragment = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestorType_Fragment = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_InvestorTypesFolder_Fragment = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ItemQueriesFolder_Fragment = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ItemRights_Fragment = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsBeaconSettings_Fragment = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonCheckbox_Fragment = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonContent_Fragment = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonDate_Fragment = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonFile_Fragment = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonImage_Fragment = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonLayout_Fragment = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonList_Fragment = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonMultilistReference_Fragment = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonPlaceholder_Fragment = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonQuery_Fragment = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonResults_Fragment = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonRichText_Fragment = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonScriban_Fragment = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonSection_Fragment = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonTemplate_Fragment = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonText_Fragment = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonToken_Fragment = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonVariantDefinition_Fragment = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonVariants_Fragment = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssLayout_Fragment = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0_Fragment = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSettings_6b328292f8314ab79885d89a054ca10a_Fragment = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSettings_457c9d0b61b84adfaf7f82561ed275ff_Fragment = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSettings_5045bf85d2ea430b9f41c2e348436e5d_Fragment = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSettings_A767f80d5ad44bfbb8b750a8da144cb5_Fragment = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSettings_B001fd725bb1476496825a8cb9e995cd_Fragment = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSettings_C643bc8630d14d61a173c7870f5dbbad_Fragment = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2_Fragment = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSettings_Ef855d0ba8b04a8e87851d1298266d90_Fragment = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssSiteGrouping_Fragment = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JssTenantFolder_Fragment = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JavaScriptRendering_Fragment = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JsonRendering_Fragment = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JurisdictionStatus_Fragment = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_JurisdictionsFolder_Fragment = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_KeyHighlightItem_Fragment = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_KeyHighlights_Fragment = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_KeyHighlightsFolder_Fragment = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_KeyHighlightsParametersTemplate_Fragment = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Language_Fragment = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LanguageSelector_Fragment = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LanguagesFolder_Fragment = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LatestPressReleasesParametersTemplate_Fragment = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LayoutServiceVariants_Fragment = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LimitedDisplayFolder_Fragment = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LimitedDisplayOption_Fragment = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Link_Fragment = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LinkList_Fragment = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LinkListFolder_Fragment = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LinkListFolder_C237d144647a4afeaa7b1570f3e3f139_Fragment = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LinkList_33c9207e3b0446068ef54ca99a97c776_Fragment = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LinkList_97a593ad273141dc80bfceb5ef6a33b7_Fragment = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LinkList_F7561ffcc0d8477fb53d2703a4060be1_Fragment = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Link_68bd1cb5a7624a969ac6cb16ab5882a3_Fragment = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Link_930f134d56784b35bfd1b77f9d0115f1_Fragment = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Link_E24e0789a05848bfabb6c69c0e60b6b7_Fragment = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LinksFolder_Fragment = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_List_Fragment = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ListFacet_Fragment = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ListFolder_Fragment = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ListItem_Fragment = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ListParametersTemplate_Fragment = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ListStyle_Fragment = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ListStyleItem_Fragment = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ListingHeroBanner_Fragment = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ListingHeroParametersTemplate_Fragment = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LiteratureAuthorization_Fragment = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LiteratureAuthorizationsFolder_Fragment = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LiteratureHubSearchPage_Fragment = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LoadMore_Fragment = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LoadMoreFolder_Fragment = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6_Fragment = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LocationFilter_Fragment = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LocationFilterFolder_Fragment = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LocationFilter_Aaad4aad290744dc90b69e4e83a661ec_Fragment = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Log_Fragment = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Login_Fragment = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Login_Abed54dc4f7840ddac562289c9c849d8_Fragment = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LogoTextBlockItem_Fragment = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LogoTextBlocks_Fragment = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_LogoTextBlocksFolder_Fragment = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Logout_Fragment = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Logout_C2294d8235a6452a94b15eb5e543b602_Fragment = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ManagedRangeFilter_Fragment = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ManagedRangeFilterFolder_Fragment = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91_Fragment = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ManagedRangeItem_Fragment = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Map_Fragment = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MapParameters_Fragment = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MapsFolder_Fragment = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MapsProvider_Fragment = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MediaBlock_Fragment = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MediaBlockFolder_Fragment = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MediaBlockParametersTemplate_Fragment = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MediaFolder_81150e5837f5443fa3c075e14a9321e7_Fragment = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MediaLinkParameters_Fragment = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MediaVirtualFolder_Fragment = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MegaNavigation_Fragment = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MegaNavigationFolder_Fragment = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MetaBranding_Fragment = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MetaRenderingParameters_Fragment = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MetadataPartialDesign_Fragment = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Model_Fragment = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ModelIterator_Fragment = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_MyLocationPoi_Fragment = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Navigation_Fragment = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_NavigationCategory_Fragment = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_NavigationFilter_Fragment = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_NavigationFilterFolder_Fragment = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_NavigationLink_Fragment = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_NavigationSubcategory_Fragment = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Navigation_9ce34bf95c934dff841d8f649c2bd6c8_Fragment = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_OneTrustSettings_Fragment = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_OptimiserConfiguration_Fragment = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_OptimiserConfigurationSection_Fragment = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_OptimizedFile_Fragment = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_OracleCdpSettings_Fragment = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_OverlayContent_Fragment = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_OverlayFolderTemplate_Fragment = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Ownership_Fragment = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_OwnershipFolder_Fragment = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Poi_Fragment = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PoiFolder_Fragment = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PoiType_Fragment = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PoIs_Fragment = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageBranchesFolder_Fragment = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageContent_Fragment = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageContentFolder_Fragment = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageContent_Ef87e73bc7ff49a2ac599b0be83755c3_Fragment = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesign_Fragment = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0_Fragment = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47_Fragment = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8_Fragment = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b_Fragment = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662_Fragment = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc_Fragment = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesignFolder_14161ec204984aa7a2a46decadf669f5_Fragment = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb_Fragment = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesignFolder_D84605f786ea482da6ff683f6572821c_Fragment = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesign_1105b8f81e00426bbf1fc840742d827b_Fragment = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_Fragment = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_3af52e70e982424b9c85e355542500c9_Fragment = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d_Fragment = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_48d2d50a150c4f6283603a4fed5646e0_Fragment = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_99a71bba507746729c3fb29b04abee23_Fragment = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_A0f265b42d6241968b65d3ede7cb59c3_Fragment = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11_Fragment = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_B8d9b352c1694b31bd506848b47ca884_Fragment = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_D3b2e1466f744df0900bec314f699ef3_Fragment = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe_Fragment = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageLevelTabs_Fragment = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageLevelTabsFolder_Fragment = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageList_Fragment = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageSelector_Fragment = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageSelectorConfiguration_Fragment = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageSelectorFolder_Fragment = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageSelector_59a7bb775f8c435ab810291abde80e63_Fragment = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageSize_Fragment = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageSizeFolder_Fragment = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageSize_B682562e0af64b3e9e3b45273bbe152d_Fragment = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageTheme_Fragment = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PageThemesFolder_Fragment = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Page_4f49a81db3664f198b89cab92f377d7a_Fragment = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Page_5e66d86353544fe6a27d3b894984d50f_Fragment = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Page_84f342ad2d0646b9aa9a818201145ca2_Fragment = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Page_718df200be51463d93edf4d77ab7a49e_Fragment = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Page_B61d5babe46f4ef39f27b57c4ccefdf7_Fragment = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Page_Cfd6e04697e24f3cb9eb41b79afc35dc_Fragment = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Page_Dae7821153e14dbabb0ddf0b53a90aaf_Fragment = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Page_Fa608b3e6aeb426388a059d89caabada_Fragment = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Pagging_Fragment = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Pagination_Fragment = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PaginationFolder_Fragment = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Paragraph_Fragment = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d_Fragment = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b_Fragment = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8_Fragment = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b_Fragment = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112_Fragment = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesignFolder_89098e3089aa4062a77346d608caac90_Fragment = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesignFolder_1695576fb93647d7842ed17730278c32_Fragment = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc_Fragment = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a_Fragment = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesign_Fd2059fd60434dfe8c04e2437ce87634_Fragment = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_Fragment = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec_Fragment = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4_Fragment = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_36c869ded22040929ce829f6ed643c66_Fragment = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_1943dc73710a430895515a342c84b037_Fragment = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_B1e2a6790a1442d8bafa66317b8be117_Fragment = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e_Fragment = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_D52704ed3b704a53abb4292105f687ad_Fragment = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_D216303f58d8425688da8cd30d00afab_Fragment = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PartialDesigns_Facda26791204fa9a0363344348f2c42_Fragment = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PerformanceChartSettings_Fragment = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PerformanceChartTimePeriod_Fragment = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PerformanceChartTimePeriodFolder_Fragment = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Placeholder_1ca0304be5b64810821154426f1752c2_Fragment = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Placeholder_D2a6884c04d54089a64ed27ca9d68d4c_Fragment = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PlainHtmlParametersTemplate_Fragment = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Playlist_Fragment = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PlaylistFolder_Fragment = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PlaylistParametersTemplate_Fragment = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Podcast_Fragment = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PodcastFolder_Fragment = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PodcastPage_Fragment = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PodcastPressReleasePage_Fragment = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PoiTypes_Fragment = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PostDeleteStep_Fragment = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574_Fragment = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a_Fragment = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PostDeleteStep_B20857895385413883f096f3767cb156_Fragment = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PostSetupStep_Fragment = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PostSetupStep_6fac654e22154a419a1d59197bebc0fe_Fragment = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f_Fragment = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PostSetupStep_341738aa44fe490e90ff7010a3c2463b_Fragment = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PreDeleteStep_Fragment = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49_Fragment = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b_Fragment = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PreDeleteStep_F0daf401190f45468bda8568d08e161d_Fragment = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PreDeleteValidationStep_Fragment = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f_Fragment = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f_Fragment = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e_Fragment = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Presentation_Fragment = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Presentation_0a70fa7389234a6eabf34134f25f3221_Fragment = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseContentType_Fragment = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseContentTypesFolder_Fragment = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseFilter_Fragment = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleasePage_Fragment = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleasePlatform_Fragment = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleasePlatformsFolder_Fragment = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseSearchPage_Fragment = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f_Fragment = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72_Fragment = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d_Fragment = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58_Fragment = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseWildcardPage_Fragment = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PressReleasesGroupFolder_Fragment = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PrivacyWarning_Fragment = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ProjectFolder_Fragment = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Promo_Fragment = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PromoFolder_Fragment = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PromoFolder_F07cbe8973ae4de692172570260cac6e_Fragment = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Promo_7f21f14d096b4f27bbccf115c6e6f6f1_Fragment = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Promo_881869ca7f5845ea8b34ad1bfd3551a8_Fragment = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Promo_Dfed4457d760457abec1c0dccdc44381_Fragment = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PromotedContent_Fragment = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PromotedContentFolder_Fragment = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PropertyListingCard_Fragment = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PropertyListingCards_Fragment = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PropertyListingCategory_Fragment = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_PropertyListingFolder_Fragment = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Query_98b413525a4b4067b92418a4b50f0a53_Fragment = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_QuickLinks_Fragment = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_QuickLinksFolder_Fragment = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_QuickLinksParametersTemplate_Fragment = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_QuotationBlockItem_Fragment = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_QuotationBlocks_Fragment = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_QuotationBlocksFolder_Fragment = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_QuotationBlocksParametersTemplate_Fragment = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Quote_Fragment = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_QuoteFolder_Fragment = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_QuoteParametersTemplate_Fragment = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RadiusFilter_Fragment = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RadiusFilterFolder_Fragment = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64_Fragment = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RadiusScheme_Fragment = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RadiusSchemeValue_Fragment = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RangeSliderFilter_Fragment = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RangeSliderFilterFolder_Fragment = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03_Fragment = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RecentArticles_Fragment = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Redirect_Fragment = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RedirectMap_Fragment = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RedirectMaps_Fragment = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Region_Fragment = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RegionLanguages_Fragment = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RegionLanguagesFolder_Fragment = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RelatedArticles_Fragment = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RelatedArticlesParametersTemplate_Fragment = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RenderEngineType_Fragment = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RenderingFolder_840d4a46550349ecbf9dbd090946c63d_Fragment = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RenderingHost_Fragment = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResizableIFramePage_Fragment = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067_Fragment = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68_Fragment = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResizableIFramePage_B58eacfb27f5417bb536141f94b92521_Fragment = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401_Fragment = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResizableIFramePage_F460ab055585441892023750e7cef6b7_Fragment = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResponsiveImage_Fragment = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResultsCount_Fragment = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResultsCountFolder_Fragment = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186_Fragment = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ResultsVariantSelector_Fragment = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RichText_Fragment = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RichTextFolder_Fragment = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RichText_0f3b73366112418c8bbab0526f3887ce_Fragment = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RichText_Efcfd8f6596745f48f85b5421928205d_Fragment = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RiskImageMapping_Fragment = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RiskImageMappings_Fragment = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RiskLevelOption_Fragment = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RiskLevelOptionFolder_Fragment = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RiskWarning_Fragment = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RiskWarningFolder_Fragment = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RiskWarningParametersTemplate_Fragment = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RolePlaceholder_Fragment = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RowSplitter_Fragment = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_RowSplitter_340c887da1d1415b9678c763af74ea97_Fragment = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Rule_Fragment = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SdrLogoMapping_Fragment = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SdrLogoMappings_Fragment = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SdrTypeOption_Fragment = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SdrTypeOptionFolder_Fragment = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SxajssLayout_Fragment = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SxaRole_Fragment = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SxaStandardValuesFolder_Fragment = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceAlertMessage_Fragment = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceCheckBox_Fragment = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceCheckBoxType_Fragment = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceConditionalRadioButton_Fragment = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceConditionalRadioButtons_Fragment = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceDateInput_Fragment = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceDropdown_Fragment = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceDropdownOption_Fragment = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceHiddenField_Fragment = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceInput_Fragment = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceInputType_Fragment = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceIntegratedForm_Fragment = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceIntegratedFormTypesFolder_Fragment = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceRepeatableSubSection_Fragment = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceRichTextArea_Fragment = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceSection_Fragment = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceSortCodeInput_Fragment = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SalesforceSubmissionType_Fragment = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Scope_Fragment = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ScopesFolder_Fragment = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Scriban_Fragment = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Scripts_Fragment = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SearchBox_Fragment = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SearchBoxFolder_Fragment = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SearchBox_1c04fd611d874590acfe9cc186865ab3_Fragment = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SearchFolder_Fragment = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SearchResults_Fragment = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SearchResultsFolder_Fragment = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SearchResults_A06f7130041d46bb8c2995a2dc00c26a_Fragment = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SecondaryHeroBannerParametersTemplate_Fragment = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SectionHeading_Fragment = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SectionHeadingFolder_Fragment = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SectionHeadingParametersTemplate_Fragment = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SectionHeadingType_Fragment = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SectionHeadingTypeFolder_Fragment = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SectionSelector_Fragment = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SectionSelectorFolder_Fragment = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SectionSelectorTab_Fragment = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Security_33077d51ebad4d1cb4a83b79f51dba13_Fragment = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Series_Fragment = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SeriesFolder_Fragment = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Settings_Fragment = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SettingsFolder_Fragment = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Settings_6c82caca67dc464195698faad083230e_Fragment = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SharePriceSettings_Fragment = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SharedArticlesFolder_Fragment = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SharedContentFolder_Fragment = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SharedFolder_Fragment = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SharedHelpArticlesFolder_Fragment = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SharedPressReleasesFolder_Fragment = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SharedSettingsFolder_Fragment = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SharedSitesSettings_Fragment = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SharedSitesSettings_C14bf746030f4e598594395f6d299e61_Fragment = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Showcase_Fragment = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ShowcaseFolder_Fragment = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ShowcaseItem_Fragment = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ShowcaseParametersTemplate_Fragment = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Site_Fragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteContentFolder_Fragment = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteDefinition_Fragment = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteEntryDisclaimer_Fragment = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteFolder_Fragment = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteGrouping_Fragment = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteManagement_Fragment = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteSecurityItemPointer_Fragment = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteSelector_Fragment = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteSelector_A44632f56dcd4d10b4892f4e35e193c3_Fragment = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteSetupRoot_Fragment = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SiteTheme_Fragment = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Site_E46f3af239fa4866a1577017c4b2a40c_Fragment = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SitecoreFormWrapperParametersTemplate_Fragment = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SitecoreRole_Fragment = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SitemapSettings_C71d856635c849b7a84d9d176e9cbd05_Fragment = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SkipLink_Fragment = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SkipLinkParameters_Fragment = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SkipLinksFolder_Fragment = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Snippet_Fragment = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SnippetItem_Fragment = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SnippetsFolder_Fragment = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SocialLoginWrapper_Fragment = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SocialMediaButtons_Fragment = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SocialMediaFolder_Fragment = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SocialMediaShare_Fragment = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SocialMediaTemplate_Fragment = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SocialNetwork_Fragment = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SocialNetworkFolder_Fragment = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SocialNetworkLink_Fragment = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SolutionTemplate_Fragment = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SortResults_Fragment = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SortResultsFolder_Fragment = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Sorting_Fragment = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SortingGroups_Fragment = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SpotifyPodcast_Fragment = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SpotifyPodcastFolder_Fragment = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_StickyCta_Fragment = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_StickyCtaFolder_Fragment = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_StickyCtaParametersTemplate_Fragment = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_StrategiesInFocusFolder_Fragment = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_StrategyInFocus_Fragment = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Style_Fragment = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Styles_Fragment = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Styles_9c0dac2808aa4b44bc2153363206f6a5_Fragment = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_SubscriptionBannerParametersTemplate_Fragment = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Tab_Fragment = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TabItem_Fragment = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TableOfContents_Fragment = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TableOfContentsFolder_Fragment = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TableOfContentsSection_Fragment = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TableOfContentsSubsection_Fragment = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Tabs_Fragment = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TabsFolder_Fragment = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Tabs_F26a9560ccf148c59542800e837caf7a_Fragment = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Tag_Fragment = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TagCloud_Fragment = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TagFolder_Fragment = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TagList_Fragment = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamBiographySettings_Fragment = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamListingCards_Fragment = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamListingCardsFolder_Fragment = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMember_Fragment = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMemberCard_Fragment = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembers_Fragment = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersParentPage_Fragment = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e_Fragment = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e_Fragment = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff_Fragment = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089_Fragment = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0_Fragment = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersWildcardPage_Fragment = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamProfileCards_Fragment = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TeamProfileCardsFolder_Fragment = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TechzoneArticlePage_Fragment = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Tenant_Fragment = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TenantFolder_Fragment = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TenantSecurityItemPointer_Fragment = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TenantSetupRoot_Fragment = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TertieryHeroBanner_Fragment = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TertieryHeroBannerParametersTemplate_Fragment = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Text_Fragment = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextBlock_Fragment = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextBlockHeadingParametersTemplate_Fragment = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextBlockHeadingType_Fragment = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextBlockHeadingTypeFolder_Fragment = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextBlockLinkType_Fragment = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextBlockLinkTypeFolder_Fragment = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextBlocks_Fragment = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextBlocksFolder_Fragment = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextBlocksParametersTemplate_Fragment = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextFolder_Fragment = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TextFolder_B762d56787f5493cbb480c455d834457_Fragment = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Text_B8f5894cb4934016bf784090b0a2fd16_Fragment = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Theme_Fragment = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ThemeTag_Fragment = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ThemeTagsFolder_Fragment = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ThemingMode_Fragment = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ThemingModes_Fragment = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Tile_Fragment = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TileLink_Fragment = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TileParametersTemplate_Fragment = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TileSizeOption_Fragment = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TileSizeOptionFolder_Fragment = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TilesFolder_Fragment = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TilesParametersTemplate_Fragment = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Title_Fragment = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Title_A82e893105754175917de904ef7e6dbe_Fragment = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Toggle_Fragment = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_ToggleFolder_Fragment = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Toggle_8e4c968e9fa543a89ac4c0baf273ccde_Fragment = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Transformation_Fragment = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TrustArticleHeroParametersTemplate_Fragment = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TrustFinder_Fragment = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TrustFinderFilterOption_Fragment = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TrustRegion_Fragment = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TrustType_Fragment = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TrustTypesFolder_Fragment = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Twitter_Fragment = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TwitterApp_Fragment = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TwitterApps_Fragment = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TwitterFolder_Fragment = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TwitterParametersTemplate_Fragment = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_TwitterSettings_Fragment = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_UnknownItem_Fragment = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_UnminifiedFile_Fragment = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_UpgradeScript_Fragment = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_UpgradeScriptLibrary_Fragment = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VariantComponentField_Fragment = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VariantDateField_Fragment = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55_Fragment = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VariantPlaceholder_Fragment = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VariantReference_Fragment = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VariantSection_Fragment = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VariantTemplate_Fragment = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VariantText_Fragment = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VariantToken_Fragment = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Variants_Fragment = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VectorFolder_Fragment = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VectorTile_Fragment = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VectorTileLink_Fragment = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VectorTilesFolder_Fragment = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VectorTilesParametersTemplate_Fragment = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Version_95ebc23204774dc38ad3465d5fe8da2f_Fragment = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Video_Fragment = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VideoCountOption_Fragment = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VideoCountOptions_Fragment = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VideoFolder_Fragment = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VideoFolder_Bba49474673e468186ba8b1a20e067a9_Fragment = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VideoPage_Fragment = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VideoParameters_Fragment = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VideoParametersTemplate_Fragment = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_VideoPressReleasePage_Fragment = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields_Video_4bc649610a894242be2dc5026090cf49_Fragment = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__AssetsOptimization_Fragment = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__BackgroundImage_Fragment = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__CompatibleThemes_Fragment = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__CompositeTheme_Fragment = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__CustomMetadata_Fragment = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__CustomRenderingViewPath_Fragment = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__DatasourceBehaviour_Fragment = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__Favicon_Fragment = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__FormsFolderLocation_Fragment = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__FundSettings_Fragment = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__HasValidUrlName_Fragment = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__LocalDataLink_Fragment = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__Login_Fragment = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__OpenGraphMetadata_Fragment = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__PageDesignTheme_Fragment = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__PageSearchScope_Fragment = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__SearchCriteria_Fragment = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__SearchableWithoutRelatedItems_Fragment = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__SeoMetadata_Fragment = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__SiteTheme_Fragment = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__SitemapSettings_Fragment = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__StickyNote_Fragment = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__Styleable_Fragment = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__TwitterMetadata_Fragment = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__Webinar_Fragment = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFields__WildcardSource_Fragment = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'name'>
  & { template: ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_template_ItemTemplate }
);

export type ItemFieldsFragment = ItemFields_Accordion_Fragment | ItemFields_AccordionFolder_Fragment | ItemFields_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6_Fragment | ItemFields_AccordionItem_Fragment | ItemFields_AccordionItem_8cf671721b2d489e809f4c23db5ab2da_Fragment | ItemFields_AccordionParametersTemplate_Fragment | ItemFields_AccordionPresentation_Fragment | ItemFields_AccordionPresentationFolder_Fragment | ItemFields_Accordion_02d060598cc14423a9ac9ff2365176b7_Fragment | ItemFields_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1_Fragment | ItemFields_AddItem_Fragment | ItemFields_AddItem_1e1b739ec3784909941d171aca7362e5_Fragment | ItemFields_AddItem_3aea335cd06d45b1841acbc8d2d1ce40_Fragment | ItemFields_AddItem_De8c75222f3241288f20342f479894eb_Fragment | ItemFields_AddItem_Ea8a3f269ccd443a95f571b868a94bd0_Fragment | ItemFields_AddThisParameters_Fragment | ItemFields_AggregatedFacetFilter_Fragment | ItemFields_AlertMessage_Fragment | ItemFields_AlertMessageFolder_Fragment | ItemFields_AlertMessageParametersTemplate_Fragment | ItemFields_AlertMessageType_Fragment | ItemFields_AllertMessageTypeFolder_Fragment | ItemFields_Archive_Fragment | ItemFields_ArticleAuthor_Fragment | ItemFields_ArticleAuthorsFolder_Fragment | ItemFields_ArticleCategoriesFolder_Fragment | ItemFields_ArticleCategory_Fragment | ItemFields_ArticleChapter_Fragment | ItemFields_ArticleChapters_Fragment | ItemFields_ArticleContentType_Fragment | ItemFields_ArticleContentTypesFolder_Fragment | ItemFields_ArticleFilter_Fragment | ItemFields_ArticleFilterOption_Fragment | ItemFields_ArticleFootnote_Fragment | ItemFields_ArticleFootnoteLink_Fragment | ItemFields_ArticleFootnoteText_Fragment | ItemFields_ArticleInfogramTile_Fragment | ItemFields_ArticleInfogramTileParametersTemplate_Fragment | ItemFields_ArticlePage_Fragment | ItemFields_ArticleRegion_Fragment | ItemFields_ArticleRegionsFolder_Fragment | ItemFields_ArticleSearchPage_Fragment | ItemFields_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c_Fragment | ItemFields_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2_Fragment | ItemFields_ArticleSearchPage_Be414ff574ac4203abb2694811443e25_Fragment | ItemFields_ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c_Fragment | ItemFields_ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907_Fragment | ItemFields_ArticleSeriesCollection_Fragment | ItemFields_ArticleSeriesFolder_Fragment | ItemFields_ArticleSettings_Fragment | ItemFields_ArticleSubscriptionBanner_Fragment | ItemFields_ArticleSubscriptionBannerFolder_Fragment | ItemFields_ArticleTag_Fragment | ItemFields_ArticleTagsFolder_Fragment | ItemFields_ArticleTeamAuthor_Fragment | ItemFields_ArticleTileParametersTemplate_Fragment | ItemFields_ArticleTilesParametersTemplate_Fragment | ItemFields_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f_Fragment | ItemFields_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8_Fragment | ItemFields_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca_Fragment | ItemFields_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c_Fragment | ItemFields_ArticleWildcardPage_405b20252077400383d3b47f09f88b47_Fragment | ItemFields_ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b_Fragment | ItemFields_ArticlesGroupFolder_Fragment | ItemFields_AttachThemeExtension_Fragment | ItemFields_AutomaticDocumentListings_Fragment | ItemFields_AutomaticDocumentListingsFolder_Fragment | ItemFields_AvailableJsonRenderings_Fragment | ItemFields_AvailableMetaRenderings_Fragment | ItemFields_AvailableRenderings_Fragment | ItemFields_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb_Fragment | ItemFields_AwardsBanner_Fragment | ItemFields_AwardsBannerFolder_Fragment | ItemFields_AwardsBannerImage_Fragment | ItemFields_AwardsBannerParametersTemplate_Fragment | ItemFields_ByocWrapperRenderingParameters_Fragment | ItemFields_BackgroundColorOption_Fragment | ItemFields_BackgroundColorOptionFolder_Fragment | ItemFields_BannerFolder_Fragment | ItemFields_BannerType_Fragment | ItemFields_BannerTypeFolder_Fragment | ItemFields_BaseHeading_Fragment | ItemFields_BaseHeadingFolder_Fragment | ItemFields_BoolFacet_Fragment | ItemFields_BranchesFolder_Fragment | ItemFields_Breadcrumb_Fragment | ItemFields_BrowserTitleDefinition_Fragment | ItemFields_CorsEntry_Fragment | ItemFields_CorsGrouping_Fragment | ItemFields_CtaPresentationType_Fragment | ItemFields_CtaPresentationTypeFolder_Fragment | ItemFields_C__AbrdnPage_Fragment | ItemFields_C__ActionBase_Fragment | ItemFields_C__AdvancedParameter_Fragment | ItemFields_C__App_Fragment | ItemFields_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c_Fragment | ItemFields_C__ArticleWildcardPage_Fragment | ItemFields_C__AvailableRenderingsFolder_Fragment | ItemFields_C__ByocRenderingParameters_Fragment | ItemFields_C__BackgroundParametersTemplate_Fragment | ItemFields_C__BaseCta_Fragment | ItemFields_C__BasePage_Fragment | ItemFields_C__BasePage_037da552a5524fe4aeee331f57ac1378_Fragment | ItemFields_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f_Fragment | ItemFields_C__BasePage_315fd21bebf04c9d9f00bae191442f1d_Fragment | ItemFields_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd_Fragment | ItemFields_C__BasePage_728c97b5c56146d9807e21018a972bb5_Fragment | ItemFields_C__BasePage_6105875085f346729dfc8d133b481f26_Fragment | ItemFields_C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b_Fragment | ItemFields_C__BaseRenderingParameters_Fragment | ItemFields_C__BaseTheme_Fragment | ItemFields_C__BaseVariantField_Fragment | ItemFields_C__Class_Fragment | ItemFields_C__CompositeGroup_Fragment | ItemFields_C__CompositeSection_Fragment | ItemFields_C__EloquaForm_Fragment | ItemFields_C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d_Fragment | ItemFields_C__ExtendedOptions_Fragment | ItemFields_C__ExtendedOptions_2964fb4257a6440fb192218443904c90_Fragment | ItemFields_C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160_Fragment | ItemFields_C__FEaaSRenderingParameters_Fragment | ItemFields_C__FacetSelectorConfigBase_Fragment | ItemFields_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845_Fragment | ItemFields_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b_Fragment | ItemFields_C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303_Fragment | ItemFields_C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5_Fragment | ItemFields_C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc_Fragment | ItemFields_C__GlobalDatasourceBehavior_Fragment | ItemFields_C__GridDefinition_Fragment | ItemFields_C__GridItemBase_Fragment | ItemFields_C__GridParameters_Fragment | ItemFields_C__HeadlessSite_Fragment | ItemFields_C__HeadlessTenant_Fragment | ItemFields_C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b_Fragment | ItemFields_C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d_Fragment | ItemFields_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d_Fragment | ItemFields_C__IAllowEmpty_Fragment | ItemFields_C__IBaseVariantDefinition_Fragment | ItemFields_C__IBoosting_Fragment | ItemFields_C__ICacheable_Fragment | ItemFields_C__ICompatibleRenderings_Fragment | ItemFields_C__IComponentVariant_Fragment | ItemFields_C__IControlType_Fragment | ItemFields_C__IDynamicPlaceholder_Fragment | ItemFields_C__IfEaaSComponentsDataSourceTemplates_Fragment | ItemFields_C__IfEaaSComponentsEditorScriptUrl_Fragment | ItemFields_C__IIcon_Fragment | ItemFields_C__ILocation_Fragment | ItemFields_C__IPaginable_Fragment | ItemFields_C__IPagination_Fragment | ItemFields_C__IPoi_Fragment | ItemFields_C__IRenderingId_Fragment | ItemFields_C__ISplitter_Fragment | ItemFields_C__IStyling_Fragment | ItemFields_C__IVariantDefinition_Fragment | ItemFields_C__InvestmentTrustPage_Fragment | ItemFields_C__JsonField_Fragment | ItemFields_C__JsonReference_Fragment | ItemFields_C__JssData_Fragment | ItemFields_C__JssSettings_Fragment | ItemFields_C__JssSiteFolder_Fragment | ItemFields_C__JssRootFolder_Fragment | ItemFields_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086_Fragment | ItemFields_C__Navigation_E6d98f24d01c419e871a4617125a49ed_Fragment | ItemFields_C__Page_Fragment | ItemFields_C__PageData_Fragment | ItemFields_C__PageDesignFolder_Fragment | ItemFields_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd_Fragment | ItemFields_C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4_Fragment | ItemFields_C__PartialDesign_Fragment | ItemFields_C__PartialDesignFolder_Fragment | ItemFields_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d_Fragment | ItemFields_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d_Fragment | ItemFields_C__PlaceholderWrapper_Fragment | ItemFields_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac_Fragment | ItemFields_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b_Fragment | ItemFields_C__RedirectMapGrouping_Fragment | ItemFields_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973_Fragment | ItemFields_C__Route_Fragment | ItemFields_C__SimpleVideo_Fragment | ItemFields_C__SiteSettingsFolder_Fragment | ItemFields_C__SitemapSettings_Fragment | ItemFields_C__StandardTemplate_Fragment | ItemFields_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c_Fragment | ItemFields_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65_Fragment | ItemFields_C__TrustFolder_Fragment | ItemFields_C__VariantDefinition_Fragment | ItemFields_C__VariantField_Fragment | ItemFields_C__VariantsGrouping_Fragment | ItemFields_C___AdvancedItem_Fragment | ItemFields_C___Arguments_Fragment | ItemFields_C___Arguments_33fab87cd52f44319a1f589ba7c1e287_Fragment | ItemFields_C___Article_Fragment | ItemFields_C___ArticlePageWorkflow_Fragment | ItemFields_C___ArticleSearchPage_Fragment | ItemFields_C___ArticleWildcard_Fragment | ItemFields_C___AssetServiceThemeMode_Fragment | ItemFields_C___BaseArticle_Fragment | ItemFields_C___BaseDataFolder_Fragment | ItemFields_C___BaseHelpArticle_Fragment | ItemFields_C___BaseInvestmentTrust_Fragment | ItemFields_C___BaseJssTenant_Fragment | ItemFields_C___BasePage_Fragment | ItemFields_C___BasePageDesign_Fragment | ItemFields_C___BasePageDesignFolder_Fragment | ItemFields_C___BasePartialDesign_Fragment | ItemFields_C___BasePartialDesignFolder_Fragment | ItemFields_C___BasePlaceholder_Fragment | ItemFields_C___BasePlaceholderSettingsFolder_Fragment | ItemFields_C___BasePresentation_Fragment | ItemFields_C___BasePressRelease_Fragment | ItemFields_C___BaseRenderingParameters_Fragment | ItemFields_C___BaseSxaStandardValuesFolder_Fragment | ItemFields_C___BaseSettings_Fragment | ItemFields_C___BaseSharedSitesSettings_Fragment | ItemFields_C___BaseSiteDefinition_Fragment | ItemFields_C___BaseSiteFolder_Fragment | ItemFields_C___BaseSiteGrouping_Fragment | ItemFields_C___BaseSiteRoot_Fragment | ItemFields_C___BaseTenant_Fragment | ItemFields_C___BaseTenantFolder_Fragment | ItemFields_C___BucketRules_Fragment | ItemFields_C___Cors_Fragment | ItemFields_C___Content_Fragment | ItemFields_C___ContentType_Fragment | ItemFields_C___DataAttributes_Fragment | ItemFields_C___DatasourceWorkflow_Fragment | ItemFields_C___Dependencies_Fragment | ItemFields_C___Description_Fragment | ItemFields_C___DesignTemplateMapping_Fragment | ItemFields_C___Designable_Fragment | ItemFields_C___EditType_Fragment | ItemFields_C___EditType_8a9f84baaa124c5d9096935714809da4_Fragment | ItemFields_C___EditingTheme_Fragment | ItemFields_C___Enabled_Fragment | ItemFields_C___ErrorHandling_Fragment | ItemFields_C___ExternalArticle_Fragment | ItemFields_C___Fields_Fragment | ItemFields_C___FilteredArticlesParent_Fragment | ItemFields_C___FilteredArticlesWildcard_Fragment | ItemFields_C___Footnotes_Fragment | ItemFields_C___FundDetailsWildcard_Fragment | ItemFields_C___FundFormAvailability_Fragment | ItemFields_C___FundMetadataPage_Fragment | ItemFields_C___FundSearchPage_Fragment | ItemFields_C___FundsFolder_Fragment | ItemFields_C___FundsFormsFolder_Fragment | ItemFields_C___FundsLiteratureFolder_Fragment | ItemFields_C___FundsShareclassesDetailsWildcard_Fragment | ItemFields_C___GridMapping_Fragment | ItemFields_C___HelpArticle_Fragment | ItemFields_C___HelpArticleSearchPage_Fragment | ItemFields_C___HelpArticleWildcard_Fragment | ItemFields_C___HorizonDatasourceGrouping_Fragment | ItemFields_C___Icon_Fragment | ItemFields_C___IncludeByDefault_Fragment | ItemFields_C___IncludeIfInstalled_Fragment | ItemFields_C___InternalArticle_Fragment | ItemFields_C___InternetExplorerCompatibilityMode_Fragment | ItemFields_C___IsSystemModule_Fragment | ItemFields_C___JsonVariantPaging_Fragment | ItemFields_C___JsonVariantsBase_Fragment | ItemFields_C___LimitedDisplay_Fragment | ItemFields_C___LinkAttributes_Fragment | ItemFields_C___LinkSettings_Fragment | ItemFields_C___LiteratureHubSearchPage_Fragment | ItemFields_C___ManualKeyInformation_Fragment | ItemFields_C___MemberOf_Fragment | ItemFields_C___MetadataPage_Fragment | ItemFields_C___Modules_Fragment | ItemFields_C___Name_Fragment | ItemFields_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d_Fragment | ItemFields_C___Name_299cdb154745448a807868d401248eaa_Fragment | ItemFields_C___Name_B88cf88159a54a19991e71038751cb60_Fragment | ItemFields_C___Navigable_Fragment | ItemFields_C___NavigablePage_Fragment | ItemFields_C___PageContent_Fragment | ItemFields_C___PageWorkflow_Fragment | ItemFields_C___PerSiteStandardValues_Fragment | ItemFields_C___Podcast_Fragment | ItemFields_C___PodcastPressRelease_Fragment | ItemFields_C___PremiumContentPage_Fragment | ItemFields_C___PressRelease_Fragment | ItemFields_C___PressReleaseContentType_Fragment | ItemFields_C___PressReleaseSearchPage_Fragment | ItemFields_C___PressReleaseWildcard_Fragment | ItemFields_C___ProtectedTheme_Fragment | ItemFields_C___PublishingGroupingTemplate_Fragment | ItemFields_C___RenderingRelatedParameters_Fragment | ItemFields_C___RenderingVariantsBase_Fragment | ItemFields_C___RenderingsList_Fragment | ItemFields_C___RobotsContent_Fragment | ItemFields_C___RoleDomain_Fragment | ItemFields_C___RoleName_Fragment | ItemFields_C___RoleType_Fragment | ItemFields_C___SalesforceCommonValidations_Fragment | ItemFields_C___SalesforceFieldId_Fragment | ItemFields_C___SalesforceFieldTitle_Fragment | ItemFields_C___SalesforceFieldValue_Fragment | ItemFields_C___Script_Fragment | ItemFields_C___SearchSignature_Fragment | ItemFields_C___Searchable_Fragment | ItemFields_C___SecurityItemPointer_Fragment | ItemFields_C___SharedArticles_Fragment | ItemFields_C___SharedContent_Fragment | ItemFields_C___SharedHelpArticles_Fragment | ItemFields_C___SharedPage_Fragment | ItemFields_C___SharedPressReleases_Fragment | ItemFields_C___SharedRoot_Fragment | ItemFields_C___SharedSettings_Fragment | ItemFields_C___SiteContent_Fragment | ItemFields_C___SiteFolder_Fragment | ItemFields_C___SiteMediaLibrary_Fragment | ItemFields_C___SiteSettings_Fragment | ItemFields_C___SiteTemplate_Fragment | ItemFields_C___SitecoreClientSiteManaging_Fragment | ItemFields_C___Sitemap_Fragment | ItemFields_C___SitemapMediaItems_Fragment | ItemFields_C___SlidersRangeSettings_Fragment | ItemFields_C___SolutionTemplateContent_Fragment | ItemFields_C___SolutionTemplateDescription_Fragment | ItemFields_C___SolutionTemplateName_Fragment | ItemFields_C___SortOrder_Fragment | ItemFields_C___StackBreakpoint_Fragment | ItemFields_C___Statistics_Fragment | ItemFields_C___SupportedLanguages_Fragment | ItemFields_C___Taggable_Fragment | ItemFields_C___TeamMembersParentPage_Fragment | ItemFields_C___TeamMembersWildcard_Fragment | ItemFields_C___TechzoneArticle_Fragment | ItemFields_C___Template_Fragment | ItemFields_C___Title_Fragment | ItemFields_C___Type_Fragment | ItemFields_C___Validation_Fragment | ItemFields_C___VariantPaging_Fragment | ItemFields_C___VectorTile_Fragment | ItemFields_C___VectorTileLink_Fragment | ItemFields_C___Video_Fragment | ItemFields_C___VideoPressRelease_Fragment | ItemFields_C___Width_Fragment | ItemFields_C___WildcardPage_Fragment | ItemFields_CacheSetting_Fragment | ItemFields_Caching_26fce9bf0256458d8281a713a5bf5520_Fragment | ItemFields_CalendarEvent_Fragment | ItemFields_CallOutSection_Fragment | ItemFields_CallOutSectionDropdownOption_Fragment | ItemFields_CallOutSectionFolder_Fragment | ItemFields_CallOutSectionParametersTemplate_Fragment | ItemFields_CallToAction_Fragment | ItemFields_CallToActionFolder_Fragment | ItemFields_CapabilitiesFolder_Fragment | ItemFields_Capability_Fragment | ItemFields_CapabilityMap_Fragment | ItemFields_CapabilityMappings_Fragment | ItemFields_Carousel_Fragment | ItemFields_CarouselFolder_Fragment | ItemFields_CarouselSlide_Fragment | ItemFields_Carousel_2b65f0d87ec54834b4aa1753c0f7036b_Fragment | ItemFields_Checkbox_Fragment | ItemFields_ChecklistFilter_Fragment | ItemFields_ChecklistFilterFolder_Fragment | ItemFields_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee_Fragment | ItemFields_ColumnSplitter_Fragment | ItemFields_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0_Fragment | ItemFields_CompatibilityMode_Fragment | ItemFields_ComponentConfiguration_Fragment | ItemFields_ComponentThemeConfiguration_Fragment | ItemFields_ComponentThemesConfiguration_Fragment | ItemFields_ComponentsConfigurations_Fragment | ItemFields_ConfigurationFolder_Fragment | ItemFields_Container_Fragment | ItemFields_ContainerOption_Fragment | ItemFields_ContainerOptionsFolder_Fragment | ItemFields_ContainerParametersTemplate_Fragment | ItemFields_Container_45130bdbbae34edcaea87b68b9d94c7f_Fragment | ItemFields_ContentBlock_Fragment | ItemFields_ContentBlockFolder_Fragment | ItemFields_ContentToken_Fragment | ItemFields_ContentTokenFolder_Fragment | ItemFields_ContentType_Fragment | ItemFields_CorporateTheme_Fragment | ItemFields_CorporateThemesFolder_Fragment | ItemFields_Country_Fragment | ItemFields_CountryIsoCode_Fragment | ItemFields_CountryIsoCodesFolder_Fragment | ItemFields_CustomerReviewFolder_Fragment | ItemFields_CustomerReviewTile_Fragment | ItemFields_CustomerReviewTileParametersTemplate_Fragment | ItemFields_DataBridgeDocumentCategoryMap_Fragment | ItemFields_DataBridgeFund_Fragment | ItemFields_DataBridgeFundRangeName_Fragment | ItemFields_DataBridgeSettingsFolder_Fragment | ItemFields_DataBridgeShareClass_Fragment | ItemFields_DataFolder_Fragment | ItemFields_DatasourceConfiguration_Fragment | ItemFields_DatasourceConfigurations_Fragment | ItemFields_DatasourceWorkflowAction_Fragment | ItemFields_DateFacet_Fragment | ItemFields_DateFilter_Fragment | ItemFields_DateFilterFolder_Fragment | ItemFields_DateFilter_Ad89c1f1e99148ef865938ab13aa28f1_Fragment | ItemFields_DefaultColumnLayout_Fragment | ItemFields_DefaultShareclassMapping_Fragment | ItemFields_DefaultShareclassMappings_Fragment | ItemFields_DescriptiveHighlight_Fragment | ItemFields_DescriptiveHighlightFolder_Fragment | ItemFields_DescriptiveHighlightItem_Fragment | ItemFields_DescriptiveHighlightParametersTemplate_Fragment | ItemFields_Device_Fragment | ItemFields_Device_7c27ec70f42e40428a0fabaa2f8eda18_Fragment | ItemFields_Devices_Fragment | ItemFields_DictionaryFolder_Fragment | ItemFields_DisqusParameters_Fragment | ItemFields_DistanceFacet_Fragment | ItemFields_Divider_Fragment | ItemFields_DocumentItem_Fragment | ItemFields_DocumentListings_Fragment | ItemFields_DocumentListingsFolder_Fragment | ItemFields_DocumentTypeFolder_Fragment | ItemFields_DominantLanguageMapping_Fragment | ItemFields_Dropdown_Fragment | ItemFields_DropdownFilter_Fragment | ItemFields_DropdownFilterFolder_Fragment | ItemFields_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d_Fragment | ItemFields_EditEditingTheme_Fragment | ItemFields_EditFrame_Fragment | ItemFields_EditModePanel_Fragment | ItemFields_EditSiteItem_Fragment | ItemFields_EditSiteItem_F040db0387fe4e10ae4053c63175e31b_Fragment | ItemFields_EditSiteTheme_Fragment | ItemFields_EditTenantTemplate_Fragment | ItemFields_EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3_Fragment | ItemFields_EditType_Fragment | ItemFields_EloquaFormFolder_Fragment | ItemFields_EloquaFundForm_Fragment | ItemFields_Enum_Fragment | ItemFields_Enums_Fragment | ItemFields_ErrorPage_Fragment | ItemFields_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171_Fragment | ItemFields_ErrorPage_4dbccce416d1491f94198496e3f77c6d_Fragment | ItemFields_ErrorPage_45d797cc048740ffb693214883ff35c2_Fragment | ItemFields_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9_Fragment | ItemFields_ErrorPage_A7dfa49761224679bf9949fffacd5fa1_Fragment | ItemFields_EventCalendarParameters_Fragment | ItemFields_EventList_Fragment | ItemFields_EventListParameters_Fragment | ItemFields_EventTypes_Fragment | ItemFields_EventsFolder_Fragment | ItemFields_ExecuteScript_Fragment | ItemFields_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f_Fragment | ItemFields_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a_Fragment | ItemFields_ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca_Fragment | ItemFields_ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de_Fragment | ItemFields_ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb_Fragment | ItemFields_ExtendSiteTheme_Fragment | ItemFields_ExternalLiterature_Fragment | ItemFields_FEaaSWrapperRenderingParameters_Fragment | ItemFields_FacebookCommentsParametersTemplate_Fragment | ItemFields_FacetSlider_Fragment | ItemFields_FacetSliderFolder_Fragment | ItemFields_FacetSlider_995ce2c7319f478b84fe22053ac85bb7_Fragment | ItemFields_FacetSummary_Fragment | ItemFields_FacetSummaryFolder_Fragment | ItemFields_FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2_Fragment | ItemFields_FacetsGrouping_Fragment | ItemFields_FakeNavigationItem_Fragment | ItemFields_FeatureBanner_Fragment | ItemFields_FeatureBannerParametersTemplate_Fragment | ItemFields_FeaturedArticles_Fragment | ItemFields_FeaturedArticlesFolder_Fragment | ItemFields_FeaturedTheme_Fragment | ItemFields_FeaturedThemesFolder_Fragment | ItemFields_Feed_Fragment | ItemFields_FeedFolder_Fragment | ItemFields_FeedParameters_Fragment | ItemFields_FieldEditor_Fragment | ItemFields_FieldRenderer_Fragment | ItemFields_FileList_Fragment | ItemFields_FileListFolder_Fragment | ItemFields_FileListParametersTemplate_Fragment | ItemFields_File_04129321770849c1801baee196e1c0a8_Fragment | ItemFields_FilterCriteria_Fragment | ItemFields_FilterCriteriaFolder_Fragment | ItemFields_FilterTaxonomyOption_Fragment | ItemFields_FilterTaxonomyOptions_Fragment | ItemFields_FilteredArticlesParentPage_Fragment | ItemFields_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d_Fragment | ItemFields_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941_Fragment | ItemFields_FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616_Fragment | ItemFields_FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9_Fragment | ItemFields_FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce_Fragment | ItemFields_FilteredArticlesWildcardPage_Fragment | ItemFields_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e_Fragment | ItemFields_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835_Fragment | ItemFields_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2_Fragment | ItemFields_FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96_Fragment | ItemFields_FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260_Fragment | ItemFields_Flip_Fragment | ItemFields_FlipFolder_Fragment | ItemFields_Flip_5ef078504c044b839dafefd752cfaba8_Fragment | ItemFields_Flipside_Fragment | ItemFields_FloatFacet_Fragment | ItemFields_Footer_Fragment | ItemFields_FooterFolder_Fragment | ItemFields_FooterLink_Fragment | ItemFields_FormRenderingParameters_Fragment | ItemFields_FundAssetClass_Fragment | ItemFields_FundAssetClassesFolder_Fragment | ItemFields_FundDetailsWildcardPage_Fragment | ItemFields_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734_Fragment | ItemFields_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f_Fragment | ItemFields_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b_Fragment | ItemFields_FundFormsFolder_Fragment | ItemFields_FundInFocus_Fragment | ItemFields_FundInFocusShareClass_Fragment | ItemFields_FundSearchPage_Fragment | ItemFields_FundSearchPage_5505b84dba1f47c7b8054749d802d926_Fragment | ItemFields_FundSearchPage_5806f83c03bc443380678ff955f4310f_Fragment | ItemFields_FundSearchPage_7432205c04214a419ca064c4cb37501c_Fragment | ItemFields_FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a_Fragment | ItemFields_FundSettings_Fragment | ItemFields_FundShareclassDetailsWildcardPage_Fragment | ItemFields_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c_Fragment | ItemFields_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3_Fragment | ItemFields_FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc_Fragment | ItemFields_FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee_Fragment | ItemFields_FundSubAssetClass_Fragment | ItemFields_FundSubAssetClassesFolder_Fragment | ItemFields_FundsExternalLiteratureFolder_Fragment | ItemFields_FundsFolder_Fragment | ItemFields_FundsInFocusFolder_Fragment | ItemFields_FundsInFocusParametersTemplate_Fragment | ItemFields_FundsLiteratureFolder_Fragment | ItemFields_FundsLiteratureMappingsFolder_Fragment | ItemFields_Gallery_Fragment | ItemFields_GalleryFolder_Fragment | ItemFields_GalleryImage_Fragment | ItemFields_GalleryParametersTemplate_Fragment | ItemFields_GalleryVideo_Fragment | ItemFields_GatedAccordionContainer_Fragment | ItemFields_GlobalLanguageSelector_Fragment | ItemFields_GlobalNavigationBar_Fragment | ItemFields_GoogleAnalytics_Fragment | ItemFields_GoogleTagManager_Fragment | ItemFields_GoogleTagManagerFolder_Fragment | ItemFields_GridSetup_Fragment | ItemFields_GridTheme_Fragment | ItemFields_HtmlCode_Fragment | ItemFields_HtmlCodeFolder_Fragment | ItemFields_HtmlInclude_Fragment | ItemFields_HtmlIncludesFolder_Fragment | ItemFields_HtmlSnippet_Fragment | ItemFields_HtmlSnippetFolder_Fragment | ItemFields_HtmlTag_Fragment | ItemFields_Header_Fragment | ItemFields_HeaderFolder_Fragment | ItemFields_Heading_Fragment | ItemFields_HeadlessSiteSetupRoot_Fragment | ItemFields_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b_Fragment | ItemFields_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1_Fragment | ItemFields_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5_Fragment | ItemFields_HeadlessSite_68ffa40c5aab45548f774742b163f318_Fragment | ItemFields_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149_Fragment | ItemFields_HeadlessSite_229484893ca144958b9937167dfb5064_Fragment | ItemFields_HeadlessSite_B28055626acc45a2913a9617398c9730_Fragment | ItemFields_HeadlessSite_F1cab1661abb450d84d55d938e7699cb_Fragment | ItemFields_HeadlessSite_F3884baa0e1548f59a6d7154a4559604_Fragment | ItemFields_HeadlessSolutionTemplateFolder_Fragment | ItemFields_HeadlessTenantSetupRoot_Fragment | ItemFields_HeadlessTenant_07248c4700af499eb2a9cb7789f72372_Fragment | ItemFields_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8_Fragment | ItemFields_HeadlessTenant_5d72df6049c74324969205b55767ad7b_Fragment | ItemFields_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3_Fragment | ItemFields_HeadlessTenant_77a403a2094e48afafa60943d349d23d_Fragment | ItemFields_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2_Fragment | ItemFields_HeadlessTenant_94824ac390d748499e5af0275d10811f_Fragment | ItemFields_HeadlessTenant_4797571864fd40929cf2412c39757ec3_Fragment | ItemFields_HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107_Fragment | ItemFields_HeadlessTrustSite_Fragment | ItemFields_HeadlessVariants_Fragment | ItemFields_HeadlessVariantsGrouping_Fragment | ItemFields_HelpArticlePage_Fragment | ItemFields_HelpArticlePlatform_Fragment | ItemFields_HelpArticlePlatformMap_Fragment | ItemFields_HelpArticlePlatformMappings_Fragment | ItemFields_HelpArticlePlatformsFolder_Fragment | ItemFields_HelpArticleSearchPage_Fragment | ItemFields_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77_Fragment | ItemFields_HelpArticleTag_Fragment | ItemFields_HelpArticleTagsFolder_Fragment | ItemFields_HelpArticleWildcardPage_Fragment | ItemFields_HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4_Fragment | ItemFields_HelpArticlesGroupFolder_Fragment | ItemFields_HelpTagMap_Fragment | ItemFields_HelpTagMappings_Fragment | ItemFields_HeroBanner_Fragment | ItemFields_Highlight_Fragment | ItemFields_HighlightBlock_Fragment | ItemFields_HighlightBlockFolder_Fragment | ItemFields_HighlightBlockParametersTemplate_Fragment | ItemFields_HighlightFolder_Fragment | ItemFields_HighlightItem_Fragment | ItemFields_HighlightParametersTemplate_Fragment | ItemFields_Home_Fragment | ItemFields_HomePage_Fragment | ItemFields_HomePage_0d3963a8171d4080b5f808618578b631_Fragment | ItemFields_HomePage_6d95c7d946c74a70be07304cc73a2010_Fragment | ItemFields_HomePage_B407f259b4e34c7db9a06e8907a56b17_Fragment | ItemFields_HomePage_Cde13c51062d426b95569e8202edc963_Fragment | ItemFields_HomePage_De9353283a3e41c495ba386aed0540c6_Fragment | ItemFields_IFrame_Fragment | ItemFields_IFrameFolder_Fragment | ItemFields_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2_Fragment | ItemFields_IFrameParametersTemplate_Fragment | ItemFields_IFrame_0da12d476de24dfeb4d0f513489bfea1_Fragment | ItemFields_IFrame_88a6f65f2b78491bb3770b06e48883e1_Fragment | ItemFields_Icon_Fragment | ItemFields_IconFolder_Fragment | ItemFields_Image_Fragment | ItemFields_ImageFolder_Fragment | ItemFields_ImageFolder_Edc00e86cef24d0cbfa264460becc323_Fragment | ItemFields_ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993_Fragment | ItemFields_ImageParametersTemplate_Fragment | ItemFields_Image_83bc563c6320490092f8204bff81586a_Fragment | ItemFields_Image_15185b0e641844499f934ff03b7ee032_Fragment | ItemFields_Image_D885df8cb2d64007b34b2bbafb527304_Fragment | ItemFields_Infographics_Fragment | ItemFields_InfographicsFolder_Fragment | ItemFields_InputValidationStep_Fragment | ItemFields_InputValidationStep_088928cf558e40ec87f3342aa9e66757_Fragment | ItemFields_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593_Fragment | ItemFields_InputValidationStep_D028fef2babf4ad1bbe74d62a977992f_Fragment | ItemFields_IntegerFacet_Fragment | ItemFields_IntroCopy_Fragment | ItemFields_IntroCopyFolder_Fragment | ItemFields_InvestmentTrustAssetClass_Fragment | ItemFields_InvestmentTrustAssetClassFolder_Fragment | ItemFields_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73_Fragment | ItemFields_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb_Fragment | ItemFields_InvestmentTrustRegion_Fragment | ItemFields_InvestmentTrustRegionFolder_Fragment | ItemFields_InvestmentTrustStyle_Fragment | ItemFields_InvestmentTrustStyleFolder_Fragment | ItemFields_InvestorType_Fragment | ItemFields_InvestorTypesFolder_Fragment | ItemFields_ItemQueriesFolder_Fragment | ItemFields_ItemRights_Fragment | ItemFields_JsBeaconSettings_Fragment | ItemFields_JsonCheckbox_Fragment | ItemFields_JsonContent_Fragment | ItemFields_JsonDate_Fragment | ItemFields_JsonFile_Fragment | ItemFields_JsonImage_Fragment | ItemFields_JsonLayout_Fragment | ItemFields_JsonList_Fragment | ItemFields_JsonMultilistReference_Fragment | ItemFields_JsonPlaceholder_Fragment | ItemFields_JsonQuery_Fragment | ItemFields_JsonResults_Fragment | ItemFields_JsonRichText_Fragment | ItemFields_JsonScriban_Fragment | ItemFields_JsonSection_Fragment | ItemFields_JsonTemplate_Fragment | ItemFields_JsonText_Fragment | ItemFields_JsonToken_Fragment | ItemFields_JsonVariantDefinition_Fragment | ItemFields_JsonVariants_Fragment | ItemFields_JssLayout_Fragment | ItemFields_JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0_Fragment | ItemFields_JssSettings_6b328292f8314ab79885d89a054ca10a_Fragment | ItemFields_JssSettings_457c9d0b61b84adfaf7f82561ed275ff_Fragment | ItemFields_JssSettings_5045bf85d2ea430b9f41c2e348436e5d_Fragment | ItemFields_JssSettings_A767f80d5ad44bfbb8b750a8da144cb5_Fragment | ItemFields_JssSettings_B001fd725bb1476496825a8cb9e995cd_Fragment | ItemFields_JssSettings_C643bc8630d14d61a173c7870f5dbbad_Fragment | ItemFields_JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2_Fragment | ItemFields_JssSettings_Ef855d0ba8b04a8e87851d1298266d90_Fragment | ItemFields_JssSiteGrouping_Fragment | ItemFields_JssTenantFolder_Fragment | ItemFields_JavaScriptRendering_Fragment | ItemFields_JsonRendering_Fragment | ItemFields_JurisdictionStatus_Fragment | ItemFields_JurisdictionsFolder_Fragment | ItemFields_KeyHighlightItem_Fragment | ItemFields_KeyHighlights_Fragment | ItemFields_KeyHighlightsFolder_Fragment | ItemFields_KeyHighlightsParametersTemplate_Fragment | ItemFields_Language_Fragment | ItemFields_LanguageSelector_Fragment | ItemFields_LanguagesFolder_Fragment | ItemFields_LatestPressReleasesParametersTemplate_Fragment | ItemFields_LayoutServiceVariants_Fragment | ItemFields_LimitedDisplayFolder_Fragment | ItemFields_LimitedDisplayOption_Fragment | ItemFields_Link_Fragment | ItemFields_LinkList_Fragment | ItemFields_LinkListFolder_Fragment | ItemFields_LinkListFolder_C237d144647a4afeaa7b1570f3e3f139_Fragment | ItemFields_LinkList_33c9207e3b0446068ef54ca99a97c776_Fragment | ItemFields_LinkList_97a593ad273141dc80bfceb5ef6a33b7_Fragment | ItemFields_LinkList_F7561ffcc0d8477fb53d2703a4060be1_Fragment | ItemFields_Link_68bd1cb5a7624a969ac6cb16ab5882a3_Fragment | ItemFields_Link_930f134d56784b35bfd1b77f9d0115f1_Fragment | ItemFields_Link_E24e0789a05848bfabb6c69c0e60b6b7_Fragment | ItemFields_LinksFolder_Fragment | ItemFields_List_Fragment | ItemFields_ListFacet_Fragment | ItemFields_ListFolder_Fragment | ItemFields_ListItem_Fragment | ItemFields_ListParametersTemplate_Fragment | ItemFields_ListStyle_Fragment | ItemFields_ListStyleItem_Fragment | ItemFields_ListingHeroBanner_Fragment | ItemFields_ListingHeroParametersTemplate_Fragment | ItemFields_LiteratureAuthorization_Fragment | ItemFields_LiteratureAuthorizationsFolder_Fragment | ItemFields_LiteratureHubSearchPage_Fragment | ItemFields_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d_Fragment | ItemFields_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e_Fragment | ItemFields_LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea_Fragment | ItemFields_LoadMore_Fragment | ItemFields_LoadMoreFolder_Fragment | ItemFields_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6_Fragment | ItemFields_LocationFilter_Fragment | ItemFields_LocationFilterFolder_Fragment | ItemFields_LocationFilter_Aaad4aad290744dc90b69e4e83a661ec_Fragment | ItemFields_Log_Fragment | ItemFields_Login_Fragment | ItemFields_Login_Abed54dc4f7840ddac562289c9c849d8_Fragment | ItemFields_LogoTextBlockItem_Fragment | ItemFields_LogoTextBlocks_Fragment | ItemFields_LogoTextBlocksFolder_Fragment | ItemFields_Logout_Fragment | ItemFields_Logout_C2294d8235a6452a94b15eb5e543b602_Fragment | ItemFields_ManagedRangeFilter_Fragment | ItemFields_ManagedRangeFilterFolder_Fragment | ItemFields_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91_Fragment | ItemFields_ManagedRangeItem_Fragment | ItemFields_Map_Fragment | ItemFields_MapParameters_Fragment | ItemFields_MapsFolder_Fragment | ItemFields_MapsProvider_Fragment | ItemFields_MediaBlock_Fragment | ItemFields_MediaBlockFolder_Fragment | ItemFields_MediaBlockParametersTemplate_Fragment | ItemFields_MediaFolder_81150e5837f5443fa3c075e14a9321e7_Fragment | ItemFields_MediaLinkParameters_Fragment | ItemFields_MediaVirtualFolder_Fragment | ItemFields_MegaNavigation_Fragment | ItemFields_MegaNavigationFolder_Fragment | ItemFields_MetaBranding_Fragment | ItemFields_MetaRenderingParameters_Fragment | ItemFields_MetadataPartialDesign_Fragment | ItemFields_Model_Fragment | ItemFields_ModelIterator_Fragment | ItemFields_MyLocationPoi_Fragment | ItemFields_Navigation_Fragment | ItemFields_NavigationCategory_Fragment | ItemFields_NavigationFilter_Fragment | ItemFields_NavigationFilterFolder_Fragment | ItemFields_NavigationLink_Fragment | ItemFields_NavigationSubcategory_Fragment | ItemFields_Navigation_9ce34bf95c934dff841d8f649c2bd6c8_Fragment | ItemFields_OneTrustSettings_Fragment | ItemFields_OptimiserConfiguration_Fragment | ItemFields_OptimiserConfigurationSection_Fragment | ItemFields_OptimizedFile_Fragment | ItemFields_OracleCdpSettings_Fragment | ItemFields_OverlayContent_Fragment | ItemFields_OverlayFolderTemplate_Fragment | ItemFields_Ownership_Fragment | ItemFields_OwnershipFolder_Fragment | ItemFields_Poi_Fragment | ItemFields_PoiFolder_Fragment | ItemFields_PoiType_Fragment | ItemFields_PoIs_Fragment | ItemFields_PageBranchesFolder_Fragment | ItemFields_PageContent_Fragment | ItemFields_PageContentFolder_Fragment | ItemFields_PageContent_Ef87e73bc7ff49a2ac599b0be83755c3_Fragment | ItemFields_PageDesign_Fragment | ItemFields_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0_Fragment | ItemFields_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47_Fragment | ItemFields_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8_Fragment | ItemFields_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b_Fragment | ItemFields_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662_Fragment | ItemFields_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc_Fragment | ItemFields_PageDesignFolder_14161ec204984aa7a2a46decadf669f5_Fragment | ItemFields_PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb_Fragment | ItemFields_PageDesignFolder_D84605f786ea482da6ff683f6572821c_Fragment | ItemFields_PageDesign_1105b8f81e00426bbf1fc840742d827b_Fragment | ItemFields_PageDesigns_Fragment | ItemFields_PageDesigns_3af52e70e982424b9c85e355542500c9_Fragment | ItemFields_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d_Fragment | ItemFields_PageDesigns_48d2d50a150c4f6283603a4fed5646e0_Fragment | ItemFields_PageDesigns_99a71bba507746729c3fb29b04abee23_Fragment | ItemFields_PageDesigns_A0f265b42d6241968b65d3ede7cb59c3_Fragment | ItemFields_PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11_Fragment | ItemFields_PageDesigns_B8d9b352c1694b31bd506848b47ca884_Fragment | ItemFields_PageDesigns_D3b2e1466f744df0900bec314f699ef3_Fragment | ItemFields_PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe_Fragment | ItemFields_PageLevelTabs_Fragment | ItemFields_PageLevelTabsFolder_Fragment | ItemFields_PageList_Fragment | ItemFields_PageSelector_Fragment | ItemFields_PageSelectorConfiguration_Fragment | ItemFields_PageSelectorFolder_Fragment | ItemFields_PageSelector_59a7bb775f8c435ab810291abde80e63_Fragment | ItemFields_PageSize_Fragment | ItemFields_PageSizeFolder_Fragment | ItemFields_PageSize_B682562e0af64b3e9e3b45273bbe152d_Fragment | ItemFields_PageTheme_Fragment | ItemFields_PageThemesFolder_Fragment | ItemFields_Page_4f49a81db3664f198b89cab92f377d7a_Fragment | ItemFields_Page_5e66d86353544fe6a27d3b894984d50f_Fragment | ItemFields_Page_84f342ad2d0646b9aa9a818201145ca2_Fragment | ItemFields_Page_718df200be51463d93edf4d77ab7a49e_Fragment | ItemFields_Page_B61d5babe46f4ef39f27b57c4ccefdf7_Fragment | ItemFields_Page_Cfd6e04697e24f3cb9eb41b79afc35dc_Fragment | ItemFields_Page_Dae7821153e14dbabb0ddf0b53a90aaf_Fragment | ItemFields_Page_Fa608b3e6aeb426388a059d89caabada_Fragment | ItemFields_Pagging_Fragment | ItemFields_Pagination_Fragment | ItemFields_PaginationFolder_Fragment | ItemFields_Paragraph_Fragment | ItemFields_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d_Fragment | ItemFields_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b_Fragment | ItemFields_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8_Fragment | ItemFields_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b_Fragment | ItemFields_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112_Fragment | ItemFields_PartialDesignFolder_89098e3089aa4062a77346d608caac90_Fragment | ItemFields_PartialDesignFolder_1695576fb93647d7842ed17730278c32_Fragment | ItemFields_PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc_Fragment | ItemFields_PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a_Fragment | ItemFields_PartialDesign_Fd2059fd60434dfe8c04e2437ce87634_Fragment | ItemFields_PartialDesigns_Fragment | ItemFields_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec_Fragment | ItemFields_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4_Fragment | ItemFields_PartialDesigns_36c869ded22040929ce829f6ed643c66_Fragment | ItemFields_PartialDesigns_1943dc73710a430895515a342c84b037_Fragment | ItemFields_PartialDesigns_B1e2a6790a1442d8bafa66317b8be117_Fragment | ItemFields_PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e_Fragment | ItemFields_PartialDesigns_D52704ed3b704a53abb4292105f687ad_Fragment | ItemFields_PartialDesigns_D216303f58d8425688da8cd30d00afab_Fragment | ItemFields_PartialDesigns_Facda26791204fa9a0363344348f2c42_Fragment | ItemFields_PerformanceChartSettings_Fragment | ItemFields_PerformanceChartTimePeriod_Fragment | ItemFields_PerformanceChartTimePeriodFolder_Fragment | ItemFields_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80_Fragment | ItemFields_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d_Fragment | ItemFields_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba_Fragment | ItemFields_Placeholder_1ca0304be5b64810821154426f1752c2_Fragment | ItemFields_Placeholder_D2a6884c04d54089a64ed27ca9d68d4c_Fragment | ItemFields_PlainHtmlParametersTemplate_Fragment | ItemFields_Playlist_Fragment | ItemFields_PlaylistFolder_Fragment | ItemFields_PlaylistParametersTemplate_Fragment | ItemFields_Podcast_Fragment | ItemFields_PodcastFolder_Fragment | ItemFields_PodcastPage_Fragment | ItemFields_PodcastPressReleasePage_Fragment | ItemFields_PoiTypes_Fragment | ItemFields_PostDeleteStep_Fragment | ItemFields_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574_Fragment | ItemFields_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a_Fragment | ItemFields_PostDeleteStep_B20857895385413883f096f3767cb156_Fragment | ItemFields_PostSetupStep_Fragment | ItemFields_PostSetupStep_6fac654e22154a419a1d59197bebc0fe_Fragment | ItemFields_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f_Fragment | ItemFields_PostSetupStep_341738aa44fe490e90ff7010a3c2463b_Fragment | ItemFields_PreDeleteStep_Fragment | ItemFields_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49_Fragment | ItemFields_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b_Fragment | ItemFields_PreDeleteStep_F0daf401190f45468bda8568d08e161d_Fragment | ItemFields_PreDeleteValidationStep_Fragment | ItemFields_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f_Fragment | ItemFields_PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f_Fragment | ItemFields_PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e_Fragment | ItemFields_Presentation_Fragment | ItemFields_Presentation_0a70fa7389234a6eabf34134f25f3221_Fragment | ItemFields_PressReleaseContentType_Fragment | ItemFields_PressReleaseContentTypesFolder_Fragment | ItemFields_PressReleaseFilter_Fragment | ItemFields_PressReleasePage_Fragment | ItemFields_PressReleasePlatform_Fragment | ItemFields_PressReleasePlatformsFolder_Fragment | ItemFields_PressReleaseSearchPage_Fragment | ItemFields_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f_Fragment | ItemFields_PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72_Fragment | ItemFields_PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d_Fragment | ItemFields_PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58_Fragment | ItemFields_PressReleaseWildcardPage_Fragment | ItemFields_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e_Fragment | ItemFields_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79_Fragment | ItemFields_PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1_Fragment | ItemFields_PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258_Fragment | ItemFields_PressReleasesGroupFolder_Fragment | ItemFields_PrivacyWarning_Fragment | ItemFields_ProjectFolder_Fragment | ItemFields_Promo_Fragment | ItemFields_PromoFolder_Fragment | ItemFields_PromoFolder_F07cbe8973ae4de692172570260cac6e_Fragment | ItemFields_Promo_7f21f14d096b4f27bbccf115c6e6f6f1_Fragment | ItemFields_Promo_881869ca7f5845ea8b34ad1bfd3551a8_Fragment | ItemFields_Promo_Dfed4457d760457abec1c0dccdc44381_Fragment | ItemFields_PromotedContent_Fragment | ItemFields_PromotedContentFolder_Fragment | ItemFields_PropertyListingCard_Fragment | ItemFields_PropertyListingCards_Fragment | ItemFields_PropertyListingCategory_Fragment | ItemFields_PropertyListingFolder_Fragment | ItemFields_Query_98b413525a4b4067b92418a4b50f0a53_Fragment | ItemFields_QuickLinks_Fragment | ItemFields_QuickLinksFolder_Fragment | ItemFields_QuickLinksParametersTemplate_Fragment | ItemFields_QuotationBlockItem_Fragment | ItemFields_QuotationBlocks_Fragment | ItemFields_QuotationBlocksFolder_Fragment | ItemFields_QuotationBlocksParametersTemplate_Fragment | ItemFields_Quote_Fragment | ItemFields_QuoteFolder_Fragment | ItemFields_QuoteParametersTemplate_Fragment | ItemFields_RadiusFilter_Fragment | ItemFields_RadiusFilterFolder_Fragment | ItemFields_RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64_Fragment | ItemFields_RadiusScheme_Fragment | ItemFields_RadiusSchemeValue_Fragment | ItemFields_RangeSliderFilter_Fragment | ItemFields_RangeSliderFilterFolder_Fragment | ItemFields_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03_Fragment | ItemFields_RecentArticles_Fragment | ItemFields_Redirect_Fragment | ItemFields_RedirectMap_Fragment | ItemFields_RedirectMaps_Fragment | ItemFields_Region_Fragment | ItemFields_RegionLanguages_Fragment | ItemFields_RegionLanguagesFolder_Fragment | ItemFields_RelatedArticles_Fragment | ItemFields_RelatedArticlesParametersTemplate_Fragment | ItemFields_RenderEngineType_Fragment | ItemFields_RenderingFolder_840d4a46550349ecbf9dbd090946c63d_Fragment | ItemFields_RenderingHost_Fragment | ItemFields_ResizableIFramePage_Fragment | ItemFields_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067_Fragment | ItemFields_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68_Fragment | ItemFields_ResizableIFramePage_B58eacfb27f5417bb536141f94b92521_Fragment | ItemFields_ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401_Fragment | ItemFields_ResizableIFramePage_F460ab055585441892023750e7cef6b7_Fragment | ItemFields_ResponsiveImage_Fragment | ItemFields_ResultsCount_Fragment | ItemFields_ResultsCountFolder_Fragment | ItemFields_ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186_Fragment | ItemFields_ResultsVariantSelector_Fragment | ItemFields_RichText_Fragment | ItemFields_RichTextFolder_Fragment | ItemFields_RichText_0f3b73366112418c8bbab0526f3887ce_Fragment | ItemFields_RichText_Efcfd8f6596745f48f85b5421928205d_Fragment | ItemFields_RiskImageMapping_Fragment | ItemFields_RiskImageMappings_Fragment | ItemFields_RiskLevelOption_Fragment | ItemFields_RiskLevelOptionFolder_Fragment | ItemFields_RiskWarning_Fragment | ItemFields_RiskWarningFolder_Fragment | ItemFields_RiskWarningParametersTemplate_Fragment | ItemFields_RolePlaceholder_Fragment | ItemFields_RowSplitter_Fragment | ItemFields_RowSplitter_340c887da1d1415b9678c763af74ea97_Fragment | ItemFields_Rule_Fragment | ItemFields_SdrLogoMapping_Fragment | ItemFields_SdrLogoMappings_Fragment | ItemFields_SdrTypeOption_Fragment | ItemFields_SdrTypeOptionFolder_Fragment | ItemFields_SxajssLayout_Fragment | ItemFields_SxaRole_Fragment | ItemFields_SxaStandardValuesFolder_Fragment | ItemFields_SalesforceAlertMessage_Fragment | ItemFields_SalesforceCheckBox_Fragment | ItemFields_SalesforceCheckBoxType_Fragment | ItemFields_SalesforceConditionalRadioButton_Fragment | ItemFields_SalesforceConditionalRadioButtons_Fragment | ItemFields_SalesforceDateInput_Fragment | ItemFields_SalesforceDropdown_Fragment | ItemFields_SalesforceDropdownOption_Fragment | ItemFields_SalesforceHiddenField_Fragment | ItemFields_SalesforceInput_Fragment | ItemFields_SalesforceInputType_Fragment | ItemFields_SalesforceIntegratedForm_Fragment | ItemFields_SalesforceIntegratedFormTypesFolder_Fragment | ItemFields_SalesforceRepeatableSubSection_Fragment | ItemFields_SalesforceRichTextArea_Fragment | ItemFields_SalesforceSection_Fragment | ItemFields_SalesforceSortCodeInput_Fragment | ItemFields_SalesforceSubmissionType_Fragment | ItemFields_Scope_Fragment | ItemFields_ScopesFolder_Fragment | ItemFields_Scriban_Fragment | ItemFields_Scripts_Fragment | ItemFields_SearchBox_Fragment | ItemFields_SearchBoxFolder_Fragment | ItemFields_SearchBox_1c04fd611d874590acfe9cc186865ab3_Fragment | ItemFields_SearchFolder_Fragment | ItemFields_SearchResults_Fragment | ItemFields_SearchResultsFolder_Fragment | ItemFields_SearchResults_A06f7130041d46bb8c2995a2dc00c26a_Fragment | ItemFields_SecondaryHeroBannerParametersTemplate_Fragment | ItemFields_SectionHeading_Fragment | ItemFields_SectionHeadingFolder_Fragment | ItemFields_SectionHeadingParametersTemplate_Fragment | ItemFields_SectionHeadingType_Fragment | ItemFields_SectionHeadingTypeFolder_Fragment | ItemFields_SectionSelector_Fragment | ItemFields_SectionSelectorFolder_Fragment | ItemFields_SectionSelectorTab_Fragment | ItemFields_Security_33077d51ebad4d1cb4a83b79f51dba13_Fragment | ItemFields_Series_Fragment | ItemFields_SeriesFolder_Fragment | ItemFields_Settings_Fragment | ItemFields_SettingsFolder_Fragment | ItemFields_Settings_6c82caca67dc464195698faad083230e_Fragment | ItemFields_SharePriceSettings_Fragment | ItemFields_SharedArticlesFolder_Fragment | ItemFields_SharedContentFolder_Fragment | ItemFields_SharedFolder_Fragment | ItemFields_SharedHelpArticlesFolder_Fragment | ItemFields_SharedPressReleasesFolder_Fragment | ItemFields_SharedSettingsFolder_Fragment | ItemFields_SharedSitesSettings_Fragment | ItemFields_SharedSitesSettings_C14bf746030f4e598594395f6d299e61_Fragment | ItemFields_Showcase_Fragment | ItemFields_ShowcaseFolder_Fragment | ItemFields_ShowcaseItem_Fragment | ItemFields_ShowcaseParametersTemplate_Fragment | ItemFields_Site_Fragment | ItemFields_SiteContentFolder_Fragment | ItemFields_SiteDefinition_Fragment | ItemFields_SiteEntryDisclaimer_Fragment | ItemFields_SiteFolder_Fragment | ItemFields_SiteGrouping_Fragment | ItemFields_SiteManagement_Fragment | ItemFields_SiteSecurityItemPointer_Fragment | ItemFields_SiteSelector_Fragment | ItemFields_SiteSelector_A44632f56dcd4d10b4892f4e35e193c3_Fragment | ItemFields_SiteSetupRoot_Fragment | ItemFields_SiteTheme_Fragment | ItemFields_Site_E46f3af239fa4866a1577017c4b2a40c_Fragment | ItemFields_SitecoreFormWrapperParametersTemplate_Fragment | ItemFields_SitecoreRole_Fragment | ItemFields_SitemapSettings_C71d856635c849b7a84d9d176e9cbd05_Fragment | ItemFields_SkipLink_Fragment | ItemFields_SkipLinkParameters_Fragment | ItemFields_SkipLinksFolder_Fragment | ItemFields_Snippet_Fragment | ItemFields_SnippetItem_Fragment | ItemFields_SnippetsFolder_Fragment | ItemFields_SocialLoginWrapper_Fragment | ItemFields_SocialMediaButtons_Fragment | ItemFields_SocialMediaFolder_Fragment | ItemFields_SocialMediaShare_Fragment | ItemFields_SocialMediaTemplate_Fragment | ItemFields_SocialNetwork_Fragment | ItemFields_SocialNetworkFolder_Fragment | ItemFields_SocialNetworkLink_Fragment | ItemFields_SolutionTemplate_Fragment | ItemFields_SortResults_Fragment | ItemFields_SortResultsFolder_Fragment | ItemFields_Sorting_Fragment | ItemFields_SortingGroups_Fragment | ItemFields_SpotifyPodcast_Fragment | ItemFields_SpotifyPodcastFolder_Fragment | ItemFields_StickyCta_Fragment | ItemFields_StickyCtaFolder_Fragment | ItemFields_StickyCtaParametersTemplate_Fragment | ItemFields_StrategiesInFocusFolder_Fragment | ItemFields_StrategyInFocus_Fragment | ItemFields_Style_Fragment | ItemFields_Styles_Fragment | ItemFields_Styles_9c0dac2808aa4b44bc2153363206f6a5_Fragment | ItemFields_SubscriptionBannerParametersTemplate_Fragment | ItemFields_Tab_Fragment | ItemFields_TabItem_Fragment | ItemFields_TableOfContents_Fragment | ItemFields_TableOfContentsFolder_Fragment | ItemFields_TableOfContentsSection_Fragment | ItemFields_TableOfContentsSubsection_Fragment | ItemFields_Tabs_Fragment | ItemFields_TabsFolder_Fragment | ItemFields_Tabs_F26a9560ccf148c59542800e837caf7a_Fragment | ItemFields_Tag_Fragment | ItemFields_TagCloud_Fragment | ItemFields_TagFolder_Fragment | ItemFields_TagList_Fragment | ItemFields_TeamBiographySettings_Fragment | ItemFields_TeamListingCards_Fragment | ItemFields_TeamListingCardsFolder_Fragment | ItemFields_TeamMember_Fragment | ItemFields_TeamMemberCard_Fragment | ItemFields_TeamMembers_Fragment | ItemFields_TeamMembersParentPage_Fragment | ItemFields_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e_Fragment | ItemFields_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e_Fragment | ItemFields_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff_Fragment | ItemFields_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089_Fragment | ItemFields_TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0_Fragment | ItemFields_TeamMembersWildcardPage_Fragment | ItemFields_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e_Fragment | ItemFields_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450_Fragment | ItemFields_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a_Fragment | ItemFields_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29_Fragment | ItemFields_TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745_Fragment | ItemFields_TeamProfileCards_Fragment | ItemFields_TeamProfileCardsFolder_Fragment | ItemFields_TechzoneArticlePage_Fragment | ItemFields_Tenant_Fragment | ItemFields_TenantFolder_Fragment | ItemFields_TenantSecurityItemPointer_Fragment | ItemFields_TenantSetupRoot_Fragment | ItemFields_TertieryHeroBanner_Fragment | ItemFields_TertieryHeroBannerParametersTemplate_Fragment | ItemFields_Text_Fragment | ItemFields_TextBlock_Fragment | ItemFields_TextBlockHeadingParametersTemplate_Fragment | ItemFields_TextBlockHeadingType_Fragment | ItemFields_TextBlockHeadingTypeFolder_Fragment | ItemFields_TextBlockLinkType_Fragment | ItemFields_TextBlockLinkTypeFolder_Fragment | ItemFields_TextBlocks_Fragment | ItemFields_TextBlocksFolder_Fragment | ItemFields_TextBlocksParametersTemplate_Fragment | ItemFields_TextFolder_Fragment | ItemFields_TextFolder_B762d56787f5493cbb480c455d834457_Fragment | ItemFields_Text_B8f5894cb4934016bf784090b0a2fd16_Fragment | ItemFields_Theme_Fragment | ItemFields_ThemeTag_Fragment | ItemFields_ThemeTagsFolder_Fragment | ItemFields_ThemingMode_Fragment | ItemFields_ThemingModes_Fragment | ItemFields_Tile_Fragment | ItemFields_TileLink_Fragment | ItemFields_TileParametersTemplate_Fragment | ItemFields_TileSizeOption_Fragment | ItemFields_TileSizeOptionFolder_Fragment | ItemFields_TilesFolder_Fragment | ItemFields_TilesParametersTemplate_Fragment | ItemFields_Title_Fragment | ItemFields_Title_A82e893105754175917de904ef7e6dbe_Fragment | ItemFields_Toggle_Fragment | ItemFields_ToggleFolder_Fragment | ItemFields_Toggle_8e4c968e9fa543a89ac4c0baf273ccde_Fragment | ItemFields_Transformation_Fragment | ItemFields_TrustArticleHeroParametersTemplate_Fragment | ItemFields_TrustFinder_Fragment | ItemFields_TrustFinderFilterOption_Fragment | ItemFields_TrustRegion_Fragment | ItemFields_TrustType_Fragment | ItemFields_TrustTypesFolder_Fragment | ItemFields_Twitter_Fragment | ItemFields_TwitterApp_Fragment | ItemFields_TwitterApps_Fragment | ItemFields_TwitterFolder_Fragment | ItemFields_TwitterParametersTemplate_Fragment | ItemFields_TwitterSettings_Fragment | ItemFields_UnknownItem_Fragment | ItemFields_UnminifiedFile_Fragment | ItemFields_UpgradeScript_Fragment | ItemFields_UpgradeScriptLibrary_Fragment | ItemFields_VariantComponentField_Fragment | ItemFields_VariantDateField_Fragment | ItemFields_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55_Fragment | ItemFields_VariantPlaceholder_Fragment | ItemFields_VariantReference_Fragment | ItemFields_VariantSection_Fragment | ItemFields_VariantTemplate_Fragment | ItemFields_VariantText_Fragment | ItemFields_VariantToken_Fragment | ItemFields_Variants_Fragment | ItemFields_VectorFolder_Fragment | ItemFields_VectorTile_Fragment | ItemFields_VectorTileLink_Fragment | ItemFields_VectorTilesFolder_Fragment | ItemFields_VectorTilesParametersTemplate_Fragment | ItemFields_Version_95ebc23204774dc38ad3465d5fe8da2f_Fragment | ItemFields_Video_Fragment | ItemFields_VideoCountOption_Fragment | ItemFields_VideoCountOptions_Fragment | ItemFields_VideoFolder_Fragment | ItemFields_VideoFolder_Bba49474673e468186ba8b1a20e067a9_Fragment | ItemFields_VideoPage_Fragment | ItemFields_VideoParameters_Fragment | ItemFields_VideoParametersTemplate_Fragment | ItemFields_VideoPressReleasePage_Fragment | ItemFields_Video_4bc649610a894242be2dc5026090cf49_Fragment | ItemFields__AssetsOptimization_Fragment | ItemFields__BackgroundImage_Fragment | ItemFields__CompatibleThemes_Fragment | ItemFields__CompositeTheme_Fragment | ItemFields__CustomMetadata_Fragment | ItemFields__CustomRenderingViewPath_Fragment | ItemFields__DatasourceBehaviour_Fragment | ItemFields__Favicon_Fragment | ItemFields__FormsFolderLocation_Fragment | ItemFields__FundSettings_Fragment | ItemFields__HasValidUrlName_Fragment | ItemFields__LocalDataLink_Fragment | ItemFields__Login_Fragment | ItemFields__OpenGraphMetadata_Fragment | ItemFields__PageDesignTheme_Fragment | ItemFields__PageSearchScope_Fragment | ItemFields__SearchCriteria_Fragment | ItemFields__SearchableWithoutRelatedItems_Fragment | ItemFields__SeoMetadata_Fragment | ItemFields__SiteTheme_Fragment | ItemFields__SitemapSettings_Fragment | ItemFields__StickyNote_Fragment | ItemFields__Styleable_Fragment | ItemFields__TwitterMetadata_Fragment | ItemFields__Webinar_Fragment | ItemFields__WildcardSource_Fragment;

export type InternalArticleFieldsFragment = (
  { __typename?: 'ArticlePage' | 'C___Article' | 'C___InternalArticle' | 'C___Podcast' | 'C___Video' | 'PodcastPage' | 'VideoPage' | '_Webinar' }
  & { articleTags: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTags_MultilistField> }
);

export type ArticleFieldsFragment = (
  { __typename?: 'ArticlePage' | 'C___Article' }
  & { duration: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_duration_IntegerField> }
);

export type VideoFieldsFragment = (
  { __typename?: 'C___Video' | 'VideoPage' }
  & { duration: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Video_duration_IntegerField> }
);

export type PodcastFieldsFragment = (
  { __typename?: 'C___Podcast' | 'PodcastPage' }
  & { duration: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___Podcast_duration_IntegerField> }
);

export type BaseFieldsFragment = (
  { __typename?: 'ArticlePage' | 'C___Article' | 'C___BaseArticle' | 'C___ExternalArticle' | 'C___InternalArticle' | 'C___Podcast' | 'C___TechzoneArticle' | 'C___Video' | 'PodcastPage' | 'TechzoneArticlePage' | 'VideoPage' | '_Webinar' }
  & { articleStrapline: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articleCategory: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField> }
);

export type ExternalArticleFragment = (
  { __typename?: 'C___ExternalArticle' | 'C___TechzoneArticle' | 'TechzoneArticlePage' }
  & { articleUrl: Types.Maybe<ArticleSearchRelatedByDatasourceQuery_search_ItemSearchResults_results_C___ExternalArticle_articleUrl_LinkField> }
);

export const ItemFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ItemFieldsFragment, unknown>;
export const InternalArticleFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalArticleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_InternalArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_7628b9a247404a51bb9d7c828ae944e6"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<InternalArticleFieldsFragment, unknown>;
export const ArticleFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ArticleFieldsFragment, unknown>;
export const VideoFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<VideoFieldsFragment, unknown>;
export const PodcastFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<PodcastFieldsFragment, unknown>;
export const BaseFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BaseArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleStrapline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_1e4c2734dc754d528af8084e6c400e1f"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articlePublicationDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedDateValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"yyyy-MM-ddTHH:mm:ssZ","block":false}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"articleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}}]} as unknown as DocumentNode<BaseFieldsFragment, unknown>;
export const ExternalArticleFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalArticle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ExternalArticleFragment, unknown>;
export const ArticleSearchRelatedByDatasourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleSearchRelatedByDatasource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"predicates"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ItemSearchPredicateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"predicates"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"articlePublicationDate","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNext"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BaseArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ItemFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalArticleFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PodcastFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleFields"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ExternalArticle"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"baseTemplates"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BaseArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleStrapline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_1e4c2734dc754d528af8084e6c400e1f"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articlePublicationDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formattedDateValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"yyyy-MM-ddTHH:mm:ssZ","block":false}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"articleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalArticleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_InternalArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleTags"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleTag"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"name"},"name":{"kind":"Name","value":"name_7628b9a247404a51bb9d7c828ae944e6"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ExternalArticle"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_ExternalArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleUrl"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<ArticleSearchRelatedByDatasourceQuery, ArticleSearchRelatedByDatasourceQueryVariables>;